import { Injectable } from '@angular/core';
import { AdvancedConditions, CosmeticOptions, CosmeticPresets, createDefaultChanceBaseTierCosmetics, createDefaultEquipmentTierCosmetics, createDefaultRestrictedUniquesTier, createDefaultUniqueTierCosmetics, CustomRule, CustomRuleGroup, GearHighlightConfig, Filter, ItemHighlight, TierCosmetic, ItemTypeOverride, JewelFilter, JewelleryFilter, FlaskFilter, JewelleryHighlightConfig, ArmourFilter, WeaponFilter, IdentifiedItemConfig, createDefaultIdentifiedItemConfigs, createDefaultCustomTierValueList, createDefaultCustomUniquesTierValueList, createDefaultCustomClusterJewelTierValueList, createDefaultCustomRuleStyles, FilterSource, MigrationHistoryEntry, FavouriteCurrencyMode } from '../models/filter-models';
import { AbyssJewelsCategory, AttackWeaponsCategory, CasterWeaponsCategory, DefenceType, EldritchItemType, EnergyShieldArmourCategory, GemWeaponsCategory, JewelleryCategory, JewelleryType, JewelsCategory, JewelType, LifeArmourCategory, QuiversCategory, TimeLostJewelsCategory, VendoringGearType } from "../models/enums";
import { RuneType, SkillGemFilterType, WaystoneFilterType } from "../models/enums";
import { DisplayType, EquipmentTierType } from "../models/enums";
import { Color, Comparator, LabelSize, MinimapIconShape, MinimapIconSize, Rarity } from "../models/enums";
import { ArmourType, BaseTypeTier, GearBaseTypeMode, GearSizeType, SocketedItemType, WeaponType } from "../models/enums";
import { ItemDataService } from './item-data.service';
import { ChanceBaseTierType, CustomTieredChanceBase, CustomTieredEquipment, CustomTieredGear, CustomTieredJewellery, CustomTieredItem, CustomTieredUnique, FlatItemData, GearTierType, ItemData, TieredMod, Tier, UniqueTierType } from '../models/item-data-models';
import { baseTypeMigrationData, extraRenames } from '../data/poe2/base-type-migration-data';
import { regularRuneBaseTypeEntries } from '../data/poe2/item-data-manual';
import { LOCAL_STORAGE_KEY_CUSTOM_CHANCE_BASE_TIERS, LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS, LOCAL_STORAGE_KEY_CUSTOM_GEAR_TIERS, LOCAL_STORAGE_KEY_CUSTOM_UNIQUE_TIERS, LOCAL_STORAGE_KEY_TIERING_MODE } from '../const';
import { patchVersion as newPatchVersion } from '../../version';
import { logErrorWithDetails, logEvent, trackError } from '../app.config';
import { TieringMode } from "../models/enums";
import { poe1, poe2 } from '../../game';
import { Economy } from '../models/economy-models';
import { defaultFavouriteBasicCurrencyTypes as defaultFavouriteBasicCurrencyTypesPoE1 } from "../data/poe1/item-lists";
import { defaultFavouriteBasicCurrencyTypes as defaultFavouriteBasicCurrencyTypesPoE2 } from "../data/poe2/item-lists";
import { FilterIdService } from './filter-id.service';

@Injectable({
  providedIn: 'root'
})
export class FilterMigratorService {
  itemData!: ItemData[];

  constructor(private itemDataService: ItemDataService, private filterIdService: FilterIdService) {
    this.itemData = this.itemDataService.getItemData();
  }

  migrateFilter(filter: Filter, oldPatchVersion: number, source: FilterSource) {
    const beforeMigration = structuredClone(filter);
    const migrationHistoryEntry: MigrationHistoryEntry = {
      source: source,
      oldVersion: oldPatchVersion.toString(),
      newVersion: newPatchVersion.toString(),
      ts: new Date().toISOString(),
      success: true,
    };

    if (!filter.migrationHistory) filter.migrationHistory = [];
    filter.migrationHistory.push(migrationHistoryEntry);

    try {
      if (oldPatchVersion < 66) {
        this.migrateFilterBefore66(filter);
      }

      if (oldPatchVersion < 67) this.migrateTo67(filter);
      if (oldPatchVersion < 69) this.migrateTo69(filter);
      if (oldPatchVersion < 70) this.migrateTo70(filter);
      if (oldPatchVersion < 71) this.migrateTo71(filter);
      if (oldPatchVersion < 76) this.migrateTo76(filter);
      if (oldPatchVersion < 77) this.migrateTo77(filter);
      if (oldPatchVersion < 81) this.migrateTo81(filter);
      if (oldPatchVersion < 86) this.migrateTo86(filter);
      if (oldPatchVersion < 87) this.migrateTo87(filter);
      if (oldPatchVersion < 89) this.migrateTo89(filter);
      if (oldPatchVersion < 90) this.migrateTo90(filter);
      if (oldPatchVersion < 91) this.migrateTo91(filter);
      if (oldPatchVersion < 94) this.migrateTo94(filter);
      if (oldPatchVersion < 95) this.migrateTo95(filter);
      if (oldPatchVersion < 98) this.migrateTo98(filter);
      if (oldPatchVersion < 99) this.migrateTo99(filter);
      if (oldPatchVersion < 100) this.migrateTo100(filter);
      if (oldPatchVersion < 104) this.migrateTo104(filter);
      if (oldPatchVersion < 105) this.migrateTo105(filter);
      if (oldPatchVersion < 106) this.migrateTo106(filter);
      if (oldPatchVersion < 107) this.migrateTo107(filter);
      if (oldPatchVersion < 108) this.migrateTo108(filter);
      if (oldPatchVersion < 109) this.migrateTo109(filter);
      if (oldPatchVersion < 110) this.migrateTo110(filter);
      if (oldPatchVersion < 111) this.migrateTo111(filter);
      if (oldPatchVersion < 113) this.migrateTo113(filter);
      if (oldPatchVersion < 115) this.migrateTo115(filter); // PoE2 0.3.0 pre-release
      if (oldPatchVersion < 116) this.migrateTo116(filter);
      if (oldPatchVersion < 117) this.migrateTo117(filter);
      if (oldPatchVersion < 118) this.migrateTo118(filter);
      if (oldPatchVersion < 119) this.migrateTo119(filter);
      if (oldPatchVersion < 120) this.migrateTo120(filter);
      if (oldPatchVersion < 123) this.migrateTo123(filter);
      if (oldPatchVersion < 124) this.migrateTo124(filter);
      if (oldPatchVersion < 125) this.migrateTo125(filter);
      if (oldPatchVersion < 128) this.migrateTo128(filter);
      if (oldPatchVersion < 129) this.migrateTo129(filter);
      if (oldPatchVersion < 130) this.migrateTo130(filter);
      if (oldPatchVersion < 132) this.migrateTo132(filter);
      if (oldPatchVersion < 133) this.migrateTo133(filter);
      if (oldPatchVersion < 135) this.migrateTo135(filter);
      if (oldPatchVersion < 136) this.migrateTo136(filter);
      if (oldPatchVersion < 137) this.migrateTo137(filter);
      if (oldPatchVersion < 139) this.migrateTo139(filter);
      if (oldPatchVersion < 140) this.migrateTo140(filter);
      if (oldPatchVersion < 141) this.migrateTo141(filter);
      if (oldPatchVersion < 143) this.migrateTo143(filter);
      if (oldPatchVersion < 144) this.migrateTo144(filter);
      if (oldPatchVersion < 146) this.migrateTo146(filter); // PoE1 3.28 Mirage League
      if (oldPatchVersion < 147) this.migrateTo147(filter);
      if (oldPatchVersion < 148) this.migrateTo148(filter);
      if (oldPatchVersion < 149) this.migrateTo149(filter);
      if (oldPatchVersion < 150) this.migrateTo150(filter);
      if (oldPatchVersion < 151) this.migrateTo151(filter);
      if (oldPatchVersion < 152) this.migrateTo152(filter);
      if (oldPatchVersion < 153) this.migrateTo153(filter);
      if (oldPatchVersion < 154) this.migrateTo154(filter); // Large refactorings
      if (oldPatchVersion < 155) this.migrateTo155(filter);
      if (oldPatchVersion < 157) this.migrateTo157(filter);
      if (oldPatchVersion < 158) this.migrateTo158(filter); // PoE2 0.5.0 Return of the Ancients: Raven
      if (oldPatchVersion < 159) this.migrateTo159(filter);
      if (oldPatchVersion < 160) this.migrateTo160(filter);
      if (oldPatchVersion < 161) this.migrateTo161(filter);
      if (oldPatchVersion < 162) this.migrateTo162(filter);
      if (oldPatchVersion < 163) this.migrateTo163(filter);
      if (oldPatchVersion < 164) this.migrateTo164(filter);
      if (oldPatchVersion < 165) this.migrateTo165(filter);
      if (oldPatchVersion < 166) this.migrateTo166(filter);
      if (oldPatchVersion < 167) this.migrateTo167(filter);
      if (oldPatchVersion < 170) this.migrateTo170(filter);
      if (oldPatchVersion < 171) this.migrateTo171(filter);
      if (oldPatchVersion < 172) this.migrateTo172(filter);
      if (oldPatchVersion < 173) this.migrateTo173(filter);
      if (oldPatchVersion < 174) this.migrateTo174(filter);
      if (oldPatchVersion < 175) this.migrateTo175(filter);
      if (oldPatchVersion < 176) this.migrateTo176(filter);
      if (oldPatchVersion < 177) this.migrateTo177(filter);
      if (oldPatchVersion < 178) this.migrateTo178(filter);
      if (oldPatchVersion < 180) this.migrateTo180(filter);
      if (oldPatchVersion < 181) this.migrateTo181(filter);
      if (oldPatchVersion < 182) this.migrateTo182(filter);

      logEvent('filter_migration', 'success', `${oldPatchVersion} -> ${newPatchVersion}`);
      migrationHistoryEntry.success = true;
    } catch (error: any) {
      const shortError = error.toString().substring(0, 200);
      logErrorWithDetails('Error migrating filter: ' + shortError, {
        error: error,
        oldPatchVersion: oldPatchVersion.toString(),
        newPatchVersion: newPatchVersion.toString(),
        source: source,
        oldFilter: beforeMigration,
      });
      logEvent('filter_migration', 'error', `${oldPatchVersion} -> ${newPatchVersion}: ${error.toString()}`);
      trackError(error);
      migrationHistoryEntry.success = false;
      migrationHistoryEntry.errorMessage = shortError;

      throw error;
    }
  }

  migrateTo182(filter: Filter) {
    const existing = filter as any;

    filter.promoteForcedHiddenCurrency = false;
    filter.promoteForcedHiddenCurrencyOneTierStackSize = poe1 ? 10 : 5;
    filter.promoteForcedHiddenCurrencyTwoTiersStackSize = poe1 ? 20 : 10;
    filter.showLvl21Quality20Gems = true;
    filter.showLvl20Quality20Gems = true;
    delete existing.showOtherLevelGems;

    this.removeEquipmentTypes(filter, ['GemsOtherLevel']);
  }

  migrateTo181(filter: Filter) {
    filter.stackedGeneralCurrencyNeverPromote = ['None'];
  }

  migrateTo180(filter: Filter) {
    filter.divCardTieringMode = filter.tieringMode;
    filter.divCardTieringModeCustom = structuredClone(filter.tieringModeCustom);
  }

  migrateTo178(filter: Filter) {
    filter.showHighDustValueUniquesMinAverage = filter.progressPreset === 'presetStrict90' ? 25000 : 15000;
    filter.showHighDustValueUniquesMinDust = filter.progressPreset === 'presetStrict90' ? 20000 : 10000;
    filter.showHighDustValueUniquesIncludeNonJewellery = true;
    filter.showHighDustValueUniquesDiscountBySize = true;
    filter.customRuleStyles.push({
      ruleId: 'uniques-high-dust',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Blue,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    });
  }

  migrateTo177(filter: Filter) {
    const existing = filter as any;

    // Flatten CosmeticSettings onto Filter; value-aware stacks with fixed buckets 3/5/10/20
    const cs = existing.cosmeticSettings ?? {};
    filter.stackedGeneralCurrencyPromotionEnabled = cs.stackedGeneralCurrencyPromotionEnabled ?? true;
    filter.stackedCurrencyMaxPromoteSteps = cs.stackedCurrencyMaxPromoteSteps ?? 2;
    filter.hiddenGearSmallAndTransparent = cs.hiddenGearSmallAndTransparent ?? true;
    filter.hiddenJewellerySmallAndTransparent = cs.hiddenJewellerySmallAndTransparent ?? false;
    filter.hiddenFlaskSmallAndTransparent = cs.hiddenFlaskSmallAndTransparent ?? false;
    delete existing.cosmeticSettings;
    delete existing.stackedCurrencyMaxStackSize;
    delete existing.stackedCurrencyStackSizePreset;
    delete existing.stackedCurrencyAllowedStackSizes;

    if (Array.isArray(filter.customRuleStyles)) {
      filter.customRuleStyles = filter.customRuleStyles.filter(
        s => (s.ruleId as string) !== 'currency-large-stacks' && (s.ruleId as string) !== 'currency-small-stacks'
      );
    }

    // Chaos/Exalt recipe: rename Weapons target to Two Hand Weapons
    if (Array.isArray(filter.showChaosRecipeTarget)) {
      filter.showChaosRecipeTarget = filter.showChaosRecipeTarget.map(t => t === 'Weapons' ? 'Two Hand Weapons' : t);
    }
    if (Array.isArray(filter.showExaltRecipeTarget)) {
      filter.showExaltRecipeTarget = filter.showExaltRecipeTarget.map(t => t === 'Weapons' ? 'Two Hand Weapons' : t);
    }
  }

  migrateTo176(filter: Filter) {
    this.removeEquipmentTypes(filter, [
      'OtherGearLevelingExcellentSocketedFirstAppearance',
      'OtherGearLevelingGoodSocketedFirstAppearance',
    ]);
  }

  migrateTo175(filter: Filter) {
    const existingFilter = (filter as any);

    delete existingFilter.showLevelingGearExcellentSocketGroup;
    delete existingFilter.showLevelingGearOtherSocketGroup;
    const removedFaRuleIds = [
      'gear-leveling-weapons-excellent-socketed-first',
      'gear-leveling-weapons-good-socketed-first',
      'gear-leveling-armour-excellent-socketed-first',
      'gear-leveling-armour-good-socketed-first',
    ];
    filter.customRuleStyles = filter.customRuleStyles.filter(s => !removedFaRuleIds.includes(s.ruleId));
    filter.show5LinkedGear = false;
    filter.show6ColourGear = true;
    filter.show5ColourGear = true;
    filter.show4ColourGear = true;
    filter.show6LinkedGearMinBaseTypeTier = BaseTypeTier.Basic;
    filter.show6LinkedGearMinItemLevel = null;
    filter.show6ColourGearMinBaseTypeTier = BaseTypeTier.Basic;
    filter.show6ColourGearMinItemLevel = null;

    delete existingFilter.showSynthesisedGear;
    delete existingFilter.showSynthesisedGearMinBaseTypeTier;
    delete existingFilter.showSynthesisedGearMinItemLevel;
    delete existingFilter.showSynthesisedJewellery;
    this.removeEquipmentTypes(filter, ['OtherGearSynthesised', 'OtherJewellerySynthesised']);
    const removedSynthRuleIds = ['gear-synthesised', 'jewellery-synthesised'];
    filter.customRuleStyles = filter.customRuleStyles.filter(s => !removedSynthRuleIds.includes(s.ruleId));
    const stripSynthesised = (obj: any) => {
      if (!obj) return;
      delete obj.synthesised;
      if (obj.advancedConditions) delete obj.advancedConditions.synthesised;
    };
    const allGroups = [...(filter.customRuleGroups ?? []), ...(filter.customCosmeticRuleGroups ?? [])];
    for (const group of allGroups) {
      group.rules?.forEach(stripSynthesised);
    }
    // Favourite equipment rules that targeted synthesised items are obsolete — remove them
    filter.weaponFilters = (filter.weaponFilters ?? []).filter((w: any) => !w.synthesised);
    filter.armourFilters = (filter.armourFilters ?? []).filter((a: any) => !a.synthesised);
    filter.jewelleryFilters = (filter.jewelleryFilters ?? []).filter((j: any) => !j.synthesised);
    filter.jewelFilters = (filter.jewelFilters ?? []).filter((j: any) => !j.synthesised);

    [...(filter.weaponFilters ?? []), ...(filter.armourFilters ?? [])].forEach(eq => {
      eq.highlightConfig.colouredSockets = false;
      eq.highlightConfig.colouredSocketsColours = 'RGB';
    });

    if (poe2) return;

    this.migrateRemovedCurrency(filter, [
      {
        type: "Delirium Orbs",
        baseTypes: ["Abyssal Delirium Orb", "Timeless Delirium Orb", "Primal Delirium Orb"]
      },
      {
        type: "Emblems",
        baseTypes: [
          "Unrelenting Timeless Eternal Emblem",
          "Unrelenting Timeless Karui Emblem",
          "Unrelenting Timeless Maraketh Emblem",
          "Unrelenting Timeless Templar Emblem",
          "Unrelenting Timeless Vaal Emblem",
        ]
      },
      {
        type: "Incubators",
        baseTypes: [
          "Abyssal Incubator",
          "Blighted Incubator",
          "Cartographer's Incubator",
          "Celestial Armoursmith's Incubator",
          "Celestial Blacksmith's Incubator",
          "Celestial Jeweller's Incubator",
          "Challenging Incubator",
          "Diviner's Incubator",
          "Eldritch Incubator",
          "Enchanted Incubator",
          "Feral Incubator",
          "Fine Incubator",
          "Foreboding Incubator",
          "Fossilised Incubator",
          "Fragmented Incubator",
          "Gemcutter's Incubator",
          "Geomancer's Incubator",
          "Honoured Incubator",
          "Infused Incubator",
          "Kalguuran Incubator",
          "Maddening Incubator",
          "Miraged Incubator",
          "Mysterious Incubator",
          "Obscured Incubator",
          "Ornate Incubator",
          "Otherworldly Incubator",
          "Primal Incubator",
          "Sacred Incubator",
          "Singular Incubator",
          "Skittering Incubator",
          "Thaumaturge's Incubator",
          "Time-Lost Incubator",
          "Whispering Incubator",
        ]
      },
      {
        type: "Map Fragments",
        baseTypes: ["The Black Barya"]
      },
      {
        type: "Currency",
        baseTypes: ["Refracting Fog"]
      },
      {
        type: "Divination Cards",
        baseTypes: ["Broken Promises", "Magnum Opus", "Parasitic Passengers"]
      }
    ]);

    this.migrateRemovedItemTypes(filter, ["Incubators"]);

    this.migrateRenamedCurrency(filter, [
      {
        type: "Astrolabes",
        baseTypes: [{ old: "Enshrouded Astrolabe", new: "Deceptive Astrolabe" }],
      },
      {
        type: "Scarabs",
        baseTypes: [
          { old: "Abyss Scarab of Edifice", new: "Abyss Scarab of Crystals" },
          { old: "Abyss Scarab of Profound Depth", new: "Abyss Scarab of the Consort" },
        ],
      },
      {
        type: "Omens",
        baseTypes: [{ old: "Omen of Blanching", new: "Omen of Trichromatism" }],
      },
      {
        type: "Skill Gems",
        baseTypes: [
          { old: "Dark Pact", new: "Dark Bargain" },
          { old: "Dark Pact of Trarthus", new: "Dark Bargain of Trarthus" },
        ],
      },
      {
        type: "Support Gems",
        baseTypes: [{ old: "Minion Pact Support", new: "Communion Support" }],
      },
    ]);

    const renamedGems: { old: string; new: string }[] = [
      { old: "Dark Pact", new: "Dark Bargain" },
      { old: "Dark Pact of Trarthus", new: "Dark Bargain of Trarthus" },
      { old: "Minion Pact Support", new: "Communion Support" },
    ];
    filter.showSearchedGemTypes = filter.showSearchedGemTypes.map((g: string) => renamedGems.find(r => r.old === g)?.new ?? g);

    if (!filter.showOtherSpecialJewelleryBaseTypesTypes?.includes('All') && !filter.showOtherSpecialJewelleryBaseTypesTypes?.includes('Pearlescent Amulet')) {
      filter.showOtherSpecialJewelleryBaseTypesTypes.push('Pearlescent Amulet');
    }

    const removedTalismanBases = [
      'Bonespire Talisman',
      'Ashscale Talisman',
      'Lone Antler Talisman',
      'Deep One Talisman',
      'Breakrib Talisman',
      'Deadhand Talisman',
      'Undying Flesh Talisman',
      'Rot Head Talisman',
      'Mandible Talisman',
      'Chrysalis Talisman',
      'Writhing Talisman',
      'Hexclaw Talisman',
      'Primal Skull Talisman',
      'Wereclaw Talisman',
      'Splitnewt Talisman',
      'Clutching Talisman',
      'Avian Twins Talisman',
      'Fangjaw Talisman',
      'Horned Talisman',
      'Spinefuse Talisman',
      'Three Rat Talisman',
      'Monkey Twins Talisman',
      'Longtooth Talisman',
      'Rotfeather Talisman',
      'Monkey Paw Talisman',
      'Three Hands Talisman',
    ];
    this.migrateRemoveJewellery(filter, JewelleryType.Talismans, removedTalismanBases);

    // Cord Belt only dropped from Mirage Blight
    this.migrateRemoveJewellery(filter, JewelleryType.Belts, ['Cord Belt']);
    filter.showOtherSpecialJewelleryBaseTypesTypes = (filter.showOtherSpecialJewelleryBaseTypesTypes ?? [])
      .filter((t: string) => t !== 'Cord Belt');
    this.migrateRemovedItemsFromCustomRules(filter, [{ type: 'Belts', baseTypes: ['Cord Belt'] }]);

    // Afarud / restored Maraketh uniques can no longer drop; only bases whose sole uniques were removed
    this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, [
      "Exquisite Blade", "Maraketh Bow", "Coronal Maul",
    ]);
  }

  migrateTo174(filter: Filter) {
    filter.favouriteScarabs = false;
    filter.favouriteScarabsTypes = ['None'];
    filter.favouriteScarabsTypesFromPresets = [];
    filter.favouriteScarabsMode = FavouriteCurrencyMode.Multiplier;
    filter.favouriteScarabsValue = poe1 ? 1.5 : 2;
    filter.endgamePresetPromoteScarabs = false;
  }

  migrateTo173(filter: Filter) {
    filter.id = this.filterIdService.generateId();
  }

  migrateTo172(filter: Filter) {
    if (poe1) return;

    this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, ["Precursor Tablet", "Overseer Precursor Tablet",
      "Delirium Precursor Tablet", "Ritual Precursor Tablet", "Abyss Precursor Tablet", "Breach Precursor Tablet"]);
  }

  migrateTo171(filter: Filter) {
    const existingFilter = filter as any;

    filter.id = this.filterIdService.generateId();

    filter.favouriteBasicCurrency = poe1 ? false : true;
    filter.favouriteBasicCurrencyTypes = poe1 ? defaultFavouriteBasicCurrencyTypesPoE1 : defaultFavouriteBasicCurrencyTypesPoE2;
    filter.favouriteBasicCurrencyMode = FavouriteCurrencyMode.Multiplier;
    filter.favouriteBasicCurrencyValue = poe1 ? 1.5 : 2;
    filter.favouriteCurrencyTypes = [];

    filter.favouriteEndgameContent = ['All'];
    filter.endgamePresetPromoteFavouriteCurrency = false;
    filter.showFavouriteRestrictedBossUniques = true;
    filter.showFavouriteLowValueBossUniques = false;
    filter.showOtherLowValueBossUniques = false;
    filter.endgamePresetEnableCustomRules = true;

    delete existingFilter.sectionVisibility.flasks;
    delete existingFilter.groupVisibility.showRemainingEquipmentFilters;
    delete existingFilter.groupVisibility.showOtherFlaskFilters;

    filter.showExcellentQualityFlasks = true;
    filter.showExcellentQualityFlasksMinQuality = 25;
    filter.showGoodQualityFlasks = true;
    filter.showGoodQualityFlasksMinQuality = 21;
    filter.showQualityFlasksMinILevel = null;
    filter.showQualityFlaskTypes = ['All'];

    if (filter.showQualityFlasksMinQuality > 20) {
      filter.showQualityFlasks = false;
    }

    if (filter.myItemsStyleOverride?.name === 'My Equipment') {
      filter.myItemsStyleOverride.name = 'Favourite Equipment';
    }

    if (poe1) {
      this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, ["Golden Hoop", "Golden Flame", "Golden Obi"]);
    } else {
      this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, ["Plated Mace"]);
      this.dangerouslyMigrateRemovedChanceBaseTypes(filter, ["Spiritbone Crown"]);

      filter.showExcellentExceptionalSocketedGearMinBaseTypeTier ??= BaseTypeTier.Elite;
      filter.showExcellentExceptionalQualityGearMinQuality ??= 28;
      filter.showExcellentExceptionalQualityGearMinBaseTypeTier ??= BaseTypeTier.Elite;
      filter.showGoodExceptionalQualityGearMinBaseTypeTier ??= BaseTypeTier.Elite;
    }
  }

  migrateTo170(filter: Filter) {
    if (poe1) return;

    this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, [
      "Steeltoe Boots", "Effigial Tower Shield", "Lamellar Mail", "Smithing Hammer", "Coffer Relic"]);
  }

  migrateTo167(filter: Filter) {
    if (poe1) return;

    if (filter.progressPreset === 'presetStrict90') {
      filter.hideRegularRunes = false; // TODO: remove this later!
    }
  }

  migrateTo166(filter: Filter) {
    if (poe1) return;

    this.dangerouslyMigrateRemovedChanceBaseTypes(filter, [
      "Two-Stone Ring",
      "Heavy Bow",
      "Aberrant Sledge",
      "Warding Quarterstaff",
      "Heartwood Shortbow",
      "Twisted Wand", "Runic Fork",
      "Perching Staff",
      "Ancient Visor", "Tenebrous Crown",
      "Ancient Leggings",
      "Ornate Ringmail", "Ancient Mail", "Primal Markings",
      "Glacial Fortress",
      "Venerable Defender",
    ]);
  }

  migrateTo165(filter: Filter) {
    const existingFilter = (filter as any);
    delete existingFilter.gearTieringMode;

    filter.customJewelleryTiers = [];

    if (poe1) {
      this.migrateRemoveJewellery(filter, JewelleryType.Belts, ["Mechalarm Belt"]);
      return;
    }

    this.migrateRemoved050UniqueOnlyGear(filter);

    this.migrateRemoveJewellery(filter, JewelleryType.Rings, ['Abyssal Signet']);

    filter.showSpecialGear = true;

    filter.showExcellentSpecialJewelleryBaseTypes = true;
    filter.showGoodSpecialJewelleryBaseTypes = true;
    filter.showOtherSpecialJewelleryBaseTypes = true;
    filter.showOtherSpecialJewelleryBaseTypesTypes = ['All'];

    filter.showExcellentJewelleryBaseTypes = true;
    filter.showExcellentJewelleryBaseTypesMinItemLevel = filter.progressPreset === 'presetVeryStrict95' ? 82
      : filter.progressPreset === 'presetStrict90' ? 81 : filter.progressPreset === 'presetEndGame80' ? 80 : null;
    filter.showGoodJewelleryBaseTypes = filter.progressPreset !== 'presetVeryStrict95';
    filter.showGoodJewelleryBaseTypesMinItemLevel = filter.progressPreset === 'presetVeryStrict95' ? 82
      : filter.progressPreset === 'presetStrict90' ? 82 : filter.progressPreset === 'presetEndGame80' ? 81 : null;

    delete existingFilter.showHighILevelJewellery;
    delete existingFilter.showHighILevelJewelleryMinILevel;

    this.migrateRemovedEquipmentTypes(filter, ['OtherJewelleryILevel']);
  }

  migrateTo164(filter: Filter) {
    this.migrateRemoveJewellery(filter, JewelleryType.Belts, ['Golden Obi']);

    if (poe1) return;

    this.migrateRemoveItemsFromCustomChanceBase(filter, [
      'Ruby', 'Emerald', 'Sapphire', 'Diamond',
      'Timeless Jewel',
      'Time-Lost Ruby', 'Time-Lost Emerald', 'Time-Lost Sapphire', 'Time-Lost Diamond',
      'Transcendent Mana Flask', 'Stoic Sceptre', 'Grand Spear',
    ]);

    // TODO: migrate poe2 my jewellery to special jewellery
  }

  migrateTo163(filter: Filter) {
    const existingFilter = (filter as any);

    if (poe1) return;

    existingFilter.gearTieringMode = 'Normal';

    this.migrateRemoveJewellery(filter, JewelleryType.Rings, ['Two-Stone Ring']);
    this.migrateRemoveJewellery(filter, JewelleryType.Amulets, ['Veridical Chain']);
  }

  migrateRemoved050UniqueOnlyGear(filter: Filter) {
    this.migrateRemovedGear(filter, [
      {
        type: "Two Hand Maces",
        baseTypes: ["Aberrant Sledge"]
      },
      {
        type: "Quarterstaves",
        baseTypes: ["Warding Quarterstaff"]
      },
      {
        type: "Bows",
        baseTypes: ["Heartwood Shortbow"]
      },
      {
        type: "Wands",
        baseTypes: ["Twisted Wand", "Runic Fork"]
      },
      {
        type: "Staves",
        baseTypes: ["Perching Staff"]
      },
      {
        type: "Helmets",
        baseTypes: ["Ancient Visor", "Tenebrous Crown"]
      },
      {
        type: "Boots",
        baseTypes: ["Ancient Leggings"]
      },
      {
        type: "Gloves",
        baseTypes: ["Ancient Gauntlets"]
      },
      {
        type: "Body Armours",
        baseTypes: ["Ornate Ringmail", "Ancient Mail", "Primal Markings"]
      },
      {
        type: "Tower Shields",
        baseTypes: ["Glacial Fortress"]
      },
      {
        type: "Targes",
        baseTypes: ["Venerable Defender"]
      }
    ]);
  }

  migrateTo162(filter: Filter) {
    if (poe1) return;

    const irradiatedTabletTier = filter.customCurrencyTiers.find(t => t.name === 'Irradiated Tablet');
    const overseerTabletTier = filter.customCurrencyTiers.find(t => t.name === 'Overseer Tablet');

    if (irradiatedTabletTier?.tier === Tier.FHidden) {
      filter.customCurrencyTiers = filter.customCurrencyTiers.filter((tier: CustomTieredItem) => tier.name !== 'Irradiated Tablet');
    }
    if (overseerTabletTier?.tier === Tier.FHidden) {
      filter.customCurrencyTiers = filter.customCurrencyTiers.filter((tier: CustomTieredItem) => tier.name !== 'Overseer Tablet');
    }
  }

  migrateTo161(filter: Filter) {
    if (poe1) return;

    this.migrateRemovedCurrency(filter, [
      {
        type: "Tablets",
        baseTypes: ["Expedition Precursor Tablet"]
      }
    ]);
  }

  migrateTo160(filter: Filter) {
    if (poe1) return;

    filter.customUniqueTiers.forEach((uniqueTier: CustomTieredUnique) => {
      if (uniqueTier.baseType === 'Verisium Cuffs') {
        uniqueTier.baseType = 'Kalguuran Cuffs';
      }
    });

    filter.customChanceBaseTiers.forEach((chanceBaseTier: CustomTieredChanceBase) => {
      if (chanceBaseTier.baseType === 'Verisium Cuffs') {
        chanceBaseTier.baseType = 'Kalguuran Cuffs';
      }
    });

    this.migrateRemovedCurrency(filter, [
      {
        type: "Legacy Runes",
        baseTypes: ["Legacy of Hysseg's Claw"]
      }
    ]);
  }

  migrateTo159(filter: Filter) {
    if (poe1) return;

    this.migrateAddMyJewelleryBaseTypes(filter, JewelleryType.Amulets, [
      'Twisted Amulet',
    ]);

    this.migrateRemovedCurrency(filter, [
      {
        type: "Fluxes",
        baseTypes: ["Thaumaturgic Flux (Level 1)", "Thaumaturgic Flux (Level 2)", "Thaumaturgic Flux (Level 3)", "Thaumaturgic Flux (Level 4)"]
      }
    ]);
  }

  migrateTo158(filter: Filter) {
    const existingFilter = (filter as any);

    filter.showLevelingVerisium = false;
    filter.hideVerisium = false;
    filter.hideVerisiumLowerThan = 5;
    filter.showLargeVerisiumStacks = true;
    filter.showLargeVerisiumStacksMinStackSize = 50;
    filter.showHugeVerisiumStacks = true;
    filter.showHugeVerisiumStacksMinStackSize = 200;
    filter.verisiumStyleOverride = new ItemTypeOverride({ name: 'Verisium', displayOptions: {
      active: true,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Star })
    }});

    if (poe1) return;

    this.migrateRemovedCurrency(filter, [
      {
        type: "Pinnacle Keys",
        baseTypes: ["Primary Calamity Fragment", "Secondary Calamity Fragment", "Tertiary Calamity Fragment"]
      },
      {
        type: "Splinters",
        baseTypes: ["Petition Splinter", "Runic Splinter"]
      },
      {
        type: "Omens",
        baseTypes: ["Omen of Recombination"]
      },
      {
        type: "Currency",
        baseTypes: ["Exotic Coinage", "Broken Circle Artifact", "Black Scythe Artifact", "Order Artifact", "Sun Artifact"]
      }
    ]);

    this.migrateRenamedCurrency(filter,[
      {
        type: "Currency",
        baseTypes: [{ old: "Vaal Infuser", new: "Vaal Armourer's Infuser" }],
      },
      {
        type: "Tablets",
        baseTypes: [{ old: "Precursor Tablet", new: "Irradiated Tablet" }],
      }
    ]);

    this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, ["Expedition Precursor Tablet", "Expedition Tablet"]);

    this.migrateRenamedGearBaseTypes(filter, [
      {
        itemType: "Helmets",
        baseTypes: [{ old: "Gladiatoral Helm", new: "Cassis Helm" }],
      },
      {
        itemType: "Gloves",
        baseTypes: [{ old: "Verisium Cuffs", new: "Kalguuran Cuffs" }],
      },
    ]);

    this.migrateRemoveItemsFromCustomUnique(filter, ["Precursor Tablet", "Overseer Precursor Tablet",
      "Delirium Precursor Tablet", "Ritual Precursor Tablet", "Abyss Precursor Tablet", "Breach Precursor Tablet"]);

    this.migrateRenamedCurrency(filter, [
      {
        type: "Tablets",
        baseTypes: [
          { old: "Precursor Tablet", new: "Irradiated Tablet" },
          { old: "Overseer Precursor Tablet", new: "Overseer Tablet" },
          { old: "Delirium Precursor Tablet", new: "Delirium Tablet" },
          { old: "Ritual Precursor Tablet", new: "Ritual Tablet" },
          { old: "Abyss Precursor Tablet", new: "Abyss Tablet" },
          { old: "Breach Precursor Tablet", new: "Breach Tablet" },
        ]
      }
    ]);

    this.migrateRemovedGear(filter, [
      {
        type: "Body Armours",
        baseTypes: ["Clandestine Jacket", "Monastic Garb"]
      },
      {
        type: "Bows",
        baseTypes: ["Double Limb Bow", "Heavy Bow"]
      },
      {
        type: "Gloves",
        baseTypes: ["Titan Mitts", "Hardened Bracers", "Embroidered Gloves"]
      },
      {
        type: "Helmets",
        baseTypes: ["Lavish Crown"]
      },
      {
        type: "Shields",
        baseTypes: ["Mosaic Targe", "Aureate Targe", "Grand Targe"]
      },
      {
        type: "Two Hand Maces",
        baseTypes: ["Greatmace", "Precise Greathammer", "Giant Maul"]
      }
    ]);

    this.migrateAddMyJewelleryBaseTypes(filter, JewelleryType.Rings, [
      'Biostatic Ring', 'Vitalic Ring', 'Mnemonic Ring', 'Kinetic Ring', 'Oneiric Ring', 'Grasping Ring',
    ]);
    this.migrateAddMyJewelleryBaseTypes(filter, JewelleryType.Amulets, [
      'Veridical Chain', 'Lament Amulet', 'Portent Amulet', 'Absent Amulet', 'Corona Amulet', 'Distorted Amulet',
    ]);
    this.migrateAddMyJewelleryBaseTypes(filter, JewelleryType.Belts, [
      'Stalking Belt', 'Invoking Belt', 'Sinew Belt', 'Forking Belt',
    ]);

    this.migrateRenamedCurrencyClasses(filter, [{ oldClass: 'Expedition Logbooks', newClass: 'Expedition Logbook' }]);

    this.migrateRemoveCustomMods(filter, ["Fevered", "of the Parasite", "of the Thirsty"]);

    this.migrateRuneTypes(filter);
    this.migrateVaalThesesFromSoulCores(filter);
  }

  private migrateRuneTypes(filter: Filter) {
    const regularRuneBaseTypes = new Set(regularRuneBaseTypeEntries.map(([name]) => name));

    const megalithRuneBaseTypes = new Set([
      'Greater Rune of Leadership', 'Greater Rune of Tithing', 'Greater Rune of Alacrity', 'Greater Rune of Nobility',
    ]);

    const lineageRuneBaseTypes = new Set([
      "Hedgewitch Assandra's Rune of Wisdom", "Saqawal's Rune of the Sky", "Fenumus' Rune of Agony",
      "Farrul's Rune of Grace", "Farrul's Rune of the Chase", "Craiceann's Rune of Warding",
      "Saqawal's Rune of Memory", "Saqawal's Rune of Erosion", "Farrul's Rune of the Hunt",
      "Craiceann's Rune of Recovery", "Courtesan Mannan's Rune of Cruelty", "Thane Grannell's Rune of Mastery",
      "Fenumus' Rune of Spinning", "Countess Seske's Rune of Archery", "Thane Girt's Rune of Wildness",
      "Fenumus' Rune of Draining", "Thane Myrk's Rune of Summer", "Lady Hestra's Rune of Winter",
      "Thane Leld's Rune of Spring", "The Greatwolf's Rune of Claws", "The Greatwolf's Rune of Willpower",
    ]);

    const subTypeNames: ['Regular Runes', 'Megalith Runes', 'Lineage Runes'] = ['Regular Runes', 'Megalith Runes', 'Lineage Runes'];
    const subTypeSets = [regularRuneBaseTypes, megalithRuneBaseTypes, lineageRuneBaseTypes];

    const allGroups = [...(filter.customRuleGroups ?? []), ...(filter.customCosmeticRuleGroups ?? [])];

    for (const group of allGroups) {
      const newRules: CustomRule[] = [];

      for (const rule of group.rules) {
        if (rule.itemType !== 'Runes') {
          newRules.push(rule);
          continue;
        }

        const isAll = rule.baseTypes.includes('All');
        const baseTypesPerSubType: string[][] = subTypeNames.map(() => isAll ? ['All'] : []);

        if (!isAll) {
          for (const baseType of rule.baseTypes) {
            const idx = subTypeSets.findIndex(set => set.has(baseType));
            if (idx !== -1) baseTypesPerSubType[idx].push(baseType);
          }
        }

        for (let i = 0; i < subTypeNames.length; i++) {
          if (baseTypesPerSubType[i].length === 0) continue;
          newRules.push(new CustomRule({ ...rule, itemType: subTypeNames[i], baseTypes: baseTypesPerSubType[i] }));
        }
      }

      newRules.forEach((r, i) => r.order = i);
      group.rules = newRules;
    }
  }

  private migrateVaalThesesFromSoulCores(filter: Filter) {
    const vaalThesisBaseTypes = new Set([
      "Guatelitzi's Thesis", "Citaqualotl's Thesis", "Jiquani's Thesis", "Quipolatl's Thesis",
    ]);

    const allGroups = [...(filter.customRuleGroups ?? []), ...(filter.customCosmeticRuleGroups ?? [])];

    for (const group of allGroups) {
      const newRules: CustomRule[] = [];

      for (const rule of group.rules) {
        if (rule.itemType !== 'Soul Cores') {
          newRules.push(rule);
          continue;
        }

        const isAll = rule.baseTypes.includes('All');
        if (isAll) {
          newRules.push(new CustomRule({ ...rule, itemType: 'Soul Cores', baseTypes: ['All'] }));
          newRules.push(new CustomRule({ ...rule, itemType: 'Vaal Theses', baseTypes: ['All'] }));
          continue;
        }

        const soulCoreBaseTypes: string[] = [];
        const thesisBaseTypes: string[] = [];

        for (const baseType of rule.baseTypes) {
          if (vaalThesisBaseTypes.has(baseType)) thesisBaseTypes.push(baseType);
          else soulCoreBaseTypes.push(baseType);
        }

        if (soulCoreBaseTypes.length > 0) {
          newRules.push(new CustomRule({ ...rule, itemType: 'Soul Cores', baseTypes: soulCoreBaseTypes }));
        }
        if (thesisBaseTypes.length > 0) {
          newRules.push(new CustomRule({ ...rule, itemType: 'Vaal Theses', baseTypes: thesisBaseTypes }));
        }
      }

      newRules.forEach((r, i) => r.order = i);
      group.rules = newRules;
    }
  }

  migrateTo157(filter: Filter) {
    filter.showAllIdentifiedItems = false;
  }

  migrateTo155(filter: Filter) {
    if (poe1) return;

    this.migrateRemoveItemsFromCustomUnique(filter, ["Shortsword"]);
  }

  migrateTo154(filter: Filter) {
    const existingFilter = (filter as any);

    filter.showHighDustValueUniques = existingFilter.includeHighDustValueUniquesAsGood ?? true;
    delete existingFilter.includeHighDustValueUniquesAsGood;

    filter.showClassSpecificUniquesForClasses = existingFilter.classSpecificUniquesForClasses;
    delete existingFilter.classSpecificUniquesForClasses;

    filter.customRuleStyles = createDefaultCustomRuleStyles();

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-exceptional')!.options = existingFilter.highlightExceptionalOtherUniques.displayOptions.cosmeticOptions;
    filter.showExceptionalUniques = existingFilter.highlightExceptionalOtherUniques.displayOptions.active;
    filter.showExceptionalUniquesMinQuality = existingFilter.highlightExceptionalOtherUniquesMinQuality;
    delete existingFilter.highlightExceptionalOtherUniques;
    delete existingFilter.highlightExceptionalOtherUniquesMinQuality;

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-small')!.options = existingFilter.highlightSmallOtherUniques.displayOptions.cosmeticOptions;
    filter.showSmallUniques = existingFilter.highlightSmallOtherUniques.displayOptions.active;
    filter.showSmallUniquesMaxSize = existingFilter.highlightSmallOtherUniquesMaxSize;
    delete existingFilter.highlightSmallOtherUniques;
    delete existingFilter.highlightSmallOtherUniquesMaxSize;

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-foulborn')!.options = existingFilter.highlightFoulbornUniques.displayOptions.cosmeticOptions;
    filter.showFoulbornUniques = existingFilter.highlightFoulbornUniques.displayOptions.active;
    delete existingFilter.highlightFoulbornUniques;

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-maps')!.options = existingFilter.highlightUniqueMaps.displayOptions.cosmeticOptions;
    filter.showUniqueMaps = existingFilter.highlightUniqueMaps.displayOptions.active;
    delete existingFilter.highlightUniqueMaps;

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-vaal')!.options = existingFilter.highlightVaalUniques.displayOptions.cosmeticOptions;
    filter.showVaalUniques = existingFilter.highlightVaalUniques.displayOptions.active;
    delete existingFilter.highlightVaalUniques;

    filter.customRuleStyles.find(r => r.ruleId === 'uniques-vaal-mod')!.options = existingFilter.highlightVaalModUniques.displayOptions.cosmeticOptions;
    filter.showVaalModUniques = existingFilter.highlightVaalModUniques.displayOptions.active;
    delete existingFilter.highlightVaalModUniques;

    filter.customRuleStyles.find(r => r.ruleId === 'gear-hidden-vendoring-rares')!.options = existingFilter.showVendoringRaresStyle.displayOptions.cosmeticOptions;
    delete existingFilter.showVendoringRaresStyle;
    filter.customRuleStyles.find(r => r.ruleId === 'gear-hidden-vendoring-magic')!.options = existingFilter.showVendoringMagicsStyle.displayOptions.cosmeticOptions;
    delete existingFilter.showVendoringMagicsStyle;

    filter.customRuleStyles.find(r => r.ruleId === 'quest-items')!.options = existingFilter.highlightQuestItems.displayOptions.cosmeticOptions;
    filter.showQuestItems = existingFilter.highlightQuestItems.displayOptions.active;
    delete existingFilter.highlightQuestItems;

    filter.groupVisibility.showValuableUniquesFilters = existingFilter.groupVisibility.showUniqueHighlights;
    filter.groupVisibility.showSpecialUniquesFilters = existingFilter.groupVisibility.showUniqueHighlights;
    filter.groupVisibility.showRemainingUniquesFilters = existingFilter.groupVisibility.showUniqueHighlights;
    filter.groupVisibility.showChanceBaseFilters = existingFilter.groupVisibility.showUniqueHighlights;
    delete existingFilter.groupVisibility.showUniqueHighlights;

    filter.sectionVisibility.uniques = existingFilter.sectionVisibility.uniquesAndOther;
    filter.sectionVisibility.other = existingFilter.sectionVisibility.uniquesAndOther;
    delete existingFilter.sectionVisibility.uniquesAndOther;

    filter.hideAllRemainingUniques = !!filter.uniqueTierCosmetics[4].displayOptions.hidden && (filter.uniqueTierCosmetics[4].displayOptions.active ?? true);

    for (const tier of filter.uniqueTierCosmetics) {
      if (tier.displayOptions.active && tier.displayOptions.hidden) {
        // Tiers that used to be hidden now should just be disabled.
        tier.displayOptions.hidden = false;
        tier.displayOptions.active = false;
      }
    }

    for (const chanceBaseTier of filter.chanceBaseTierCosmetics) {
      if (chanceBaseTier.displayOptions.hidden) {
        chanceBaseTier.displayOptions.hidden = false;
      }
    }

    filter.showLevelingGearAllMagicRareBoots = true;
    filter.showLevelingGearAllMagicRareBootsMaxAreaLevel = 20;

    // Plain JSON / legacy filters may omit fields added for tier vs specific base types.

    filter.weaponFilters?.forEach(w => {
      w.baseTypeMode ??= GearBaseTypeMode.Tier;
      w.specificBaseTypes ??= ['All'];
    });

    filter.armourFilters?.forEach(a => {
      a.baseTypeMode ??= GearBaseTypeMode.Tier;
      a.specificBaseTypes ??= ['All'];
    });

    filter.showTrialKeys = true;
    filter.showTrialItemTypes = ['All'];
    filter.hideOtherTrialItems = false;

    const legacyRules: CustomRule[] = (existingFilter.customRules ?? []).map((r: any) => new CustomRule(r));
    const legacyCosmetic: CustomRule[] = (existingFilter.customCosmeticRules ?? []).map((r: any) => new CustomRule(r));
    filter.customRuleGroups = [new CustomRuleGroup({ name: 'Default', isDefault: true, active: true, order: 0, rules: legacyRules })];
    filter.customCosmeticRuleGroups = [new CustomRuleGroup({ name: 'Default', isDefault: true, active: true, order: 0, rules: legacyCosmetic })];

    delete existingFilter.customRules;
    delete existingFilter.customCosmeticRules;

    const oldSize = (filter.cosmeticPresets as { defaultLabelSize?: string }).defaultLabelSize;
    if (oldSize === 'larger') {
      filter.cosmeticPresets.defaultLabelSize = 'large';
    } else if (oldSize === 'veryLarge') {
      filter.cosmeticPresets.defaultLabelSize = 'larger';
    }

    if (poe1) return;

    this.migrateRemoveItemsFromCustomUnique(filter, ["Stone Tower Shield", "Legion Boots", "Ironclad Vestments", "Goathide Gloves"]);
  }

  migrateTo153(filter: Filter) {
    filter.showLevelingGearMaxAreaLevel = 70;
  }

  migrateTo152(filter: Filter) {
    if (poe1) return;

    if (!filter.showOtherSpecialJewelleryBaseTypesTypes?.includes('All') && !filter.showOtherSpecialJewelleryBaseTypesTypes?.includes('Cord Belt')) {
      filter.showOtherSpecialJewelleryBaseTypesTypes.push('Cord Belt');
    }
  }

  migrateTo151(filter: Filter) {
    filter.showHeistEnchantedBlueprints = true;
    filter.showHeistEnchantedContracts = true;
  }

  migrateTo150(filter: Filter) {
    filter.showCorruptedImplicitJewellery = true;
    filter.showCorruptedImplicitJewelleryClasses = ['All'];
    filter.showCorruptedImplicitJewelleryMinRarity = Rarity.Rare;
    filter.showCorruptedImplicitJewelleryMinImplicits = 2;
  }

  migrateTo149(filter: Filter) {
    filter.showAnointedAmulets = true;
  }

  migrateTo148(filter: Filter) {
    if (poe2) return;

    const beltFilters = filter.jewelleryFilters.filter(j => j.jewelleryType === JewelleryType.Belts);
    const hasCordBelt = beltFilters.some(j => j.jewelleryBaseTypes.includes('Cord Belt'));

    if (!hasCordBelt) {
      const presetBeltFilter = beltFilters.find(j => j.fromProgressPreset);
      if (presetBeltFilter) {
        presetBeltFilter.jewelleryBaseTypes.push('Cord Belt');
      } else {
        filter.jewelleryFilters.push(new JewelleryFilter({
          jewelleryType: JewelleryType.Belts,
          jewelleryBaseTypes: ['Cord Belt'],
        }));
      }
    }
  }

  migrateTo147(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightUniqueMaps = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.Brown,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Diamond,
      }
    }});
  }

  migrateTo146(filter: Filter) {
    const existingFilter = (filter as any);

    delete existingFilter.favouriteMaps;
    delete existingFilter.mapTypesT16Favourite;
    delete existingFilter.mapTypesLowTierInfluenced;

    delete existingFilter.showOtherAwakenedGems;
    delete existingFilter.showOtherSpecialSupportGems;

    delete existingFilter.showGrafts;
    delete existingFilter.showGraftsMinQuality;
    delete existingFilter.showGraftsMinILevel;
    delete existingFilter.showGraftsMinRarity;
    delete existingFilter.showGraftsTypes;
    delete existingFilter.hideOtherGrafts;

    filter.showTopTierExceptionalSupportGems = true;
    filter.showOtherExceptionalSupportGems = true;
    filter.showImbuedGems = true;

    if (poe2) return;

    const removedCurrencyTypes = ["Cartographer's Chisel",
      "Engineer's Orb", "Harbinger's Orb", "Orb of Horizons",
      "Ancient Shard", "Binding Shard", "Engineer's Shard", "Harbinger's Shard", "Horizon Shard",
      "Deregulation Scroll", "Electroshock Scroll", "Fragmentation Scroll", "Haemocombustion Scroll", "Specularity Scroll", "Time-light Scroll",
    ];

    this.migrateRemovedCurrency(filter, [
      {
        type: "Currency",
        baseTypes: removedCurrencyTypes,
      },
      {
        type: "Divination Cards",
        baseTypes: ["The Cartographer", "The Bargain", "The Eye of Terror", "The Obscured", "The Puzzle", "The Landing", "The Cheater", "The Emptiness"]
      },
      {
        type: "Wombgifts",
        baseTypes: ["Growing Wombgift"]
      },
      {
        type: "Scarabs",
        baseTypes: ["Harbinger Scarab", "Harbinger Scarab of Obelisks", "Harbinger Scarab of Regency", "Harbinger Scarab of Warhoards"]
      },
      {
        type: "Delirium Orbs",
        baseTypes: ["Obscured Delirium Orb", "Foreboding Delirium Orb", "Kalguuran Delirium Orb"]
      },
      {
        type: "Incubators",
        baseTypes: ["Foreboding Incubator"]
      }
    ]);

    filter.hideCurrencyTypes = filter.hideCurrencyTypes.filter((c: string) => !removedCurrencyTypes.includes(c));

    this.migrateRenamedCurrency(filter, [
      {
        type: "Scarabs",
        baseTypes: [
          { old: "Breach Scarab", new: "Breach Scarab of the Hive" },
          { old: "Breach Scarab of Lordship", new: "Breach Scarab of Instability" },
          { old: "Breach Scarab of Splintering", new: "Breach Scarab of the Marshal" },
          { old: "Breach Scarab of Snares", new: "Breach Scarab of the Incensed Swarm" },
          { old: "Influencing Scarab of Conversion", new: "Influencing Scarab of Interference" },
          { old: "Expedition Scarab of the Skald", new: "Expedition Scarab of Infusion" },
          { old: "Legion Scarab of Command", new: "Legion Scarab of Treasures" },
          { old: "Abyss Scarab of Emptiness", new: "Abyss Scarab of Descending" },
          { old: "Betrayal Scarab of Perpetuation", new: "Betrayal Scarab of Unbreaking" },
          { old: "Scarab of Bisection", new: "Scarab of the Sinistral" },
          { old: "Scarab of Unity", new: "Scarab of the Dextral" },
        ]
      },
      {
        type: "Skill Gems",
        baseTypes: [
          { old: "Sweep", new: "Holy Sweep" },
        ]
      },
      {
        type: "Support Gems",
        baseTypes: [
          { old: "Lesser Multiple Projectiles Support", new: "Multiple Projectiles Support" },
        ]
      },
    ]);

    const renamedGems: { old: string; new: string }[] = [
      { old: "Sweep", new: "Holy Sweep" },
      { old: "Lesser Multiple Projectiles Support", new: "Multiple Projectiles Support" },
    ];
    filter.showSearchedGemTypes = filter.showSearchedGemTypes.map((g: string) => renamedGems.find(r => r.old === g)?.new ?? g);

    this.dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter, [
      "Imperial Staff Piece", "Blunt Arrow Quiver Piece", "Archon Kite Shield Piece", "Callous Mask Piece", "Cloth Belt Piece", "Legion Sword Piece",
      "Harbinger Map"]);

    this.migrateRemovedItemTypes(filter, ["Grafts", "Implants", "Scouting Reports"]);

    const removedGems = ["Awakened Added Fire Damage Support", "Awakened Ancestral Call Support", "Awakened Brutality Support",
      "Awakened Burning Damage Support", "Awakened Elemental Damage with Attacks Support", "Awakened Fire Penetration Support",
      "Awakened Generosity Support", "Awakened Melee Physical Damage Support", "Awakened Melee Splash Support", "Awakened Multistrike Support",
      "Awakened Empower Support", "Awakened Added Cold Damage Support", "Awakened Arrow Nova Support", "Awakened Cast On Critical Strike Support",
      "Awakened Chain Support", "Awakened Cold Penetration Support", "Awakened Deadly Ailments Support", "Awakened Fork Support",
      "Awakened Greater Multiple Projectiles Support", "Awakened Swift Affliction Support", "Awakened Vicious Projectiles Support",
      "Awakened Void Manipulation Support", "Awakened Enhance Support", "Awakened Added Chaos Damage Support",
      "Awakened Added Lightning Damage Support", "Awakened Blasphemy Support", "Awakened Cast While Channelling Support",
      "Awakened Controlled Destruction Support", "Awakened Elemental Focus Support", "Awakened Hextouch Support",
      "Awakened Increased Area of Effect Support", "Awakened Lightning Penetration Support", "Awakened Minion Damage Support",
      "Awakened Spell Cascade Support", "Awakened Spell Echo Support", "Awakened Unbound Ailments Support", "Awakened Unleash Support",
      "Awakened Enlighten Support"];

    this.migrateRemovedItemsFromCustomRules(filter, [
      { type: "Support Gems", baseTypes: removedGems },
    ]);

    filter.showSearchedGemTypes = filter.showSearchedGemTypes.filter((g: string) => !removedGems.includes(g));
    if (filter.showSearchedGemTypes?.length === 0) filter.showSearchedGemTypes = ['None'];

    existingFilter.customRules = existingFilter.customRules.filter((c: CustomRule) => !(c.itemType === 'Maps' && !c.baseTypes.includes('All')));
    existingFilter.customCosmeticRules = existingFilter.customCosmeticRules.filter((c: CustomRule) => !(c.itemType === 'Maps' && !c.baseTypes.includes('All')));

    this.migrateRemovedEquipmentTypes(filter, ["GemsOtherAwakened", "GemsOtherAwakened", "ItemsGrafts"])
  }

  migrateTo144(filter: Filter) {
    filter.ruthless = false;
  }

  migrateTo143(filter: Filter) {
    filter.clusterJewelTieringMode = 'Normal';
    filter.clusterJewelTieringModeCustom = createDefaultCustomClusterJewelTierValueList();
    filter.showClusterJewelBasesMinItemLevel = 1;
  }

  migrateTo141(filter: Filter) {
    filter.hideRegularRunes = false;
    filter.hideRegularRunesExceptions = ['None'];

    if (filter.progressPreset === 'presetVeryStrict95') {
      filter.hideRegularRunes = true;
    }
  }

  migrateTo140(filter: Filter) {
    filter.league = true;
    filter.hardcore = false;
    filter.economy = filter.tieringMode as any === 'SSF' ? Economy.Fixed : Economy.League;
    filter.uniquesTieringMode = 'Normal';
    filter.tieringModeCustom = createDefaultCustomTierValueList();
    filter.uniquesTieringModeCustom = createDefaultCustomUniquesTierValueList();

    filter.showLevelingGold = false;
    filter.showVendoringRaresUntilAreaLevel = 40;
    filter.showVendoringMagicsUntilAreaLevel = 20;

    if (filter.tieringMode as any === 'SSF') filter.tieringMode = 'Normal';

    if (poe2 && filter.progressPreset === 'presetMidCampaign30') filter.progressPreset = 'presetEarlyCampaign1';
  }

  migrateTo139(filter: Filter) {
    const existingFilter = (filter as any);

    if (poe1) return;

    existingFilter.gearTieringMode = 'Normal';
  }

  migrateTo137(filter: Filter) {
    const existingFilter = (filter as any);

    filter.showIdentifiedTimeLostJewelCategories = [TimeLostJewelsCategory.All]; // POE2

    filter.showIdentifiedGear = existingFilter.showExcellentIdentifiedGear ?? true;
    filter.showIdentifiedJewellery = existingFilter.showExcellentIdentifiedJewellery ?? true;
    filter.showIdentifiedJewels = existingFilter.showExcellentIdentifiedJewels ?? true;
    filter.showIdentifiedCustomItems = existingFilter.showExcellentIdentifiedCustomItems ?? true;
    filter.identifiedItemConfigs = createDefaultIdentifiedItemConfigs();

    filter.hideRemainingIdentifiedItems = true;
    filter.hideRemainingIdentifiedItemsIncludingCorrupted = false;

    filter.customModItemCategories.forEach((c: any) => {
      if (c.singleMod) {
        c.customConfiguration = new IdentifiedItemConfig();
        delete c.singleMod;

        if (c.minimumRarity) {
          c.customConfiguration.rarity = c.minimumRarity;
          c.customConfiguration.rarityComparator = Comparator.GreaterThanOrEqual;
        }
      }

      delete c.minimumRarity;
    });

    filter.showIdentifiedGear = existingFilter.showExcellentIdentifiedGear ?? true;
    filter.showIdentifiedJewellery = existingFilter.showExcellentIdentifiedJewellery ?? true;
    filter.showIdentifiedJewels = existingFilter.showExcellentIdentifiedJewels ?? true;
    filter.showIdentifiedCustomItems = existingFilter.showExcellentIdentifiedCustomItems ?? true;

    delete existingFilter.showExcellentIdentifiedGear;
    delete existingFilter.showExcellentIdentifiedGearTier;
    delete existingFilter.showGoodIdentifiedGear;
    delete existingFilter.showGoodIdentifiedGearTier;
    delete existingFilter.showExcellentIdentifiedJewellery;
    delete existingFilter.showGoodIdentifiedJewellery;
    delete existingFilter.showExcellentIdentifiedJewels;
    delete existingFilter.showGoodIdentifiedJewels;
    delete existingFilter.showExcellentIdentifiedCustomItems;
    delete existingFilter.showGoodIdentifiedCustomItems;

    if (poe1) return;

    this.migrateRemoveCustomMods(filter, ["Pirate's", "Dragon's", "of Excavation", "of Windfall"]);
    this.migrateRemovedIdentifiedItemCategories(filter, ["Melee Elemental", "Ranged Elemental", "Elemental Quivers"]);
    if (filter.showIdentifiedAttackWeaponCategories.includes(AttackWeaponsCategory.MeleeElemental)) {
      filter.showIdentifiedAttackWeaponCategories = filter.showIdentifiedAttackWeaponCategories.filter((c: AttackWeaponsCategory) => c !== AttackWeaponsCategory.MeleeElemental);
    }
    if (filter.showIdentifiedAttackWeaponCategories.includes(AttackWeaponsCategory.RangedElemental)) {
      filter.showIdentifiedAttackWeaponCategories = filter.showIdentifiedAttackWeaponCategories.filter((c: AttackWeaponsCategory) => c !== AttackWeaponsCategory.RangedElemental);
    }
    if (filter.showIdentifiedAttackWeaponCategories.length === 0) {
      filter.showIdentifiedAttackWeaponCategories = [AttackWeaponsCategory.All];
    }
    if (filter.showIdentifiedQuiverCategories.includes(QuiversCategory.ElementalQuivers)) {
      filter.showIdentifiedQuiverCategories = filter.showIdentifiedQuiverCategories.filter((c: QuiversCategory) => c !== QuiversCategory.ElementalQuivers);
    }
    if (filter.showIdentifiedQuiverCategories.length === 0) {
      filter.showIdentifiedQuiverCategories = [QuiversCategory.All];
    }
  }

  migrateTo136(filter: Filter) {
    const existingFilter = (filter as any);

    if (poe1) return;

    existingFilter.customRules.concat(existingFilter.customCosmeticRules).forEach((rule: CustomRule) => {
      if (rule.itemType === 'All Gear' || rule.itemType === 'All Weapons') {
        rule.filterItemClass += ' "Talismans"';
      }
    });

    this.migrateRemoveItemsFromCustomChanceBase(filter, ['Precursor Tablet', 'Ritual Precursor Tablet', 'Pronged Spear', 'Ashbark Talisman']);
    this.migrateRemoveItemsFromCustomEquipment(filter, ['OtherExcellentIdentifiedJewels']);
  }

  migrateTo135(filter: Filter) {
    const existingFilter = (filter as any);

    filter.salvagingItemsStyleOverride = new ItemTypeOverride({ name: 'Salvaging Gear', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
    }});

    if (filter.chanceBaseTierCosmetics[0]?.displayOptions.hidden === true) {
      filter.chanceBaseTierCosmetics[0].displayOptions.hidden = false;
      filter.chanceBaseTierCosmetics[0].displayOptions.active = false;
    }

    if (filter.chanceBaseTierCosmetics[1]?.displayOptions.hidden === true) {
      filter.chanceBaseTierCosmetics[1].displayOptions.hidden = false;
      filter.chanceBaseTierCosmetics[1].displayOptions.active = false;
    }

    filter.customEquipmentTiers.forEach((t: CustomTieredEquipment) => {
      if (t.equipmentType === 'OtherGearExcellentExceptional') {
        t.equipmentType = 'OtherGearExcellentExceptionalSocketed';
      } else if (t.equipmentType === 'OtherGearGoodExceptional') {
        t.equipmentType = 'OtherGearGoodExceptionalSocketed';
      }
    });

    filter.showLevelingGearIgnoreLevelDifferenceForSpecialWeaponTypes = true;

    filter.armourFilters.forEach((a: ArmourFilter) => {
      if (a.armourType.includes(ArmourType.All)) {
        a.armourType = [ArmourType.BodyArmours, ArmourType.Helmets, ArmourType.Gloves, ArmourType.Boots, ArmourType.Shields];
      }
    });

    if (poe1) return;

    this.migrateRemovedGear(filter, [{ type: 'Sceptres', baseTypes: ['Lupine Sceptre', 'Ochre Sceptre', 'Devouring Sceptre', 'Clasped Sceptre'] }]);
    this.migrateRemovedGear(filter, [{ type: 'Staves', baseTypes: ['Reflecting Staff', 'Spriggan Staff'] }]);
    this.migrateRemovedGear(filter, [{ type: 'Wands', baseTypes: ['Acrid Wand', 'Offering Wand', 'Critical Wand'] }]);
  }

  migrateTo133(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightVaalUniques = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.Red,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
     }
    });

    existingFilter.highlightVaalModUniques = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.Purple,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
     }
    });

    delete existingFilter.showDeliriumWaystones;
    this.removeEquipmentTypes(filter, ['ItemsWaystonesDelirium']);

    if (poe1) return;

    this.migrateRenamedCurrencyClasses(filter, [{ oldClass: 'Socketable', newClass: 'Augment' }]);
    this.migrateRenamedCurrencyTypes(filter, [{ oldType: 'Talismans', newType: 'Idols' }]);

    const renamedCurrency = [
      {
        type: 'Idols',
        baseTypes: [
          { old:"Talisman of Sirrius", new: "Idol of Sirrius" },
          { old:"Talisman of Thruldana", new: "Idol of Thruldana" },
          { old:"Talisman of Grold", new: "Idol of Grold" },
          { old:"Talisman of Eeshta", new: "Idol of Eeshta" },
          { old:"Talisman of Egrin", new: "Idol of Egrin" },
          { old:"Talisman of Maxarius", new: "Idol of Maxarius" },
          { old:"Talisman of Ralakesh", new: "Idol of Ralakesh" },
          { old:"Serpent Talisman", new: "Snake Idol" },
          { old:"Primate Talisman", new: "Primate Idol" },
          { old:"Owl Talisman", new: "Owl Idol" },
          { old:"Cat Talisman", new: "Cat Idol" },
          { old:"Wolf Talisman", new: "Wolf Idol" },
          { old:"Stag Talisman", new: "Stag Idol" },
          { old:"Boar Talisman", new: "Boar Idol" },
          { old:"Bear Talisman", new: "Bear Idol" },
          { old:"Ox Talisman", new: "Ox Idol" },
          { old:"Rabbit Talisman", new: "Rabbit Idol" },
          { old:"Fox Talisman", new: "Fox Idol" },
        ]
      },
      {
        type: 'Lineage Gems',
        baseTypes: [
          { old: "Piety's Mercy", new: "Dominus' Grasp" },
        ]
      }
    ];

    const removedCurrency = [
      { type: 'Omens', baseTypes: [ "Omen of Homogenising Exaltation", "Omen of Homogenising Coronation" ] },
      { type: 'Ancient Bones', baseTypes: [ "Preserved Vertebrae" ] },
      { type: 'Map Fragments', baseTypes: [ "Idol of Estazunti" ]}
    ];

    this.migrateRemovedCurrency(filter, removedCurrency);
    this.migrateRenamedCurrency(filter, renamedCurrency);
  }

  removeEquipmentTypes(filter: Filter, types: string[]) {
    filter.customEquipmentTiers = filter.customEquipmentTiers.filter((t: CustomTieredEquipment) => !types.includes(t.equipmentType));
  }

  migrateTo132(filter: Filter) {
    const existingFilter = (filter as any);

    if (existingFilter.hideGearOfRarity === Rarity.Rare) {
      if (existingFilter.hideGearByRarity) {
        filter.hideAllOtherGear = true;
        existingFilter.hideGearByRarity = false;
      }

      existingFilter.hideGearOfRarity = Rarity.Magic;
    }

    if (!filter.equipmentTieringMode) {
      filter.equipmentTieringMode = 'Subtle';
    }

    if (!filter.customEquipmentTiers) {
      filter.customEquipmentTiers = [];
    }

    if (!filter.equipmentTierCosmetics || filter.equipmentTierCosmetics.length === 0) {
      filter.equipmentTierCosmetics = createDefaultEquipmentTierCosmetics();
    }

    filter.weaponFilters.forEach((w: any) => {
      w.highlightConfig = new GearHighlightConfig();
    });

    filter.weaponFilters = filter.weaponFilters.filter((w: any) => w.rarityComparator === Comparator.GreaterThanOrEqual && !w.weaponType?.some((t: string) => t === 'All'));

    filter.armourFilters.forEach((a: any) => {
      a.highlightConfig = new GearHighlightConfig();
    });

    filter.armourFilters = filter.armourFilters.filter((a: any) => a.rarityComparator === Comparator.GreaterThanOrEqual);

    (filter.weaponFilters as (WeaponFilter | ArmourFilter)[]).concat(filter.armourFilters as (WeaponFilter | ArmourFilter)[]).forEach((item) => {
      if (item.rarity === Rarity.Magic) {
        item.highlightConfig.regularNormal = false;
      } else if (item.rarity === Rarity.Rare) {
        item.highlightConfig.regularNormal = false;
        item.highlightConfig.regularMagic = false;
        item.highlightConfig.magic = false;
        item.highlightConfig.lowTierMagic = false;
      }

      if (item.unidentifiedTier) {
        item.highlightConfig.rareMinTier = Math.max(item.highlightConfig.rareMinTier, item.unidentifiedTier);
        item.highlightConfig.magicMinTier = Math.max(item.highlightConfig.magicMinTier, item.unidentifiedTier);
        item.highlightConfig.lowTierRareMinTier = Math.max(item.highlightConfig.lowTierRareMinTier, item.unidentifiedTier);
        item.highlightConfig.lowTierMagicMinTier = Math.max(item.highlightConfig.lowTierMagicMinTier, item.unidentifiedTier);
      }

      if (item.baseTypeTier === BaseTypeTier.Basic) {
        item.highlightConfig.lowTierMagic = false;
        item.highlightConfig.lowTierRare = false;
      }

      delete (item as any).rarityComparator;
    });

    filter.jewelleryFilters = [];
    filter.jewelFilters = [];
    filter.flaskFilters = [];

    if (existingFilter.hideRingsBaseTypeExceptions && existingFilter.hideRingsBaseTypeExceptions.length > 0 && !existingFilter.hideRingsBaseTypeExceptions.includes('None')) {
      filter.jewelleryFilters.push(new JewelleryFilter({ jewelleryType: JewelleryType.Rings, jewelleryBaseTypes: existingFilter.hideRingsBaseTypeExceptions }));
    }
    if (existingFilter.hideAmuletsBaseTypeExceptions && existingFilter.hideAmuletsBaseTypeExceptions.length > 0 && !existingFilter.hideAmuletsBaseTypeExceptions.includes('None')) {
      filter.jewelleryFilters.push(new JewelleryFilter({ jewelleryType: JewelleryType.Amulets, jewelleryBaseTypes: existingFilter.hideAmuletsBaseTypeExceptions }));
    }
    if (existingFilter.hideTalismansBaseTypeExceptions && existingFilter.hideTalismansBaseTypeExceptions.length > 0 && !existingFilter.hideTalismansBaseTypeExceptions.includes('None')) {
      filter.jewelleryFilters.push(new JewelleryFilter({ jewelleryType: JewelleryType.Talismans, jewelleryBaseTypes: existingFilter.hideTalismansBaseTypeExceptions }));
    }
    if (existingFilter.hideBeltsBaseTypeExceptions && existingFilter.hideBeltsBaseTypeExceptions.length > 0 && !existingFilter.hideBeltsBaseTypeExceptions.includes('None')) {
      filter.jewelleryFilters.push(new JewelleryFilter({ jewelleryType: JewelleryType.Belts, jewelleryBaseTypes: existingFilter.hideBeltsBaseTypeExceptions }));
    }
    if (existingFilter.hideJewelsBaseTypeExceptions && existingFilter.hideJewelsBaseTypeExceptions.length > 0 && !existingFilter.hideJewelsBaseTypeExceptions.includes('None')) {
      filter.jewelFilters.push(new JewelFilter({ jewelType: existingFilter.hideJewelsBaseTypeExceptions.filter((type: string) => type !== 'Prismatic Jewel' && type !== 'Timeless Jewel' && type !== 'Diamond' && type !== 'Time-Lost Diamond') as JewelType[] }));
    }

    if (existingFilter.hideLifeFlasksBaseTypeExceptions && existingFilter.hideLifeFlasksBaseTypeExceptions.length > 0 && !existingFilter.hideLifeFlasksBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Life Flasks', flaskBaseTypes: existingFilter.hideLifeFlasksBaseTypeExceptions }));
    }
    if (existingFilter.hideManaFlasksBaseTypeExceptions && existingFilter.hideManaFlasksBaseTypeExceptions.length > 0 && !existingFilter.hideManaFlasksBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Mana Flasks', flaskBaseTypes: existingFilter.hideManaFlasksBaseTypeExceptions }));
    }
    if (existingFilter.hideHybridFlasksBaseTypeExceptions && existingFilter.hideHybridFlasksBaseTypeExceptions.length > 0 && !existingFilter.hideHybridFlasksBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Hybrid Flasks', flaskBaseTypes: existingFilter.hideHybridFlasksBaseTypeExceptions }));
    }
    if (existingFilter.hideUtilityFlasksBaseTypeExceptions && existingFilter.hideUtilityFlasksBaseTypeExceptions.length > 0 && !existingFilter.hideUtilityFlasksBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Utility Flasks', flaskBaseTypes: existingFilter.hideUtilityFlasksBaseTypeExceptions }));
    }
    if (existingFilter.hideTincturesBaseTypeExceptions && existingFilter.hideTincturesBaseTypeExceptions.length > 0 && !existingFilter.hideTincturesBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Tinctures', flaskBaseTypes: existingFilter.hideTincturesBaseTypeExceptions }));
    }
    if (existingFilter.hideCharmsBaseTypeExceptions && existingFilter.hideCharmsBaseTypeExceptions.length > 0 && !existingFilter.hideCharmsBaseTypeExceptions.includes('None')) {
      filter.flaskFilters.push(new FlaskFilter({ flaskClass: 'Charms', flaskBaseTypes: existingFilter.hideCharmsBaseTypeExceptions }));
    }

    if (existingFilter.highlightJewels?.displayOptions?.active && existingFilter.highlightJewelsTypes?.length > 0 && !existingFilter.highlightJewelsTypes?.includes('All')) {
      // We had jewel highlights set. Add them to our new filter.jewelFilters, or create one if needed
      if (filter.jewelFilters.length === 0) {
        filter.jewelFilters.push(new JewelFilter({ jewelType: existingFilter.highlightJewelsTypes as JewelType[], rarity: existingFilter.highlightJewelsRarity as Rarity }));
      } else {
        filter.jewelFilters[0].jewelType = Array.from(new Set([...filter.jewelFilters[0].jewelType, ...(existingFilter.highlightJewelsTypes as JewelType[])]));
      }
    }

    if (existingFilter.highlightRareBreachRings?.displayOptions?.active || existingFilter.highlightOtherBreachRings?.displayOptions?.active) {
      if (!filter.jewelleryFilters.find((j: any) => j.jewelleryType === JewelleryType.Rings)) {
        filter.jewelleryFilters.push(new JewelleryFilter({
          jewelleryType: JewelleryType.Rings,
          jewelleryBaseTypes: ['Breach Ring'],
          rarity: existingFilter.highlightOtherBreachRings?.displayOptions?.active ? Rarity.Normal : Rarity.Rare,
          highlightConfig: new JewelleryHighlightConfig()
        }));
      } else {
        const ringFilter = filter.jewelleryFilters.find((j: any) => j.jewelleryType === JewelleryType.Rings)!;
        ringFilter.jewelleryBaseTypes = Array.from(new Set([...ringFilter.jewelleryBaseTypes, 'Breach Ring']));
      }
    }

    filter.jewelleryFilters.forEach((item: any) => {
      if (item.rarity === Rarity.Magic) {
        item.highlightConfig.regularNormal = false;
      } else if (item.rarity === Rarity.Rare) {
        item.highlightConfig.regularNormal = false;
        item.highlightConfig.regularMagic = false;
        item.highlightConfig.magic = false;
      }
    });

    filter.jewelFilters.forEach((item: any) => {
      if (item.rarity === Rarity.Normal) item.Rarity = Rarity.Magic;
      if (item.rarity === Rarity.Rare) {
        item.highlightConfig.regularMagic = false;
      }
    });

    // Migrate old highlights to new booleans

    // POE2
    filter.showExcellentExceptionalSocketedGear = existingFilter.highlightExcellentExceptionalSocketedGear?.displayOptions?.active ?? true;
    filter.showGoodExceptionalSocketedGear = existingFilter.highlightGoodExceptionalSocketedGear?.displayOptions?.active ?? true;
    filter.showGoodExceptionalSocketedGearMinBaseTypeTier = existingFilter.highlightGoodExceptionalSocketedGearMinBaseTypeTier;
    filter.showExcellentExceptionalQualityGear = existingFilter.highlightExcellentExceptionalQualityGear?.displayOptions?.active ?? true;
    filter.showGoodExceptionalQualityGear = existingFilter.highlightGoodExceptionalQualityGear?.displayOptions?.active ?? true;
    filter.showGoodExceptionalQualityGearMinQuality = existingFilter.highlightGoodExceptionalQualityGearMinQuality;
    filter.showILevel82NormalGear = existingFilter.highlightILevel82NormalGear?.displayOptions?.active ?? true;
    filter.showILevel82NormalGearMinBaseTypeTier = existingFilter.highlightILevel82NormalGearMinBaseTypeTier;
    filter.showILevel81NormalGear = existingFilter.highlightILevel81NormalGear?.displayOptions?.active ?? true;
    filter.showILevel81NormalGearMinBaseTypeTier = existingFilter.highlightILevel81NormalGearMinBaseTypeTier;
    const highILevelJewelleryActive = existingFilter.highlightHighILevelJewellery?.displayOptions?.active ?? true;
    filter.showExcellentJewelleryBaseTypes = highILevelJewelleryActive;
    filter.showGoodJewelleryBaseTypes = highILevelJewelleryActive;
    filter.showExcellentJewelleryBaseTypesMinItemLevel = existingFilter.highlightHighILevelJewelleryMinILevel;
    filter.showHighILevelCharms = existingFilter.highlightHighILevelCharms?.displayOptions?.active ?? true;
    filter.showHighILevelCharmsMinILevel = existingFilter.highlightHighILevelCharmsMinILevel;
    filter.showHighILevelCharmTypes = existingFilter.highlightHighILevelCharmTypes;

    delete existingFilter.highlightExcellentExceptionalSocketedGear;
    delete existingFilter.highlightGoodExceptionalSocketedGear;
    delete existingFilter.highlightGoodExceptionalSocketedGearMinBaseTypeTier;
    delete existingFilter.highlightExcellentExceptionalQualityGear;
    delete existingFilter.highlightGoodExceptionalQualityGear;
    delete existingFilter.highlightGoodExceptionalQualityGearMinQuality;
    delete existingFilter.highlightILevel82NormalGear;
    delete existingFilter.highlightILevel82NormalGearMinBaseTypeTier;
    delete existingFilter.highlightILevel81NormalGear;
    delete existingFilter.highlightILevel81NormalGearMinBaseTypeTier;
    delete existingFilter.highlightHighILevelJewellery;
    delete existingFilter.highlightHighILevelJewelleryMinILevel;
    delete existingFilter.highlightHighILevelCharms;
    delete existingFilter.highlightHighILevelCharmsMinILevel;
    delete existingFilter.highlightHighILevelCharmTypes;

    // POE1
    filter.showInfluencedJewellery = existingFilter.highlightInfluencedJewellery?.displayOptions?.active ?? true;
    filter.showFracturedJewellery = existingFilter.highlightFracturedJewellery?.displayOptions?.active ?? true;
    (filter as any).showSynthesisedJewellery = existingFilter.highlightSynthesisedJewellery?.displayOptions?.active ?? true;
    filter.showVeiledJewellery = existingFilter.highlightVeiledJewellery?.displayOptions?.active ?? true;
    filter.showVeiledJewelleryOfSyndicateMembers = existingFilter.highlightVeiledJewelleryOfSyndicateMembers;
    filter.showMemoryStrandJewellery = existingFilter.highlightMemoryStrandJewellery?.displayOptions?.active ?? true;
    filter.showMemoryStrandJewelleryMinStrands = existingFilter.highlightMemoryStrandJewelleryMinStrands;
    filter.showCorruptedImplicitJewels = existingFilter.highlightCorruptedImplicitJewels?.displayOptions?.active ?? true;
    filter.showCorruptedImplicitJewelsTypes = existingFilter.highlightCorruptedImplicitJewelsTypes;
    filter.showCorruptedImplicitJewelsMinImplicits = existingFilter.highlightCorruptedImplicitJewelsMinImplicits;
    filter.showCorruptedImplicitJewelsMinExplicits = existingFilter.highlightCorruptedImplicitJewelsMinExplicits;
    filter.showExcellentClusterJewelBases = existingFilter.highlightExcellentClusterJewelBases?.displayOptions?.active ?? true;
    filter.showGoodClusterJewelBases = existingFilter.highlightGoodClusterJewelBases?.displayOptions?.active ?? true;

    delete existingFilter.highlightInfluencedJewellery;
    delete existingFilter.highlightFracturedJewellery;
    delete existingFilter.highlightSynthesisedJewellery;
    delete existingFilter.highlightVeiledJewellery;
    delete existingFilter.highlightVeiledJewelleryOfSyndicateMembers;
    delete existingFilter.highlightMemoryStrandJewellery;
    delete existingFilter.highlightMemoryStrandJewelleryMinStrands;
    delete existingFilter.highlightCorruptedImplicitJewels;
    delete existingFilter.highlightCorruptedImplicitJewelsTypes;
    delete existingFilter.highlightCorruptedImplicitJewelsMinImplicits;
    delete existingFilter.highlightCorruptedImplicitJewelsMinExplicits;
    delete existingFilter.highlightExcellentClusterJewelBases;
    delete existingFilter.highlightGoodClusterJewelBases;

    // Identified items
    existingFilter.showExcellentIdentifiedGear = existingFilter.highlightExcellentIdentifiedGear?.displayOptions?.active ?? true;
    existingFilter.showGoodIdentifiedGear = existingFilter.highlightGoodIdentifiedGear?.displayOptions?.active ?? true;
    existingFilter.showExcellentIdentifiedGearTier = existingFilter.highlightExcellentIdentifiedGearTier ?? existingFilter.showExcellentIdentifiedGearTier;
    existingFilter.showGoodIdentifiedGearTier = existingFilter.highlightGoodIdentifiedGearTier ?? existingFilter.showGoodIdentifiedGearTier;
    existingFilter.showIdentifiedAttackWeaponCategories = existingFilter.highlightIdentifiedAttackWeaponCategories ?? filter.showIdentifiedAttackWeaponCategories;
    existingFilter.showIdentifiedAttackWeaponTypes = existingFilter.highlightIdentifiedAttackWeaponTypes ?? filter.showIdentifiedAttackWeaponTypes;
    existingFilter.showIdentifiedCasterWeaponCategories = existingFilter.highlightIdentifiedCasterWeaponCategories ?? filter.showIdentifiedCasterWeaponCategories;
    existingFilter.showIdentifiedGemWeaponCategories = existingFilter.highlightIdentifiedGemWeaponCategories ?? filter.showIdentifiedGemWeaponCategories;
    existingFilter.showIdentifiedQuiverCategories = existingFilter.highlightIdentifiedQuiverCategories ?? filter.showIdentifiedQuiverCategories;
    existingFilter.showIdentifiedLifeArmourCategories = existingFilter.highlightIdentifiedLifeArmourCategories ?? filter.showIdentifiedLifeArmourCategories;
    existingFilter.showIdentifiedLifeArmourTypesDefenceTypes = existingFilter.highlightIdentifiedLifeArmourTypesDefenceTypes ?? filter.showIdentifiedLifeArmourTypesDefenceTypes;
    existingFilter.showIdentifiedEnergyShieldArmourCategories = existingFilter.highlightIdentifiedEnergyShieldArmourCategories ?? filter.showIdentifiedEnergyShieldArmourCategories;
    existingFilter.showIdentifiedEnergyShieldArmourTypesDefenceTypes = existingFilter.highlightIdentifiedEnergyShieldArmourTypesDefenceTypes ?? filter.showIdentifiedEnergyShieldArmourTypesDefenceTypes;
    existingFilter.showExcellentIdentifiedJewellery = existingFilter.highlightExcellentIdentifiedJewellery?.displayOptions?.active ?? true;
    existingFilter.showGoodIdentifiedJewellery = existingFilter.highlightGoodIdentifiedJewellery?.displayOptions?.active ?? true;
    existingFilter.showIdentifiedJewelleryCategories = existingFilter.highlightIdentifiedJewelleryCategories ?? filter.showIdentifiedJewelleryCategories;
    existingFilter.showExcellentIdentifiedJewels = existingFilter.highlightExcellentIdentifiedJewels?.displayOptions?.active ?? true;
    existingFilter.showGoodIdentifiedJewels = existingFilter.highlightGoodIdentifiedJewels?.displayOptions?.active ?? true;
    existingFilter.showIdentifiedJewelCategories = existingFilter.highlightIdentifiedJewelCategories ?? filter.showIdentifiedJewelCategories;
    existingFilter.showIdentifiedAbyssJewelCategories = existingFilter.highlightIdentifiedAbyssJewelCategories ?? filter.showIdentifiedAbyssJewelCategories;
    existingFilter.showExcellentIdentifiedCustomItems = existingFilter.highlightExcellentIdentifiedCustomItems?.displayOptions?.active ?? true;
    existingFilter.showGoodIdentifiedCustomItems = existingFilter.highlightGoodIdentifiedCustomItems?.displayOptions?.active ?? true;

    delete existingFilter.highlightExcellentIdentifiedGear;
    delete existingFilter.highlightGoodIdentifiedGear;
    delete existingFilter.highlightExcellentIdentifiedGearTier;
    delete existingFilter.highlightGoodIdentifiedGearTier;
    delete existingFilter.highlightIdentifiedAttackWeaponCategories;
    delete existingFilter.highlightIdentifiedAttackWeaponTypes;
    delete existingFilter.highlightIdentifiedCasterWeaponCategories;
    delete existingFilter.highlightIdentifiedGemWeaponCategories;
    delete existingFilter.highlightIdentifiedQuiverCategories;
    delete existingFilter.highlightIdentifiedLifeArmourCategories;
    delete existingFilter.highlightIdentifiedLifeArmourTypesDefenceTypes;
    delete existingFilter.highlightIdentifiedEnergyShieldArmourCategories;
    delete existingFilter.highlightIdentifiedEnergyShieldArmourTypesDefenceTypes;
    delete existingFilter.highlightExcellentIdentifiedJewellery;
    delete existingFilter.highlightGoodIdentifiedJewellery;
    delete existingFilter.highlightIdentifiedJewelleryCategories;
    delete existingFilter.highlightExcellentIdentifiedJewels;
    delete existingFilter.highlightGoodIdentifiedJewels;
    delete existingFilter.highlightIdentifiedJewelCategories;
    delete existingFilter.highlightIdentifiedAbyssJewelCategories;
    delete existingFilter.highlightExcellentIdentifiedCustomItems;
    delete existingFilter.highlightGoodIdentifiedCustomItems;

    // POE1 Crafting bases
    filter.showWeaponCraftingBasesClasses = existingFilter.highlightWeaponCraftingBasesClasses ?? filter.showWeaponCraftingBasesClasses;
    filter.showWeaponCraftingBasesMinItemLevel = existingFilter.highlightWeaponCraftingBasesMinItemLevel ?? filter.showWeaponCraftingBasesMinItemLevel;
    filter.showExcellentWeaponCraftingBases = existingFilter.highlightExcellentWeaponCraftingBases?.displayOptions?.active ?? true;
    filter.showGoodWeaponCraftingBases = existingFilter.highlightGoodWeaponCraftingBases?.displayOptions?.active ?? true;
    filter.showArmourCraftingBasesTypes = existingFilter.highlightArmourCraftingBasesTypes ?? filter.showArmourCraftingBasesTypes;
    filter.showArmourCraftingBasesMinItemLevel = existingFilter.highlightArmourCraftingBasesMinItemLevel ?? filter.showArmourCraftingBasesMinItemLevel;
    filter.showExcellentArmourCraftingBases = existingFilter.highlightExcellentArmourCraftingBases?.displayOptions?.active ?? true;
    filter.showGoodArmourCraftingBases = existingFilter.highlightGoodArmourCraftingBases?.displayOptions?.active ?? true;

    delete existingFilter.highlightWeaponCraftingBasesClasses;
    delete existingFilter.highlightWeaponCraftingBasesMinItemLevel;
    delete existingFilter.highlightExcellentWeaponCraftingBases;
    delete existingFilter.highlightGoodWeaponCraftingBases;
    delete existingFilter.highlightArmourCraftingBasesTypes;
    delete existingFilter.highlightArmourCraftingBasesMinItemLevel;
    delete existingFilter.highlightExcellentArmourCraftingBases;
    delete existingFilter.highlightGoodArmourCraftingBases;

    delete existingFilter.showLinkedGear;
    delete existingFilter.showLinkedGearMinLinks;
    delete existingFilter.showLinkedGearCustomSocketGroup;

    filter.showTieredRareJewellery = true;
    filter.showTieredRareJewelleryMinTier = 3;
    filter.showTieredRareJewelleryTypes = [JewelleryType.All];
    filter.showTieredRareJewelleryMinIlevel = null;

    filter.showTieredMagicJewellery = true;
    filter.showTieredMagicJewelleryMinTier = 4;
    filter.showTieredMagicJewelleryTypes = [JewelleryType.All];
    filter.showTieredMagicJewelleryMinIlevel = null;

    filter.showLowTierTieredRareGear = true;
    filter.showLowTierTieredRareGearMinTier = 4;

    filter.showLowTierTieredMagicGear = true;
    filter.showLowTierTieredMagicGearMinTier = 5;

    delete existingFilter.hideRingsBaseTypeExceptions;
    delete existingFilter.hideAmuletsBaseTypeExceptions;
    delete existingFilter.hideTalismansBaseTypeExceptions; // POE1
    delete existingFilter.hideBeltsBaseTypeExceptions;
    delete existingFilter.hideJewelsBaseTypeExceptions;

    // Delete removed highlight properties
    delete existingFilter.highlightRareJewellery;
    delete existingFilter.highlightRareJewelleryMinTier;
    delete existingFilter.highlightExceptionalWeaponAndArmourExceptions;
    delete existingFilter.highlightExceptionalWeaponAndArmourExceptionsMinQuality;
    delete existingFilter.highlightRareWeaponAndArmourExceptions;
    delete existingFilter.highlightRareWeaponAndArmourExceptionsMinTier;
    delete existingFilter.highlight6LinkWeaponAndArmourExceptions;
    delete existingFilter.highlightOtherWeaponAndArmourExceptions;
    delete existingFilter.highlightJewels;
    delete existingFilter.highlightJewelsTypes;
    delete existingFilter.highlightJewelsRarity;
    delete existingFilter.highlightRareBreachRings;
    delete existingFilter.highlightOtherBreachRings;

    filter.showHighILevelFlasks = false; // POE1
    filter.showHighILevelFlasksMinILevel = 84; // POE1
    filter.showHighILevelFlaskTypes = ['All']; // POE1

    filter.showQualityCharms = true; // POE2
    filter.showQualityCharmsMinQuality = 1; // POE2

    (existingFilter.customRules.concat(existingFilter.customCosmeticRules)).forEach((rule: any) => {
      if (rule.advancedConditions && rule.advancedConditions.clusterJewelPassives && !rule.advancedConditions.minClusterJewelPassives) {
        rule.advancedConditions.minClusterJewelPassives = rule.advancedConditions.clusterJewelPassives;
        delete rule.advancedConditions.clusterJewelPassives;
      }

      if (rule.advancedConditions && rule.advancedConditions.waystoneTier && !rule.advancedConditions.waystoneMaxTier) {
        if (rule.advancedConditions.waystoneTierComparator === Comparator.GreaterThanOrEqual) {
          rule.advancedConditions.waystoneMinTier = rule.advancedConditions.waystoneTier;
        } else if (rule.advancedConditions.waystoneTierComparator === Comparator.LessThanOrEqual) {
          rule.advancedConditions.waystoneMaxTier = rule.advancedConditions.waystoneTier;
        } else {
          rule.advancedConditions.waystoneMinTier = rule.advancedConditions.waystoneTier;
          rule.advancedConditions.waystoneMaxTier = rule.advancedConditions.waystoneTier;
        }
        delete rule.advancedConditions.waystoneTier;
        delete rule.advancedConditions.waystoneTierComparator;
      }
    });

    existingFilter.customRules.forEach((rule: any) => {
      if (rule?.displayOptions?.displayType === 'TierHighlight') {
        rule.displayOptions.displayType = DisplayType.EquipmentTier;
      }

      if (rule?.displayOptions?.displayTypeTierHighlightType === 'Waystone') {
        rule.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Map;
      } else if (rule?.displayOptions?.displayTypeTierHighlightType === 'SkillGem') {
        rule.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Gem;
      }
    });

    delete existingFilter.hideLifeFlasksBaseTypeExceptions;
    delete existingFilter.hideLifeFlasksBaseTypeExceptionsMinQuality;
    delete existingFilter.hideManaFlasksBaseTypeExceptions;
    delete existingFilter.hideManaFlasksBaseTypeExceptionsMinQuality;
    delete existingFilter.hideHybridFlasksBaseTypeExceptions;
    delete existingFilter.hideHybridFlasksBaseTypeExceptionsMinQuality;
    delete existingFilter.hideUtilityFlasksBaseTypeExceptions;
    delete existingFilter.hideUtilityFlasksBaseTypeExceptionsMinQuality;
    delete existingFilter.hideTincturesBaseTypeExceptions;
    delete existingFilter.hideTincturesBaseTypeExceptionsMinQuality;
    delete existingFilter.hideCharmsQuality;
    delete existingFilter.hideCharmsBaseTypeExceptions;

    // Leveling settings

    filter.showLevelingGear = existingFilter.showLevelingGear || existingFilter.showLevelingWeapons;
    filter.showLevelingGearMinAreaLevel = null;

    filter.showLevelingGearExcellentSocketed = true; // POE1
    (filter as any).showLevelingGearExcellentSocketGroup = existingFilter.showLevelingWeaponSocketGroup; // POE1 (removed in migrateTo175)
    filter.showLevelingGearExcellentSocketedDifference = null; // POE1
    filter.showLevelingGearOtherSocketed = true; // POE1
    (filter as any).showLevelingGearOtherSocketGroup = null; // POE1 (removed in migrateTo175)
    filter.showLevelingGearOtherSocketedLevelDifference = 10; // POE1

    filter.showLevelingGearNormal = true;
    filter.showLevelingGearNormalLevelDifference = 5;

    filter.showLevelingGearMagic = true;
    filter.showLevelingGearMagicLevelDifference = 5;

    filter.showLevelingGearRare = true;
    filter.showLevelingGearRareLevelDifference = 20;

    filter.showLevelingGearWeapons = existingFilter.showLevelingWeapons;
    filter.showLevelingGearWeaponClasses = existingFilter.showLevelingWeaponClasses;

    filter.showLevelingGearArmour = existingFilter.showLevelingArmour;
    filter.showLevelingGearArmourDefenceTypes = existingFilter.showLevelingArmourDefenceTypes;

    filter.showLevelingFlasks = existingFilter.hideFlasksByAreaLevel;
    filter.showLevelingFlasksAlwaysHideHybrid = true;

    delete existingFilter.showLevelingWeapons;
    delete existingFilter.showLevelingWeaponClasses;
    delete existingFilter.showLevelingWeaponSocketGroup;
    delete existingFilter.showLevelingArmour;
    delete existingFilter.showLevelingArmourDefenceTypes;
    delete existingFilter.showLevelingArmourSocketGroup;
    delete existingFilter.hideFlasksByAreaLevel;

    const dummyFilter = new Filter();
    filter.groupVisibility = dummyFilter.groupVisibility;
    filter.sectionVisibility = dummyFilter.sectionVisibility;

    filter.identifiedItemsStyleOverride = new ItemTypeOverride({ name: 'Identified Equipment', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
    }});

    if (existingFilter.highlightIdentifiedItemsLabelStyleOverride && existingFilter.highlightIdentifiedItemsLabelStyleOverride.displayOptions.active) {
      Object.assign(filter.identifiedItemsStyleOverride.displayOptions, existingFilter.highlightIdentifiedItemsLabelStyleOverride.displayOptions);
    }

    filter.craftingBasesStyleOverride = new ItemTypeOverride({ name: 'Crafting Bases', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ textColor: poe1 ? "rgb(200,200,200)" : undefined, minimapIconShape: MinimapIconShape.Kite })
    }});

    if (poe1 && existingFilter.highlightCraftingBasesLabelStyleOverride && existingFilter.highlightCraftingBasesLabelStyleOverride.displayOptions.active) {
      Object.assign(filter.craftingBasesStyleOverride.displayOptions, existingFilter.highlightCraftingBasesLabelStyleOverride.displayOptions);
    }

    filter.unidentifiedItemsStyleOverride = new ItemTypeOverride({ name: 'Unidentified Equipment', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
    }});

    filter.levelingItemsStyleOverride = new ItemTypeOverride({ name: 'Leveling Gear', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite, fontSize: LabelSize.Larger })
    }});

    filter.myItemsStyleOverride = new ItemTypeOverride({ name: 'Favourite Equipment', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.UpsideDownHouse })
    }});

    filter.gemStyleOverride = new ItemTypeOverride({ name: 'Gems', displayOptions: {
      active: true,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Circle })
    }});

    filter.mapStyleOverride = new ItemTypeOverride({ name: poe1 ? 'Maps' : 'Waystones', displayOptions: {
      active: true,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Diamond })
    }});

    filter.goldStyleOverride = new ItemTypeOverride({ name: 'Gold', displayOptions: {
      active: true,
      cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Star })
    }});

    delete existingFilter.highlightCraftingBasesLabelStyleOverride;
    delete existingFilter.highlightIdentifiedItemsLabelStyleOverride;

    if (poe1) {
      // Migrate 'All' to 'All Veiled' in veiledOfSyndicateMembers arrays
      const migrateAllToAllVeiled = (arr?: string[]) =>
        arr ? arr.map(member => member === 'All' ? 'All Veiled' : member) : arr;

      if (filter.showVeiledGearOfSyndicateMembers) {
        filter.showVeiledGearOfSyndicateMembers = migrateAllToAllVeiled(filter.showVeiledGearOfSyndicateMembers) || ['All Members'];
      }
      if (filter.showVeiledJewelleryOfSyndicateMembers) {
        filter.showVeiledJewelleryOfSyndicateMembers = migrateAllToAllVeiled(filter.showVeiledJewelleryOfSyndicateMembers) || ['All Members'];
      }
      filter.weaponFilters.forEach((w: any) => {
        if (w.veiledOfSyndicateMembers) {
          w.veiledOfSyndicateMembers = migrateAllToAllVeiled(w.veiledOfSyndicateMembers);
        }
      });
      filter.armourFilters.forEach((a: any) => {
        if (a.veiledOfSyndicateMembers) {
          a.veiledOfSyndicateMembers = migrateAllToAllVeiled(a.veiledOfSyndicateMembers);
        }
      });
    }

    // Migrate remaining highlights to show properties (equipment tier system)

    // POE2 Trial Items
    filter.showTrialItems = existingFilter.highlightTrialItems?.displayOptions?.active ?? true;
    delete existingFilter.highlightTrialItems;

    // POE1 Other Highlights
    existingFilter.showGrafts = existingFilter.highlightGrafts?.displayOptions?.active ?? true;
    existingFilter.showGraftsMinQuality = existingFilter.highlightGraftsMinQuality;
    existingFilter.showGraftsMinILevel = existingFilter.highlightGraftsMinILevel;
    existingFilter.showGraftsMinRarity = existingFilter.highlightGraftsMinRarity;
    existingFilter.showGraftsTypes = existingFilter.highlightGraftsTypes;
    delete existingFilter.highlightGrafts;
    delete existingFilter.highlightGraftsMinQuality;
    delete existingFilter.highlightGraftsMinILevel;
    delete existingFilter.highlightGraftsMinRarity;
    delete existingFilter.highlightGraftsTypes;

    // POE1 Heist Items
    filter.showHeistBlueprints = (existingFilter.highlightHeistBlueprints?.displayOptions?.active && !existingFilter.highlightHeistBlueprints?.displayOptions?.hidden) ?? true;
    filter.showHeistContracts = (existingFilter.highlightHeistContracts?.displayOptions?.active && !existingFilter.highlightHeistContracts?.displayOptions?.hidden) ?? true;
    filter.showHeistLocations = existingFilter.highlightHeistLocations;
    filter.showRoguesMarkers = (existingFilter.highlightRoguesMarkers?.displayOptions?.active && !existingFilter.highlightRoguesMarkers?.displayOptions?.hidden) ?? true;
    delete existingFilter.highlightHeistBlueprints;
    delete existingFilter.highlightHeistContracts;
    delete existingFilter.highlightHeistLocations;
    delete existingFilter.highlightRoguesMarkers;

    // POE1 6-Linked Items
    filter.show6LinkedGear = existingFilter.highlight6LinkedItems?.displayOptions?.active ?? true;
    delete existingFilter.highlight6LinkedItems;

    // POE1 Restricted Mod Identified Items
    filter.showRestrictedModIdentifiedItems = existingFilter.highlightRestrictedModIdentifiedItems?.displayOptions?.active ?? true;
    filter.showRestrictedModIdentifiedItemsGearTier = existingFilter.highlightRestrictedModIdentifiedItemsGearTier;
    filter.showRestrictedModIdentifiedItemsWeaponTypes = existingFilter.highlightRestrictedModIdentifiedItemsWeaponTypes;
    filter.showRestrictedModIdentifiedItemsDefenceTypes = existingFilter.highlightRestrictedModIdentifiedItemsDefenceTypes;
    filter.showRestrictedModIdentifiedItemsDelve = existingFilter.highlightRestrictedModIdentifiedItemsDelve;
    filter.showRestrictedModIdentifiedItemsIncursion = existingFilter.highlightRestrictedModIdentifiedItemsIncursion;
    filter.showRestrictedModIdentifiedItemsBreach = existingFilter.highlightRestrictedModIdentifiedItemsBreach;
    delete existingFilter.highlightRestrictedModIdentifiedItems;
    delete existingFilter.highlightRestrictedModIdentifiedItemsGearTier;
    delete existingFilter.highlightRestrictedModIdentifiedItemsWeaponTypes;
    delete existingFilter.highlightRestrictedModIdentifiedItemsDefenceTypes;
    delete existingFilter.highlightRestrictedModIdentifiedItemsDelve;
    delete existingFilter.highlightRestrictedModIdentifiedItemsIncursion;
    delete existingFilter.highlightRestrictedModIdentifiedItemsBreach;

    // POE1 Gems
    filter.showTopTierAwakenedGems = existingFilter.highlightTopTierAwakenedGems?.displayOptions?.active ?? true;
    existingFilter.showOtherAwakenedGems = existingFilter.highlightOtherAwakenedGems?.displayOptions?.active ?? true;
    filter.showTopTierSpecialSupportGems = existingFilter.highlightTopTierSpecialSupportGems?.displayOptions?.active ?? true;
    existingFilter.showOtherSpecialSupportGems = existingFilter.highlightOtherSpecialSupportGems?.displayOptions?.active ?? true;
    filter.showLvl21Gems = existingFilter.highlightLvl21Gems?.displayOptions?.active ?? true;
    filter.showLevelGems = existingFilter.highlightLevelGems?.displayOptions?.active ?? true;
    filter.showLevelGemsMinLevel = existingFilter.highlightLevelGemsMinLevel ?? 18;
    existingFilter.showOtherLevelGems = existingFilter.highlightOtherLevelGems?.displayOptions?.active ?? true;
    filter.showQuality23Gems = existingFilter.highlightQuality23Gems?.displayOptions?.active ?? true;
    filter.showQualityGems = existingFilter.highlightQualityGems?.displayOptions?.active ?? true;
    filter.showQualityGemsMinQuality = existingFilter.highlightQualityGemsMinQuality ?? 10;
    filter.showOtherQualityGems = existingFilter.highlightOtherQualityGems?.displayOptions?.active ?? true;
    filter.showSearchedGems = existingFilter.highlightSearchedGems?.displayOptions?.active ?? true;
    filter.showSearchedGemTypes = existingFilter.highlightSearchedGemTypes ?? ['None'];
    delete existingFilter.highlightTopTierAwakenedGems;
    delete existingFilter.highlightOtherAwakenedGems;
    delete existingFilter.highlightTopTierSpecialSupportGems;
    delete existingFilter.highlightOtherSpecialSupportGems;
    delete existingFilter.highlightLvl21Gems;
    delete existingFilter.highlightLevelGems;
    delete existingFilter.highlightLevelGemsMinLevel;
    delete existingFilter.highlightOtherLevelGems;
    delete existingFilter.highlightQuality23Gems;
    delete existingFilter.highlightQualityGems;
    delete existingFilter.highlightQualityGemsMinQuality;
    delete existingFilter.highlightOtherQualityGems;
    delete existingFilter.highlightSearchedGems;
    delete existingFilter.highlightSearchedGemTypes;

    // POE2 Waystones
    filter.showRareWaystones = existingFilter.highlightRareWaystones?.displayOptions?.active ?? true;
    existingFilter.showDeliriumWaystones = existingFilter.highlightDeliriumWaystones?.displayOptions?.active ?? true;
    filter.showOtherWaystones = existingFilter.highlightOtherWaystones?.displayOptions?.active ?? true;
    delete existingFilter.highlightRareWaystones;
    delete existingFilter.highlightDeliriumWaystones;
    delete existingFilter.highlightOtherWaystones;

    // Gold Stacks
    filter.showLargeGoldStacks = existingFilter.highlightLargeGoldStacks?.displayOptions?.active ?? true;
    filter.showLargeGoldStacksMinStackSize = filter.hideGoldLowerThan ? filter.hideGoldLowerThan * 20 : 500;
    filter.showHugeGoldStacks = existingFilter.highlightHugeGoldStacks?.displayOptions?.active ?? true;
    filter.showHugeGoldStacksMinStackSize = filter.hideGoldLowerThan ? filter.hideGoldLowerThan * 100 : 2000;
    delete existingFilter.highlightLargeGoldStacks;
    delete existingFilter.highlightHugeGoldStacks;

    filter.mapTypesT17Corrupted = true;
    filter.mapTypesT16MemoryInfluencedCorrupted = true;
    filter.mapTypesBlightRavagedCorrupted = true;

    filter.divCardCosmeticsSameAsTierCosmetics = false;
    filter.divCardCosmeticsSameAsTierCosmeticsOverrides = new ItemTypeOverride({ name: 'Divination Cards', displayOptions: {
      active: false,
      cosmeticOptions: new CosmeticOptions( { minimapIconShape: MinimapIconShape.Square })
    }});
    filter.equipmentCosmeticsSameAsTierCosmetics = false;
    filter.equipmentCosmeticsSameAsTierCosmeticsOverrides = new ItemTypeOverride({ name: 'Equipment', displayOptions: {
      active: true,
      cosmeticOptions: new CosmeticOptions( { minimapIconShape: MinimapIconShape.Kite })
    }});

    delete existingFilter.cosmeticSettings.highlightOverrideMinimapIcons;
    delete existingFilter.cosmeticSettings.highlightMinimapIconShapeItems;
    delete existingFilter.cosmeticSettings.highlightMinimapIconShapeWaystones;
    delete existingFilter.cosmeticSettings.highlightCopySoundSettings;
    delete existingFilter.cosmeticSettings.highlightCopyLabelSettings;
    delete existingFilter.cosmeticSettings.highlightCopyVisibility;

    filter.showExcellentGearBaseTypes = true; // POE1
    filter.showExcellentGearBaseTypesMinItemLevel = 83; // POE1
    filter.showGoodGearBaseTypes = true; // POE1
    filter.showGoodGearBaseTypesMinItemLevel = 83; // POE1
    filter.showExcellentJewelleryBaseTypes = true;
    filter.showExcellentJewelleryBaseTypesMinItemLevel = null;
    filter.showGoodJewelleryBaseTypes = true;
    filter.showGoodJewelleryBaseTypesMinItemLevel = null;
    filter.showOtherSpecialJewelleryBaseTypes = true;
    filter.showOtherSpecialJewelleryBaseTypesMinItemLevel = 85;
    filter.showOtherSpecialJewelleryBaseTypesTypes = ['All'];

    filter.showVendoringMagics = poe1 ? false : filter.progressPreset === 'presetEarlyCampaign1' ? true : false;
    filter.showVendoringMagicsSize = GearSizeType.TwoByTwoOnly;
    existingFilter.showVendoringMagicsStyle = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: new CosmeticOptions({
        textColor: poe1 ? 'rgba(136,136,255,0.6)' : 'rgba(122,151,254,0.6)',
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
      })
    }});

    if (poe2) {
      filter.showLevelingGear = filter.progressPreset === 'presetEarlyCampaign1' || filter.progressPreset === 'presetMidCampaign30';
      filter.showLevelingGearWeapons = filter.showLevelingGear;
      filter.showLevelingGearArmour = filter.showLevelingGear;
      filter.showVendoringRares = filter.showLevelingGear;
    }
  }

  migrateTo130(filter: Filter) { // 3.27 pre-release
    const existingFilter = filter as any;

    existingFilter.highlightFoulbornUniques = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.Purple,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    }});

    existingFilter.highlightGrafts = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightGraftsMinQuality = null;
    existingFilter.highlightGraftsMinILevel = null;
    existingFilter.highlightGraftsMinRarity = null;
    existingFilter.highlightGraftsTypes = ['All'];
    existingFilter.hideOtherGrafts = false;

    filter.showVendoringRares = true; // POE1
    existingFilter.showVendoringRaresUntilAreaLevel = 40; // POE1
    filter.showVendoringRaresSize = GearSizeType.All; // POE1
    filter.showVendoringRaresType = VendoringGearType.ShowStyled; // POE1
    existingFilter.showVendoringRaresStyle = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: new CosmeticOptions({
        textColor: poe1 ? 'rgba(255,255,119,0.6)' : 'rgba(254,224,85,0.6)',
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
      })
    }}); // POE1
    existingFilter.showVendoringRaresLevelingRaresStyle = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } }); // POE1

    if (poe2) return;

    this.migrateRenamedCurrency(filter, [{ type: 'Runegrafts', baseTypes: [{ old: 'Runegraft of Recompense', new: 'Runegraft of Refraction' }] }]);
    this.migrateRemovedCurrency(filter, [{ type: 'Currency', baseTypes: ['Bestiary Orb'] }]);
    this.migrateRemovedGear(filter, [{ type: 'Wands', baseTypes: ['Carved Wand', 'Engraved Wand', 'Imbued Wand'] }]);
  }

  migrateTo129(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightLevelGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightLevelGemsMinLevel = 18;
    existingFilter.highlightOtherLevelGems = structuredClone(existingFilter.highlightLvl18PlusGems);
    delete existingFilter.highlightLvl18PlusGems;

    (existingFilter.customRules.concat(existingFilter.customCosmeticRules)).forEach((rule: any) => {
      if (rule.advancedConditions?.clusterJewelPassives) {
        rule.advancedConditions.minClusterJewelPassives = rule.advancedConditions.clusterJewelPassives;
        delete rule.advancedConditions.clusterJewelPassives; // Oopsie, this was minClusterJewelPassives -- need to migrate this again
      }
    });
  }

  migrateTo128(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightGoodExceptionalSocketedGear.displayOptions.active = true;
    existingFilter.highlightGoodExceptionalQualityGear.displayOptions.active = true;
    existingFilter.highlightGoodExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Advanced;
  }

  migrateTo125(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightSmallOtherUniques = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.White,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Circle,
      }
     }
    });
    existingFilter.highlightSmallOtherUniquesMaxSize = GearSizeType.JewelleryOnly;
  }

  migrateTo124(filter: Filter) {
    const existingFilter = (filter as any);

    delete existingFilter.cosmeticSettings.highlightOverrideMinimapIcons;

    existingFilter.highlightILevel82NormalGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightILevel82NormalGearMinBaseTypeTier = BaseTypeTier.Elite;
    existingFilter.highlightILevel81NormalGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.EVisible } });
    existingFilter.highlightILevel81NormalGearMinBaseTypeTier = BaseTypeTier.Elite;

    existingFilter.highlightHighILevelJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.EVisible } });
    existingFilter.highlightHighILevelJewelleryMinILevel = 82;
    existingFilter.highlightHighILevelCharms = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightHighILevelCharmsMinILevel = 82;
    existingFilter.highlightHighILevelCharmTypes = ['Thawing Charm', 'Silver Charm', 'Golden Charm', 'Staunching Charm', 'Stone Charm'];

    if (filter.progressPreset === 'presetStrict90') {
      existingFilter.highlightILevel81NormalGear.displayOptions.active = false;
    }
  }

  migrateTo123(filter: Filter) {
    const existingFilter = (filter as any);

    filter.hideUncutGems = false;
    filter.hideUncutSkillGemsBelowLevel = null;
    filter.hideUncutSpiritGemsBelowLevel = null;
    filter.hideUncutSupportGemsBelowLevel = null;

    if (filter.progressPreset === 'presetStrict90') {
      filter.hideUncutGems = true;
      filter.hideUncutSkillGemsBelowLevel = 18;
      filter.hideUncutSpiritGemsBelowLevel = 18;

      if (!existingFilter.skillGemShowSupportGems) {
        filter.hideUncutSupportGemsBelowLevel = 5;
      }
    }

    existingFilter.highlightRareWaystones = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Map } });
    existingFilter.highlightDeliriumWaystones = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Map } });
    existingFilter.highlightOtherWaystones = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Map } });

    delete existingFilter.dynamicSkillGems;
    delete existingFilter.skillGemFilterType;
    delete existingFilter.dynamicSkillGemsLevel;
    delete existingFilter.skillGemShowSupportGems;

    delete existingFilter.hideRunes;
    delete existingFilter.hideRunesOfType;
    delete existingFilter.hideRunesExceptions;

    existingFilter.customCosmeticRules.forEach((rule: CustomRule) => {
      if (rule.displayOptions?.cosmeticOptions?.fontSize) rule.displayOptions.cosmeticOptions.fontSize = Number(rule.displayOptions?.cosmeticOptions?.fontSize);
    });

    filter.tierCosmetics.forEach((tier: TierCosmetic) => {
      if (tier.displayOptions?.cosmeticOptions?.fontSize) tier.displayOptions.cosmeticOptions.fontSize = Number(tier.displayOptions?.cosmeticOptions?.fontSize);
    });

    filter.divCardTierCosmetics.forEach((tier: TierCosmetic) => {
      if (tier.displayOptions?.cosmeticOptions?.fontSize) tier.displayOptions.cosmeticOptions.fontSize = Number(tier.displayOptions?.cosmeticOptions?.fontSize);
    });

    filter.uniqueTierCosmetics.forEach((tier: TierCosmetic) => {
      if (tier.displayOptions?.cosmeticOptions?.fontSize) tier.displayOptions.cosmeticOptions.fontSize = Number(tier.displayOptions?.cosmeticOptions?.fontSize);
    });

    filter.chanceBaseTierCosmetics.forEach((tier: TierCosmetic) => {
      if (tier.displayOptions?.cosmeticOptions?.fontSize) tier.displayOptions.cosmeticOptions.fontSize = Number(tier.displayOptions?.cosmeticOptions?.fontSize);
    });
  }

  migrateTo120(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.hideLifeFlasksBaseTypeExceptionsMinQuality = null;
    existingFilter.hideManaFlasksBaseTypeExceptionsMinQuality = null;
    existingFilter.hideHybridFlasksBaseTypeExceptionsMinQuality = null;
    existingFilter.hideUtilityFlasksBaseTypeExceptionsMinQuality = null;
    existingFilter.hideTincturesBaseTypeExceptionsMinQuality = null;

    existingFilter.highlightGoodExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Expert;
    existingFilter.highlightGoodExceptionalQualityGearMinQuality = 24;

    filter.showQualityWeaponsSize = GearSizeType.All;
    filter.showQualityMartialWeaponsSize = GearSizeType.All;
    filter.showQualityCasterWeaponsSize = GearSizeType.All;
    filter.showQualityArmourSize = GearSizeType.All;
  }

  migrateTo119(filter: Filter) {
    const existingFilter = (filter as any);

    delete existingFilter.showExceptionalSocketedGear;
    delete existingFilter.showExceptionalSocketedGearMinBaseTypeTier;

    delete existingFilter.showExceptionalQualityGear;
    delete existingFilter.showExceptionalQualityGearMinBaseTypeTier;
    delete existingFilter.showExceptionalQualityGearMinQuality;

    existingFilter.highlightExcellentExceptionalSocketedGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightGoodExceptionalSocketedGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });

    existingFilter.highlightExcellentExceptionalQualityGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.ARed } });
    existingFilter.highlightGoodExceptionalQualityGear = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });

    if (existingFilter.progressPreset === 'presetStrict90') {
      existingFilter.highlightGoodExceptionalSocketedGear.displayOptions.active = false;
      existingFilter.highlightGoodExceptionalQualityGear.displayOptions.active = false;
    }

    existingFilter.highlightExceptionalOtherUniques = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: {
        highlight: true,
        beam: true,
        highlightColor: Color.Brown,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    }});
    existingFilter.highlightExceptionalOtherUniquesMinQuality =
      filter.progressPreset === 'presetStrict90' ? 27
      : filter.progressPreset === 'presetEndGame80' ? 25
      : filter.progressPreset === 'presetMidMaps70' ? 23
      : 21;
  }

  migrateTo118(filter: Filter) {
    const existingFilter = (filter as any);

    if (poe1) return;

    filter.customUniqueTiers.forEach((uniqueTier: CustomTieredUnique) => {
      if (uniqueTier.baseType === 'Coral Circlet') {
        uniqueTier.baseType = 'Vermeil Circlet';
      } else if (uniqueTier.baseType === 'Diviner Cuffs') {
        uniqueTier.baseType = 'Verisium Cuffs';
      }
    });
  }

  migrateTo117(filter: Filter) {
    const existingFilter = (filter as any);

    if (poe1) return;

    // Rename Acient Bones to Ancient Bones
    existingFilter.customRules.forEach((rule: CustomRule) => {
      if (rule.itemType === 'Acient Bones') rule.itemType = 'Ancient Bones';
    });

    existingFilter.customCosmeticRules.forEach((rule: CustomRule) => {
      if (rule.itemType === 'Acient Bones') rule.itemType = 'Ancient Bones';
    });
  }

  migrateTo116(filter: Filter) {
    const existingFilter = (filter as any);

    // Clean up old renamed stuff

    delete existingFilter.highlightSelectedExcellentIdentifiedAttackWeapons;
    delete existingFilter.highlightSelectedExcellentIdentifiedAttackWeaponsTier;
    delete existingFilter.highlightSelectedGoodIdentifiedAttackWeapons;
    delete existingFilter.highlightSelectedGoodIdentifiedAttackWeaponsTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedCasterWeapons;
    delete existingFilter.highlightSelectedExcellentIdentifiedCasterWeaponsTier;
    delete existingFilter.highlightSelectedGoodIdentifiedCasterWeapons;
    delete existingFilter.highlightSelectedGoodIdentifiedCasterWeaponsTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedGemWeapons;
    delete existingFilter.highlightSelectedExcellentIdentifiedGemWeaponsTier;
    delete existingFilter.highlightSelectedGoodIdentifiedGemWeapons;
    delete existingFilter.highlightSelectedGoodIdentifiedGemWeaponsTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedQuivers;
    delete existingFilter.highlightSelectedExcellentIdentifiedQuiversTier;
    delete existingFilter.highlightSelectedGoodIdentifiedQuivers;
    delete existingFilter.highlightSelectedGoodIdentifiedQuiversTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedLifeArmour;
    delete existingFilter.highlightSelectedExcellentIdentifiedLifeArmourTier;
    delete existingFilter.highlightSelectedGoodIdentifiedLifeArmour;
    delete existingFilter.highlightSelectedGoodIdentifiedLifeArmourTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedEnergyShieldArmour;
    delete existingFilter.highlightSelectedExcellentIdentifiedEnergyShieldArmourTier;
    delete existingFilter.highlightSelectedGoodIdentifiedEnergyShieldArmour;
    delete existingFilter.highlightSelectedGoodIdentifiedEnergyShieldArmourTier;

    delete existingFilter.highlightSelectedExcellentIdentifiedJewellery;
    delete existingFilter.highlightSelectedGoodIdentifiedJewellery;

    if (poe1) return;

    if (filter.progressPreset === 'presetEarlyCampaign1' || filter.progressPreset === 'presetMidCampaign30' || filter.progressPreset === 'presetLateCampaignEarlyMaps60') {
      const otherUniquesTier = filter.uniqueTierCosmetics.find(t => t.uniqueTier === 'Other')?.displayOptions;
      if (otherUniquesTier) {
        otherUniquesTier.active = true;
      }
    }
  }

  migrateTo115(filter: Filter) {
    // 0.3.0 pre-release

    const existingFilter = (filter as any);

    // General filter settings: Exceptional / min-tier gear exception highlights

    existingFilter.highlightRareWeaponAndArmourExceptionsMinTier =
      filter.progressPreset === 'presetStrict90' ? 4
      : filter.progressPreset === 'presetEndGame80' ? 3
      : filter.progressPreset === 'presetMidMaps70' ? 2
      : null;
      existingFilter.highlightExceptionalWeaponAndArmourExceptions = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
      existingFilter.highlightExceptionalWeaponAndArmourExceptionsMinQuality =
      filter.progressPreset === 'presetStrict90' ? 27
      : filter.progressPreset === 'presetEndGame80' ? 25
      : filter.progressPreset === 'presetMidMaps70' ? 23
      : 21;

    existingFilter.showExceptionalSocketedGear = true;
    existingFilter.showExceptionalQualityGear = true;
    if (existingFilter.progressPreset === 'presetStrict90') {
      existingFilter.showExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Elite;
      existingFilter.showExceptionalQualityGearMinBaseTypeTier = BaseTypeTier.Elite;
      existingFilter.showExceptionalQualityGearMinQuality = 28;
    } else {
      existingFilter.showExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Expert;
      existingFilter.showExceptionalQualityGearMinBaseTypeTier = BaseTypeTier.Expert;
      existingFilter.showExceptionalQualityGearMinQuality = 25;
    }

    existingFilter.sectionVisibility.showExceptionalGearFilters = false;

    if (poe1) return;

    // Removed Currency

    const removedCurrency = [
      {
        type: 'Omens',
        baseTypes: ['Omen of Greater Annulment', 'Omen of Dextral Alchemy', 'Omen of Sinistral Alchemy', 'Omen of Dextral Coronation', 'Omen of Sinistral Coronation']
      }
    ];

    removedCurrency.forEach((currency: any) => {
      const rulesForType = existingFilter.customRules.filter((c: CustomRule) => c.itemType === currency.type);
      const cosmeticRulesForType = existingFilter.customCosmeticRules.filter((c: CustomRule) => c.itemType === currency.type);

      rulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.filter((baseType: string) => !currency.baseTypes.includes(baseType));

        if (rule.baseTypes.length === 0) {
          existingFilter.customRules = existingFilter.customRules.filter((c: CustomRule) => c !== rule);
        }
      });

      cosmeticRulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.filter((baseType: string) => !currency.baseTypes.includes(baseType));

        if (rule.baseTypes.length === 0) {
          existingFilter.customCosmeticRules = existingFilter.customCosmeticRules.filter((c: CustomRule) => c !== rule);
        }
      });

      filter.customCurrencyTiers = filter.customCurrencyTiers.filter((c: CustomTieredItem) => !currency.baseTypes.includes(c.name));
    });

    // Renamed currency

    const renamedCurrency = [
      {
        type: 'Essences',
        baseTypes: [
          { old: 'Essence of Torment', new: 'Essence of Abrasion' },
          { old: 'Greater Essence of Torment', new: 'Greater Essence of Abrasion' }
        ]
      },
      {
        type: 'Distilled Emotions',
        baseTypes: [
          { old: "Distilled Ire", new: "Diluted Liquid Ire" },
          { old: "Distilled Guilt", new: "Diluted Liquid Guilt" },
          { old: "Distilled Greed", new: "Diluted Liquid Greed" },
          { old: "Distilled Paranoia", new: "Liquid Paranoia" },
          { old: "Distilled Envy", new: "Liquid Envy" },
          { old: "Distilled Disgust", new: "Liquid Disgust" },
          { old: "Distilled Despair", new: "Liquid Despair" },
          { old: "Distilled Fear", new: "Concentrated Liquid Fear" },
          { old: "Distilled Suffering", new: "Concentrated Liquid Suffering" },
          { old: "Distilled Isolation", new: "Concentrated Liquid Isolation" },
        ]
      }
    ];

    renamedCurrency.forEach((currency: any) => {
      const rulesForType = existingFilter.customRules.filter((c: CustomRule) => c.itemType === currency.type);
      const cosmeticRulesForType = existingFilter.customCosmeticRules.filter((c: CustomRule) => c.itemType === currency.type);

      rulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.map((baseType: string) => currency.baseTypes.find((b: any) => b.old === baseType)?.new || baseType);
      });

      cosmeticRulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.map((baseType: string) => currency.baseTypes.find((b: any) => b.old === baseType)?.new || baseType);
      });

      filter.customCurrencyTiers = filter.customCurrencyTiers.map((c: CustomTieredItem) => {
        c.name = currency.baseTypes.find((b: any) => b.old === c.name)?.new || c.name;
        return c;
      });
    });

    // Renamed item types

    existingFilter.customRules.forEach((cr: CustomRule) => {
      if (cr.itemType === 'Distilled Emotions') cr.itemType = 'Liquid Emotions';
    });

    existingFilter.customCosmeticRules.forEach((cr: CustomRule) => {
      if (cr.itemType === 'Distilled Emotions') cr.itemType = 'Liquid Emotions';
    });

    // Split Skill Gem types

    const customRulesToAdd = existingFilter.customRules.map((cr: CustomRule) => this.migrateSkillGemTypes(cr, existingFilter.customRules));
    const customCosmeticRulesToAdd = existingFilter.customCosmeticRules.map((cr: CustomRule) => this.migrateSkillGemTypes(cr, existingFilter.customCosmeticRules));

    // Insert new rules after their corresponding old rules, maintaining order
    customRulesToAdd.forEach((migration: any) => {
      if (migration.newRules && migration.newRules.length > 0) {
        const oldRuleIndex = existingFilter.customRules.indexOf(migration.oldRule);
        if (oldRuleIndex !== -1) {
          existingFilter.customRules.splice(oldRuleIndex + 1, 0, ...migration.newRules);
        }
      }
    });

    customCosmeticRulesToAdd.forEach((migration: any) => {
      if (migration.newRules && migration.newRules.length > 0) {
        const oldRuleIndex = existingFilter.customCosmeticRules.indexOf(migration.oldRule);
        if (oldRuleIndex !== -1) {
          existingFilter.customCosmeticRules.splice(oldRuleIndex + 1, 0, ...migration.newRules);
        }
      }
    });

    existingFilter.customRules = existingFilter.customRules.filter((c: CustomRule) => c.itemType !== 'Skill Gems');
    existingFilter.customCosmeticRules = existingFilter.customCosmeticRules.filter((c: CustomRule) => c.itemType !== 'Skill Gems');

    (existingFilter.customRules as CustomRule[]).forEach((cr, index) => cr.order = index);
    (existingFilter.customCosmeticRules as CustomRule[]).forEach((cr, index) => cr.order = index);

    // Removed uniques

    const removedSingleUniqueBaseTypes = ['Steeltoe Boots', 'Effigial Tower Shield', 'Lamellar Mail', 'Smithing Hammer', 'Spiritbone Crown', 'Coffer Relic'];

    filter.customUniqueTiers = filter.customUniqueTiers.filter((c: CustomTieredUnique) => !removedSingleUniqueBaseTypes.includes(c.baseType));

    // Renamed base types

    const renamedBaseTypes = [
      { old: 'Embroidered Gloves', new: 'Embellished Gloves' },
    ];

    renamedBaseTypes.forEach((baseType: any) => {
      filter.customGearTiers.forEach((c: CustomTieredGear) => {
        if (c.baseType === baseType.old) {
          c.baseType = baseType.new;
        }
      });
      filter.customJewelleryTiers?.forEach((c: CustomTieredJewellery) => {
        if (c.baseType === baseType.old) {
          c.baseType = baseType.new;
        }
      });
    });

    // Added jewellery base types

    if (!existingFilter.hideRingsBaseTypeExceptions) existingFilter.hideRingsBaseTypeExceptions = [];
    if (!existingFilter.hideAmuletsBaseTypeExceptions) existingFilter.hideAmuletsBaseTypeExceptions = [];

    if (!existingFilter.hideRingsBaseTypeExceptions.includes('Abyssal Signet')) {
      existingFilter.hideRingsBaseTypeExceptions.push('Abyssal Signet');
      if (existingFilter.hideRingsBaseTypeExceptions.includes('None')) {
        existingFilter.hideRingsBaseTypeExceptions = existingFilter.hideRingsBaseTypeExceptions.filter((b: string) => b !== 'None');
      }
    }

    if (!existingFilter.hideAmuletsBaseTypeExceptions.includes('Pearlescent Amulet')) {
      existingFilter.hideAmuletsBaseTypeExceptions.push('Pearlescent Amulet');
      if (existingFilter.hideAmuletsBaseTypeExceptions.includes('None')) {
        existingFilter.hideAmuletsBaseTypeExceptions = existingFilter.hideAmuletsBaseTypeExceptions.filter((b: string) => b !== 'None');
      }
    }

    // Removed gear base types

    const removedGearBaseTypes = [
      { type: 'Spears',  baseTypes: ['Sword Spear', 'Striking Spear', 'Steelhead Spear', 'Coursing Spear', 'Swift Spear'] },
      { type: 'One Hand Maces', baseTypes: [ "Calescent Hammer", "Flared Mace", "Battle Pick" ] },
      { type: 'Two Hand Maces', baseTypes: [ "Snakewood Greathammer",  "Blacksmith Maul",  "Zealot Greathammer" ] },
      { type: 'Quarterstaves', baseTypes: [ "Reaching Quarterstaff", "Barbarous Quarterstaff", "Arcing Quarterstaff" ] },
      { type: 'Bows', baseTypes: [ "Snakewood Shortbow", "Protector Bow", "Rider Bow" ] },
      { type: 'Crossbows', baseTypes: [ "Taut Crossbow", "Robust Crossbow", "Painted Crossbow" ] },
      { type: 'Helmets', baseTypes: [ "Corroded Greathelm", "Mercenary Greathelm", "Homeguard Greathelm", "Rotted Hood", "Wool Cap", "Narrow Hood", "Druidic Circlet", "Avian Tiara", "Desert Circlet", "Domed Helm", "Engraved Helm", "Soldier Helm", "Mailed Crown", "Forest Crown", "Zealot Crown", "Oak Mask", "Bandit Mask", "Skulking Mask" ] },
      { type: 'Boots', baseTypes: [ "Plated Greaves", "Lionheart Greaves", "Bound Boots", "Sleek Boots", "Laced Sandals", "Bangled Sandals", "Soldiering Sabatons", "Goldwork Sabatons", "Adherent Leggings", "Bound Leggings", "Wayfarer Shoes", "Silverbuckled Shoes" ] },
      { type: 'Gloves', baseTypes: [ "Plated Mitts", "Elegant Mitts", "Hunting Bracers", "Swift Bracers", "Ominous Gloves", "Embellished Gloves", "Ironmail Gauntlets", "Captain Gauntlets", "Braided Cuffs", "Heirloom Cuffs", "Bandage Wraps", "Cambric Wraps", "Righteous Cuffs", "Diviner Cuffs" ] },
      { type: 'Body Armours', baseTypes: [ "Barbarian Plate", "Rugged Cuirass", "Sandsworn Cuirass", "Patchwork Vest", "Hunting Coat", "Riding Coat", "Avian Robe", "Cursespeaker's Robe", "Luxurious Robe", "Ring Mail", "Scoundrel Armour", "Wanderer Armour", "Templar Vestments", "Bearskin Mantle", "Chain Vestments", "Ascetic Garb", "Oiled Jacket", "Evangelist Garb" ] },
      { type: 'Shields', baseTypes: [ "Aged Tower Shield", "Metalworked Tower Shield", "Cultist Tower Shield", "Ironwood Targe", "Fur-lined Targe", "Mercenary Targe", "Painted Crest Shield", "Engraved Crest Shield", "Descry Crest Shield" ] },
      { type: 'Bucklers', baseTypes: [ "Oak Buckler", "Painted Buckler", "Coiled Buckler" ] },
      { type: 'Foci', baseTypes: [ "Wreath Focus", "Staghorn Focus", "Jingling Focus" ] },
    ];

    removedGearBaseTypes.forEach((gearType: any) => {
      const rulesForType = existingFilter.customRules.filter((c: CustomRule) => c.itemType === gearType.type);
      const cosmeticRulesForType = existingFilter.customCosmeticRules.filter((c: CustomRule) => c.itemType === gearType.type);

      rulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.filter((baseType: string) => !gearType.baseTypes.includes(baseType));

        if (rule.baseTypes.length === 0) {
          existingFilter.customRules = existingFilter.customRules.filter((c: CustomRule) => c !== rule);
        }
      });

      cosmeticRulesForType.forEach((rule: CustomRule) => {
        rule.baseTypes = rule.baseTypes.filter((baseType: string) => !gearType.baseTypes.includes(baseType));

        if (rule.baseTypes.length === 0) {
          existingFilter.customCosmeticRules = existingFilter.customCosmeticRules.filter((c: CustomRule) => c !== rule);
        }
      });

      filter.customGearTiers = filter.customGearTiers.filter((c: CustomTieredGear) => !gearType.baseTypes.includes(c.baseType));
    });
  }

  private migrateSkillGemTypes(rule: CustomRule, collection: CustomRule[]) {
    const newRules: CustomRule[] = [];
    if (rule.itemType === 'Skill Gems') {
      if (rule.baseTypes.includes('All') || rule.baseTypes.includes('Uncut Skill Gem')) {
        const index = collection.indexOf(rule);
        newRules.push(new CustomRule({
          ...rule,
          filterItemClass: undefined,
          itemType: 'Uncut Skill Gems',
          itemClass: 'Uncut Skill Gems',
          baseTypes: ['All'],
        }));
      }

      if (rule.baseTypes.includes('All') || rule.baseTypes.includes('Uncut Support Gem')) {
        const index = collection.indexOf(rule);
        newRules.push(new CustomRule({
          ...rule,
          filterItemClass: undefined,
          itemType: 'Uncut Support Gems',
          itemClass: 'Uncut Support Gems',
          baseTypes: ['All'],
        }));
      }

      if (rule.baseTypes.includes('All') || rule.baseTypes.includes('Uncut Spirit Gem')) {
        const index = collection.indexOf(rule);
        newRules.push(new CustomRule({
          ...rule,
          filterItemClass: undefined,
          itemType: 'Uncut Spirit Gems',
          itemClass: 'Uncut Spirit Gems',
          baseTypes: ['All'],
        }));
      }
    }

    return { oldRule: rule, newRules: newRules };
  }

  migrateTo113(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightExcellentIdentifiedJewels = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightGoodIdentifiedJewels = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightIdentifiedJewelCategories = [JewelsCategory.All];
    existingFilter.highlightIdentifiedAbyssJewelCategories = [AbyssJewelsCategory.All];

    filter.customModTiers.forEach((tieredMod: any) => {
      delete tieredMod.id;
    });

    existingFilter.highlightRestrictedModIdentifiedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.EVisible } });
    existingFilter.highlightRestrictedModIdentifiedItemsGearTier = BaseTypeTier.Expert;
    existingFilter.highlightRestrictedModIdentifiedItemsWeaponTypes = [WeaponType.All];
    existingFilter.highlightRestrictedModIdentifiedItemsDefenceTypes = [DefenceType.All];
    existingFilter.highlightRestrictedModIdentifiedItemsDelve = true;
    existingFilter.highlightRestrictedModIdentifiedItemsIncursion = true;
    existingFilter.highlightRestrictedModIdentifiedItemsBreach = true;

    existingFilter.mapTypesLowTierInfluenced = true;
    filter.mapTypesLowTierMemoryInfluenced = true;
    filter.mapTypesLowTierBlighted = false;
    filter.mapTypesLowTierDelirium = false;
    filter.mapTypesLowTierMinTier = 14;
    filter.mapTypesT16Normal = true;
    existingFilter.mapTypesT16Favourite = true;
    filter.mapTypesT16EightMod = true;
    filter.mapTypesT16Blighted = true;
    filter.mapTypesT16Influenced = true;
    filter.mapTypesT16MemoryInfluenced = true;
    filter.mapTypesT16Delirium = true;
    filter.mapTypesT17 = true;
    filter.mapTypesBlightRavaged = true;

    filter.cosmeticPresets.defaultLabelSize = 'default';

    existingFilter.gearTieringMode = 'Strict';

    existingFilter.customRules.forEach((rule: CustomRule) => {
      this.migrateMinMaxAdvancedConditions(rule);
    });

    existingFilter.customCosmeticRules.forEach((rule: CustomRule) => {
      this.migrateMinMaxAdvancedConditions(rule);
    });

    existingFilter.highlightCorruptedImplicitJewels = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightCorruptedImplicitJewelsTypes = ['All'];
    existingFilter.highlightCorruptedImplicitJewelsMinImplicits = 1;
    existingFilter.highlightCorruptedImplicitJewelsMinExplicits = 3;

    existingFilter.sectionVisibility.showCurrencyStackSettings = false;

    existingFilter.highlightExcellentClusterJewelBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightGoodClusterJewelBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
  }

  private migrateMinMaxAdvancedConditions(rule: CustomRule) {
    const oldAdvancedConditions = rule.advancedConditions as any;
    if (!oldAdvancedConditions) return;

    if (oldAdvancedConditions.itemLevel !== undefined && oldAdvancedConditions.itemLevel !== null) {
      if (oldAdvancedConditions.itemLevelComparator === Comparator.GreaterThanOrEqual) {
        rule.advancedConditions!.minItemLevel = oldAdvancedConditions.itemLevel;
      } else if (oldAdvancedConditions.itemLevelComparator === Comparator.LessThanOrEqual) {
        rule.advancedConditions!.maxItemLevel = oldAdvancedConditions.itemLevel;
      } else {
        rule.advancedConditions!.minItemLevel = oldAdvancedConditions.itemLevel;
        rule.advancedConditions!.maxItemLevel = oldAdvancedConditions.itemLevel;
      }
    }

    if (oldAdvancedConditions.dropLevel !== undefined && oldAdvancedConditions.dropLevel !== null) {
      if (oldAdvancedConditions.dropLevelComparator === Comparator.GreaterThanOrEqual) {
        rule.advancedConditions!.minDropLevel = oldAdvancedConditions.dropLevel;
      } else if (oldAdvancedConditions.dropLevelComparator === Comparator.LessThanOrEqual) {
        rule.advancedConditions!.maxDropLevel = oldAdvancedConditions.dropLevel;
      } else {
        rule.advancedConditions!.minDropLevel = oldAdvancedConditions.dropLevel;
        rule.advancedConditions!.maxDropLevel = oldAdvancedConditions.dropLevel;
      }
    }

    if (oldAdvancedConditions.areaLevel !== undefined && oldAdvancedConditions.areaLevel !== null) {
      if (oldAdvancedConditions.areaLevelComparator === Comparator.GreaterThanOrEqual) {
        rule.advancedConditions!.minAreaLevel = oldAdvancedConditions.areaLevel;
      } else if (oldAdvancedConditions.areaLevelComparator === Comparator.LessThanOrEqual) {
        rule.advancedConditions!.maxAreaLevel = oldAdvancedConditions.areaLevel;
      } else {
        rule.advancedConditions!.minAreaLevel = oldAdvancedConditions.areaLevel;
        rule.advancedConditions!.maxAreaLevel = oldAdvancedConditions.areaLevel;
      }
    }

    delete oldAdvancedConditions.itemLevel;
    delete oldAdvancedConditions.itemLevelComparator;
    delete oldAdvancedConditions.dropLevel;
    delete oldAdvancedConditions.dropLevelComparator;
    delete oldAdvancedConditions.areaLevel;
    delete oldAdvancedConditions.areaLevelComparator;
  }

  migrateTo111(filter: Filter) {
    const existingFilter = (filter as any);

    const potentialIndex = filter.uniqueTierCosmetics.findIndex(tier => tier.uniqueTier === 'Potential');
    if (potentialIndex !== -1) {
      filter.uniqueTierCosmetics.splice(potentialIndex + 1, 0, createDefaultRestrictedUniquesTier());
    }

    filter.uniqueTierCosmetics.forEach((tier: TierCosmetic, index: number) => {
      tier.order = index;
    });

    filter.divCardTierCosmetics = structuredClone(filter.tierCosmetics);
    existingFilter.highlightRoguesMarkers = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.EVisible } });

    filter.cosmeticPresets = new CosmeticPresets();
    // Try to guess initial values
    const sTierCosmetics = filter.tierCosmetics.find(t => t.tier === Tier.SPurple)?.displayOptions?.cosmeticOptions;
    const aTierCosmetics = filter.tierCosmetics.find(t => t.tier === Tier.ARed)?.displayOptions?.cosmeticOptions;
    const bTierCosmetics = filter.tierCosmetics.find(t => t.tier === Tier.BOrange)?.displayOptions?.cosmeticOptions;
    if (sTierCosmetics) {
      filter.cosmeticPresets.labelSize = sTierCosmetics.fontSize === LabelSize.Largest ? 'veryLarge' : sTierCosmetics.fontSize === LabelSize.Large ? 'larger' : 'default';
      filter.cosmeticPresets.labelColor = sTierCosmetics.textColor ? 'accentTiered' : 'default';
      filter.cosmeticPresets.startingTier = bTierCosmetics?.textColor ? 'bTier' : aTierCosmetics?.textColor ? 'aTier' : sTierCosmetics.fontSize === LabelSize.Largest ? 'sTier' : 'bTier'; // Default
    }

    existingFilter.sectionVisibility = {
      showFlaskFilters: existingFilter.showFlaskFilters,
      showCurrencyFilters: existingFilter.showCurrencyFilters,
      showJewelleryFilters: existingFilter.showJewelleryFilters,
      showUniqueHighlights: existingFilter.showUniqueHighlights,
      showCraftingBasesHighlights: existingFilter.showCraftingBasesHighlights,
      showIdentifiedItemsHighlights: existingFilter.showIdentifiedItemsHighlights,
      showOtherHighlights: existingFilter.showOtherHighlights,
      showJewelleryHighlights: existingFilter.showJewelleryHighlights,
      showGearFilters: existingFilter.showGearFilters,
      showLevelingFilters: existingFilter.showLevelingFilters, // POE1
      showTieredGearFilters: existingFilter.showTieredGearFilters, // POE2
      showQualityFilters: existingFilter.showQualityFilters,
      showInfluenceFilters: existingFilter.showInfluenceFilters, // POE1
      showWeaponExceptions: existingFilter.showWeaponExceptions,
      showArmourExceptions: existingFilter.showArmourExceptions,
      showDynamicFilters: existingFilter.showDynamicFilters,
      showGemHighlights: existingFilter.showGemHighlights, // POE1
      showFreeTextRules: existingFilter.showFreeTextRules,
    } as any;

    delete existingFilter.showFlaskFilters;
    delete existingFilter.showCurrencyFilters;
    delete existingFilter.showJewelleryFilters;
    delete existingFilter.showUniqueHighlights;
    delete existingFilter.showCraftingBasesHighlights;
    delete existingFilter.showIdentifiedItemsHighlights;
    delete existingFilter.showOtherHighlights;
    delete existingFilter.showJewelleryHighlights;
    delete existingFilter.showGearFilters;
    delete existingFilter.showLevelingFilters;
    delete existingFilter.showTieredGearFilters;
    delete existingFilter.showQualityFilters;
    delete existingFilter.showInfluenceFilters;
    delete existingFilter.showWeaponExceptions;
    delete existingFilter.showArmourExceptions;
    delete existingFilter.showDynamicFilters;
    delete existingFilter.showGemHighlights;
    delete existingFilter.showFreeTextRules;

    existingFilter.includeHighDustValueUniquesAsGood = true;
  }

  migrateTo110(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.showJewelleryHighlights = true;

    existingFilter.highlightInfluencedJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightFracturedJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightSynthesisedJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightVeiledJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightVeiledJewelleryOfSyndicateMembers = ['All Members'];
    existingFilter.highlightMemoryStrandJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });
    existingFilter.highlightMemoryStrandJewelleryMinStrands = 60;

    filter.showInfluencedGear = true;
    filter.showInfluencedGearMinBaseTypeTier = BaseTypeTier.Elite;
    filter.showInfluencedGearMinItemLevel = null;
    filter.showFracturedGear = true;
    filter.showFracturedGearMinBaseTypeTier = BaseTypeTier.Elite;
    filter.showFracturedGearMinItemLevel = null;
    (filter as any).showSynthesisedGear = true;
    (filter as any).showSynthesisedGearMinBaseTypeTier = BaseTypeTier.Elite;
    (filter as any).showSynthesisedGearMinItemLevel = null;
    filter.showVeiledGear = true;
    filter.showVeiledGearMinBaseTypeTier = BaseTypeTier.Elite;
    filter.showVeiledGearMinItemLevel = null;
    filter.showVeiledGearOfSyndicateMembers = ['All Members'];
    filter.showMemoryStrandGear = true;
    filter.showMemoryStrandGearMinBaseTypeTier = BaseTypeTier.Elite;
    filter.showMemoryStrandGearMinItemLevel = null;
    filter.showMemoryStrandGearMinStrands = 60;

    delete existingFilter.highlightVeiledItems;
    delete existingFilter.highlightFracturedItems;
    delete existingFilter.highlightSynthesisedItems;
    delete existingFilter.highlightInfluencedItems;
    delete existingFilter.highlightInfluencedItemsInfluence;
    delete existingFilter.highlightEldritchItems;
    delete existingFilter.highlightEldritchItemsTier;
    delete existingFilter.highlightEldritchItemsType;
  }

  migrateTo109(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightExcellentIdentifiedGear = { ...existingFilter.highlightSelectedExcellentIdentifiedAttackWeapons };
    existingFilter.highlightGoodIdentifiedGear = { ...existingFilter.highlightSelectedGoodIdentifiedAttackWeapons };
    existingFilter.highlightExcellentIdentifiedGearTier = existingFilter.highlightSelectedExcellentIdentifiedAttackWeaponsTier;
    existingFilter.highlightGoodIdentifiedGearTier = existingFilter.highlightSelectedGoodIdentifiedAttackWeaponsTier;

    existingFilter.highlightIdentifiedEnergyShieldArmourTypesDefenceTypes = [DefenceType.ArmourEnergyShield, DefenceType.EnergyShield, DefenceType.EvasionEnergyShield];

    existingFilter.highlightExcellentIdentifiedJewellery = { ...existingFilter.highlightSelectedExcellentIdentifiedJewellery };
    existingFilter.highlightGoodIdentifiedJewellery = { ...existingFilter.highlightSelectedGoodIdentifiedJewellery };

    existingFilter.highlightExcellentIdentifiedCustomItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightGoodIdentifiedCustomItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });

    filter.customModItemCategories = [];

    existingFilter.cosmeticSettings.hiddenGearSmallAndTransparent = true;
    existingFilter.cosmeticSettings.hiddenJewellerySmallAndTransparent = false;
    existingFilter.cosmeticSettings.hiddenFlaskSmallAndTransparent = false;
  }

  migrateTo108(filter: Filter) {
    const existingFilter = (filter as any);
    existingFilter.highlightQualityGems = existingFilter.highlightQuality10pGems;
    delete existingFilter.highlightQuality10pGems;

    existingFilter.highlightQualityGemsMinQuality = 10;
  }

  migrateTo107(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.showIdentifiedItemsHighlights = true;

    existingFilter.highlightIdentifiedAttackWeaponCategories = [AttackWeaponsCategory.All];
    existingFilter.highlightIdentifiedAttackWeaponTypes = [WeaponType.All];
    existingFilter.highlightSelectedExcellentIdentifiedAttackWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedAttackWeaponsTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedAttackWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedAttackWeaponsTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedCasterWeaponCategories = [CasterWeaponsCategory.All];
    existingFilter.highlightSelectedExcellentIdentifiedCasterWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedCasterWeaponsTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedCasterWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedCasterWeaponsTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedGemWeaponCategories = [GemWeaponsCategory.All];
    existingFilter.highlightSelectedExcellentIdentifiedGemWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedGemWeaponsTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedGemWeapons = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedGemWeaponsTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedQuiverCategories = [QuiversCategory.All];
    existingFilter.highlightSelectedExcellentIdentifiedQuivers = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedQuiversTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedQuivers = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedQuiversTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedLifeArmourCategories = [LifeArmourCategory.All];
    existingFilter.highlightIdentifiedLifeArmourTypesDefenceTypes = [DefenceType.All];
    existingFilter.highlightSelectedExcellentIdentifiedLifeArmour = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedLifeArmourTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedLifeArmour = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedLifeArmourTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedEnergyShieldArmourCategories = [EnergyShieldArmourCategory.All];
    existingFilter.highlightIdentifiedEnergyShieldArmourTypesDefenceTypes = [DefenceType.All];
    existingFilter.highlightSelectedExcellentIdentifiedEnergyShieldArmour = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedExcellentIdentifiedEnergyShieldArmourTier = BaseTypeTier.Expert;
    existingFilter.highlightSelectedGoodIdentifiedEnergyShieldArmour = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightSelectedGoodIdentifiedEnergyShieldArmourTier = BaseTypeTier.Expert;

    existingFilter.highlightIdentifiedJewelleryCategories = [JewelleryCategory.All];
    existingFilter.highlightSelectedExcellentIdentifiedJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightSelectedGoodIdentifiedJewellery = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });

    existingFilter.highlightIdentifiedItemsLabelStyleOverride = new ItemHighlight({ displayOptions: {
      active: false,
      displayType: DisplayType.ItemTypeOverrides,
      cosmeticOptions: new CosmeticOptions()
    }});

    existingFilter.customModTiers = [];

    existingFilter.hideJewels = false;
    existingFilter.hideJewelsOfRarity = Rarity.Magic;
    existingFilter.hideJewelsBaseTypeExceptions = ['None'];
  }

  migrateTo106(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightWeaponCraftingBasesClasses = [WeaponType.All];
    existingFilter.highlightWeaponCraftingBasesMinItemLevel = 84;
    existingFilter.highlightExcellentWeaponCraftingBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightGoodWeaponCraftingBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });

    existingFilter.highlightArmourCraftingBasesTypes = [ArmourType.All];
    existingFilter.highlightArmourCraftingBasesMinItemLevel = 84;
    existingFilter.highlightExcellentArmourCraftingBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });
    existingFilter.highlightGoodArmourCraftingBases = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });

    existingFilter.highlightCraftingBasesLabelStyleOverride = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.ItemTypeOverrides,
      cosmeticOptions: new CosmeticOptions({ textColor: "rgb(200,200,200)" })
    } });

    existingFilter.showFlaskFilters = true;
    existingFilter.showCurrencyFilters = true;
    existingFilter.showJewelleryFilters = true;
    existingFilter.showUniqueHighlights = true;
    existingFilter.showCraftingBasesHighlights = true; // POE1
    existingFilter.showOtherHighlights = true;
    existingFilter.showGearFilters = true;
    existingFilter.showLevelingFilters = true; // POE1
    existingFilter.showTieredGearFilters = true; // POE2
    existingFilter.showQualityFilters = true;
    existingFilter.showWeaponExceptions = true;
    existingFilter.showArmourExceptions = true;
    existingFilter.showDynamicFilters = true;
    existingFilter.showGemHighlights = true; // POE1
    existingFilter.showFreeTextRules = !!filter.freeRulesBottom || !!filter.freeRulesTop;

    if (poe2) {
      if (existingFilter.highlightRareJewelleryMinTier && typeof existingFilter.highlightRareJewelleryMinTier === 'string') {
        existingFilter.highlightRareJewelleryMinTier = parseInt(existingFilter.highlightRareJewelleryMinTier);
      }
    }
  }

  migrateTo105(filter: Filter) {
    const existingFilter = (filter as any);

    if (existingFilter.hideAmuletsOfRarity === 'NormalAndMagic') filter.hideAmuletsOfRarity = Rarity.Magic;
    if (existingFilter.hideRingsOfRarity === 'NormalAndMagic') filter.hideRingsOfRarity = Rarity.Magic;
    if (existingFilter.hideBeltsOfRarity === 'NormalAndMagic') filter.hideBeltsOfRarity = Rarity.Magic;

    if (poe2) {
      if (existingFilter.showTieredRareGearMinTier && typeof existingFilter.showTieredRareGearMinTier === 'string') {
        filter.showTieredRareGearMinTier = parseInt(existingFilter.showTieredRareGearMinTier);
      }
      if (existingFilter.showTieredMagicGearMinTier && typeof existingFilter.showTieredMagicGearMinTier === 'string') {
        filter.showTieredMagicGearMinTier = parseInt(existingFilter.showTieredMagicGearMinTier);
      }

      filter.weaponFilters.forEach((w: any) => {
        if (w.unidentifiedTier && typeof w.unidentifiedTier === 'string') {
          w.unidentifiedTier = parseInt(w.unidentifiedTier);
        }
      });

      filter.armourFilters.forEach((a: any) => {
        if (a.unidentifiedTier && typeof a.unidentifiedTier === 'string') {
          a.unidentifiedTier = parseInt(a.unidentifiedTier);
        }
      });
    }
  }

  migrateTo104(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled = true;
    existingFilter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold = 3;
    existingFilter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold = 10;
    existingFilter.cosmeticSettings.stackedGeneralCurrencyNeverPromote = ['None'];
    existingFilter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled = poe1 ? true : false;
    existingFilter.cosmeticSettings.stackedHiddenCurrencyOneTierThreshold = poe1 ? 15 : 5;
    existingFilter.cosmeticSettings.stackedHiddenCurrencyTwoTiersThreshold = poe1 ? 50 : 10;
    existingFilter.cosmeticSettings.stackedHiddenCurrencyNeverHighlight = false;

    if (existingFilter.highlight6SocketedItems && existingFilter.highlight6SocketedItems.displayOptions.active) {
      filter.showJewellersRecipe = true;
    } else {
      filter.showJewellersRecipe = false;
    }

    delete existingFilter.highlight6SocketedItems;

    existingFilter.highlightSynthesisedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });

    existingFilter.favouriteMaps = ['None'];

    filter.weaponFilters.forEach((w: any) => {
      w.weaponType = [w.weaponType];
    });

    filter.armourFilters.forEach((a: any) => {
      a.armourType = a.armourType === 'AllButShields' ? [ArmourType.BodyArmours, ArmourType.Helmets, ArmourType.Gloves, ArmourType.Boots] : [a.armourType];
    });
  }

  migrateTo100(filter: Filter) {
    const existingFilter = (filter as any);

    filter.hideTinctures = false;
    existingFilter.hideTincturesBaseTypeExceptions = ['None'];

    existingFilter.highlightLargeGoldStacks = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightHugeGoldStacks = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });

    filter.ssf = (filter.tieringMode as any) === 'SSF' && filter.armourFilters.filter(a => a.show).length > 0 && filter.weaponFilters.filter(w => w.show).length > 0;
  }

  migrateTo99(filter: Filter) {
    const existingFilter = (filter as any);
    const tierPriority = { 'Excellent': 1, 'Good': 2, 'Potential': 3, 'Other': 4 };

    const uniqueTiersMap = new Map<string, { baseType: string, tier: UniqueTierType }>();
    const allUniques = this.itemDataService.getUniquesList();

    existingFilter.customUniqueTiers.forEach((t: { uniqueName: string, tier: UniqueTierType }) => {
      const uniqueItem = allUniques.find(u => u.name === t.uniqueName);
      if (!uniqueItem) return;

      const existingEntry = uniqueTiersMap.get(uniqueItem.baseType);
      if (!existingEntry || tierPriority[t.tier as keyof typeof tierPriority] < tierPriority[existingEntry.tier as keyof typeof tierPriority]) {
        uniqueTiersMap.set(uniqueItem.baseType, { baseType: uniqueItem.baseType, tier: t.tier });
      }
    });

    filter.customUniqueTiers = Array.from(uniqueTiersMap.values());
  }

  migrateTo98(filter: Filter) {
    filter.hideScrollsLowerThan = null;
    filter.hidePortalScrollsLowerThan = null;
  }

  migrateTo95(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightQuestItems = new ItemHighlight({ displayOptions: {
      displayType: DisplayType.Custom,
      cosmeticOptions: { highlight: true, highlightColor: Color.Green, beam: true, minimapIconShape: MinimapIconShape.Kite, minimapIconSize: MinimapIconSize.Small }
    }});

    existingFilter.showLinkedGearCustomSocketGroup = null;

    // filter.showLinkedGearMinLinks was stored as string, should be number
    existingFilter.showLinkedGearMinLinks = existingFilter.showLinkedGearMinLinks ? parseInt(existingFilter.showLinkedGearMinLinks) : 5;

    existingFilter.showLevelingWeapons = true;
    existingFilter.showLevelingWeaponClasses = ['All'];
    existingFilter.showLevelingWeaponSocketGroup = null;

    existingFilter.showLevelingArmour = true;
    existingFilter.showLevelingArmourDefenceTypes = ['All'];
    existingFilter.showLevelingArmourSocketGroup = null;

    filter.progressPreset = null;
    filter.classPreset = null;

    if (existingFilter.classSpecificUniquesForClasses?.length > 0) {
      filter.classPreset = existingFilter.classSpecificUniquesForClasses[0];
    }
  }

  migrateTo94(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.highlightHeistBlueprints = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange } });
    existingFilter.highlightHeistContracts = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightHeistLocations = ['All'];

    if (existingFilter.highlightBlueprints) delete existingFilter.highlightBlueprints;
    if (existingFilter.highlightBlueprintsType) delete existingFilter.highlightBlueprintsType;
    if (existingFilter.highlightContracts) delete existingFilter.highlightContracts;
    if (existingFilter.highlightContractsType) delete existingFilter.highlightContractsType;
  }

  migrateTo91(filter: Filter) {
    const existingFilter = (filter as any);

    filter.hideHybridFlasks = false;
    existingFilter.hideHybridFlasksBaseTypeExceptions = ['None'];
    filter.hideUtilityFlasks = false;
    existingFilter.hideUtilityFlasksBaseTypeExceptions = ['None'];
    filter.hidePortalScrolls = false;
    filter.hideTalismans = false;
    existingFilter.hideTalismansBaseTypeExceptions = ['None'];

    filter.showChaosRecipe = true;
    filter.showChaosRecipeTarget = ['All'];
    filter.showExaltRecipe = true;
    filter.showExaltRecipeTarget = ['All'];
    filter.showExaltRecipeInfluence = ['All'];
    filter.showChromaticRecipe = true;
    filter.showChromaticRecipeType = GearSizeType.TwoByTwoOnly;

    filter.showQualityWeapons = true;
    filter.showQualityWeaponsMinQuality = 1;
    existingFilter.showLinkedGear = true;
    existingFilter.showLinkedGearMinLinks = 5;

    existingFilter.highlight6LinkWeaponAndArmourExceptions = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple } });

    existingFilter.highlightInfluencedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightInfluencedItemsInfluence = ['All'];

    existingFilter.highlightEldritchItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });
    existingFilter.highlightEldritchItemsTier = 1;
    existingFilter.highlightEldritchItemsType = EldritchItemType.All;

    existingFilter.highlightVeiledItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.EVisible } });
    existingFilter.highlightFracturedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite } });

    existingFilter.highlight6LinkedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.ARed } });
    existingFilter.highlight6SocketedItems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow } });

    existingFilter.highlightTopTierAwakenedGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightOtherAwakenedGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Gem } });

    existingFilter.highlightTopTierSpecialSupportGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.SPurple, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightOtherSpecialSupportGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Gem } });

    existingFilter.highlightLvl21Gems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.ARed, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightLvl18PlusGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Gem } });

    existingFilter.highlightQuality23Gems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.ARed, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightQuality10pGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.CYellow, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightOtherQualityGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.DWhite, displayTypeTierHighlightType: EquipmentTierType.Gem } });

    existingFilter.highlightSearchedGems = new ItemHighlight({ displayOptions: { displayTypeTier: Tier.BOrange, displayTypeTierHighlightType: EquipmentTierType.Gem } });
    existingFilter.highlightSearchedGemTypes = ['None'];

    filter.hideOtherGems = false;
  }

  migrateTo90(filter: Filter) {
    const existingFilter = (filter as any);

    // Migrate global custom tiers to filter
    const customCurrencyTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS) || '[]') as { name: string, tier: Tier }[];
    const customUniqueTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_UNIQUE_TIERS) || '[]') as { name: string, tier: UniqueTierType }[];
    const customChanceBaseTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_CHANCE_BASE_TIERS) || '[]') as { name: string, tier: ChanceBaseTierType }[];
    const customGearTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_GEAR_TIERS) || '[]') as { name: string, tier: GearTierType }[];

    existingFilter.customCurrencyTiers = customCurrencyTiers.map(t => ({ name: t.name, tier: t.tier }));
    existingFilter.customUniqueTiers = customUniqueTiers.map(t => ({ uniqueName: t.name, tier: t.tier }));
    existingFilter.customChanceBaseTiers = customChanceBaseTiers.map(t => ({ baseType: t.name, tier: t.tier }));
    existingFilter.customGearTiers = customGearTiers.map(t => ({ baseType: t.name, tier: t.tier }));

    // Leave the old ones for future filters

    // Initialize classSpecificUniquesForClasses
    existingFilter.classSpecificUniquesForClasses = ['None'];

    // Migrate the S-Tier style to the A-Tier
    const sTier = filter.tierCosmetics.find(t => t.tier as any === 'S');
    const aTier = filter.tierCosmetics.find(t => t.tier as any === 'A');
    if (sTier && aTier) Object.assign(aTier.displayOptions, sTier.displayOptions);

    // Migrate the old SP-Tier to the new S-Tier
    const spTier = filter.tierCosmetics.find(t => t.tier as any === 'P');
    if (sTier && spTier) Object.assign(sTier.displayOptions, spTier.displayOptions);

    // Remove SP-Tier
    filter.tierCosmetics = filter.tierCosmetics.filter(t => t.tier as any !== 'P');

    // Reorder
    filter.tierCosmetics.forEach((t: TierCosmetic, index: number) => {
      t.order = index;
    });

    // Migrate any custom tiers from SP to S
    filter.customCurrencyTiers = filter.customCurrencyTiers.map(t => ({ ...t, tier: t.tier as any === 'P' ? Tier.SPurple : t.tier }));

    // On any of the highlights, replace the old SP-Tier with the new S-Tier
    if (existingFilter.highlightRareJewellery?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightRareJewellery.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightRareWeaponAndArmourExceptions?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightRareWeaponAndArmourExceptions.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightOtherWeaponAndArmourExceptions?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightOtherWeaponAndArmourExceptions.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightTrialItems?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightTrialItems.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightJewels?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightJewels.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightRareBreachRings?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightRareBreachRings.displayOptions.displayTypeTier = Tier.SPurple;
    if (existingFilter.highlightOtherBreachRings?.displayOptions.displayTypeTier as any === 'P') existingFilter.highlightOtherBreachRings.displayOptions.displayTypeTier = Tier.SPurple;

    // Same for custom rules and custom cosmetic rules
    existingFilter.customRules.forEach((r: CustomRule) => {
      if (r.displayOptions.displayTypeTier as any === 'P') r.displayOptions.displayTypeTier = Tier.SPurple;
    });
    existingFilter.customCosmeticRules.forEach((r: CustomRule) => {
      if (r.displayOptions.displayTypeTier as any === 'P') r.displayOptions.displayTypeTier = Tier.SPurple;
    });

    filter.tieringMode = localStorage.getItem(LOCAL_STORAGE_KEY_TIERING_MODE) as TieringMode || 'Normal';
  }

  migrateTo89(filter: Filter) {
    const existingFilter = (filter as any);

    filter.showQualityFlasks = existingFilter.hideLifeFlasksQuality === null ? false : true;
    filter.showQualityFlasksMinQuality = existingFilter.hideLifeFlasksQuality === null ? 10 : existingFilter.hideLifeFlasksQuality;

    delete existingFilter.hideLifeFlasksQuality;
    delete existingFilter.hideManaFlasksQuality;
  }

  migrateTo87(filter: Filter) {
    const existingFilter = (filter as any);

    existingFilter.skillGemShowSupportGems = false;

    // Fix the issue of incorrect display type on custom rules
    existingFilter.customRules.forEach((rule: CustomRule) => {
      const itemData = this.itemData.find(i => i.itemType === rule.itemType);
      if (rule.itemType === 'Skill Gems') {
        rule.displayOptions.displayType = DisplayType.EquipmentTier;
        rule.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Gem;
      } else if (rule.itemType === 'Waystones') {
        rule.displayOptions.displayType = DisplayType.EquipmentTier;
        rule.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Map;
      } else if (itemData && itemData.isCurrency) {
        rule.displayOptions.displayType = DisplayType.Tier;
        rule.displayOptions.displayTypeTierHighlightType = undefined;
      } else {
        rule.displayOptions.displayType = DisplayType.EquipmentTier;
        rule.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Item;
      }
    });

    existingFilter.cosmeticSettings = {};
  }

  migrateTo86(filter: Filter) {
    const existingFilter = (filter as any);

    // TierCosmetics.options was renamed to cosmeticOptions. Show was inverted in hidden.
    filter.tierCosmetics.forEach((t: any) => {
      const oldTierCosmetic = (t.options ?? t.displayOptions as any);
      t.displayOptions = new InitialDisplayOptions({
        active: oldTierCosmetic.active,
        hidden: oldTierCosmetic.show === false,
        displayType: DisplayType.Custom,
        cosmeticOptions: new CosmeticOptions(oldTierCosmetic.options ?? oldTierCosmetic.cosmeticOptions),
      });
      delete oldTierCosmetic.options;
      delete oldTierCosmetic.show;
      delete oldTierCosmetic.active;
      delete oldTierCosmetic.custom;
      delete oldTierCosmetic.continue;
    });

    // 'show' on custom rules was inverted in 'hidden'.
    existingFilter.customRules.forEach((r: CustomRule) => {
      const oldCustomRule = (r as any);
      const displayType = Object.values(Tier).includes(oldCustomRule.displayType) ? DisplayType.EquipmentTier : DisplayType.Custom;
      r.displayOptions = new InitialDisplayOptions({
        active: oldCustomRule.active,
        hidden: oldCustomRule.show === false,
        displayType,
        displayTypeTierHighlightType: displayType === DisplayType.EquipmentTier ? EquipmentTierType.Item : undefined,
        displayTypeTier: displayType === DisplayType.EquipmentTier ? oldCustomRule.displayType : undefined,
        cosmeticOptions: displayType === DisplayType.Custom
          ? (existingFilter.customTierCosmetics.find((t: any) => t.name === oldCustomRule.displayType)?.options || new CosmeticOptions())
          : undefined,
      });
      delete oldCustomRule.show;
      delete oldCustomRule.active;
      delete oldCustomRule.displayType;
      delete oldCustomRule.cosmeticOptions;
    });

    existingFilter.customCosmeticRules.forEach((r: CustomRule) => {
      const oldCustomRule = (r as any);
      r.displayOptions = new InitialDisplayOptions({
        active: oldCustomRule.active,
        hidden: oldCustomRule.show === false,
        displayType: DisplayType.Custom,
        cosmeticOptions: new CosmeticOptions(oldCustomRule.cosmeticOptions),
      });
      delete oldCustomRule.show;
      delete oldCustomRule.active;
      delete oldCustomRule.displayType;
      delete oldCustomRule.cosmeticOptions;
    });

    // Move all customRules with displayType Custom to customCosmeticRules

    existingFilter.customRules.forEach((r: CustomRule) => {
      if (r.displayOptions.displayType === DisplayType.Custom) {
        existingFilter.customCosmeticRules.push(r);
      }
    });

    existingFilter.customRules = existingFilter.customRules.filter((r: CustomRule) => r.displayOptions.displayType !== DisplayType.Custom);

    // Check whether there are any currency items in poe-custom-item-tiers which are in custom tier cosmetics. If so, change that into a custom cosmetic rule with the same cosmetic options.

    let customCurrencyTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS) || '[]') as { name: string, tier: Tier }[];
    const migrated: string[] = [];
    customCurrencyTiers.forEach((t: { name: string, tier: Tier }) => {
      const customTierCosmetic = existingFilter.customTierCosmetics.find((tierCosmetic: TierCosmetic) => tierCosmetic.name === t.name);
      if (customTierCosmetic) {
        const customRule = new Initial86CustomRule();
        customRule.displayOptions = new InitialDisplayOptions({
          displayType: DisplayType.Custom,
          cosmeticOptions: (customTierCosmetic as any).options,
        });
        const itemFromFlatItemData = this.itemDataService.getFlatItemDataByBaseTypeName(t.name);
        if (itemFromFlatItemData) {
          customRule.itemClass = itemFromFlatItemData.itemClass;
          customRule.itemType = itemFromFlatItemData.itemType;
          customRule.baseTypes = [itemFromFlatItemData.baseType.name];
        }
        existingFilter.customCosmeticRules.push(customRule);
        migrated.push(t.name);
      } else if (!Object.values(Tier).includes(t.name as any)) {
        migrated.push(t.name); // Custom tier doesn't exist: remove it
      }
    });

    // Delete the migrated currency items from LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS
    customCurrencyTiers = customCurrencyTiers.filter(item => !migrated.includes(item.name));
    localStorage.setItem(LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS, JSON.stringify(customCurrencyTiers));

    // Assign the correct index to the new custom cosmetic rules

    existingFilter.customCosmeticRules.forEach((r: CustomRule, index: number) => {
      r.order = index;
    });

    // Create default unique & chance tier cosmetics
    existingFilter.uniqueTierCosmetics = createDefaultUniqueTierCosmetics(false);
    existingFilter.chanceBaseTierCosmetics = createDefaultChanceBaseTierCosmetics();

    existingFilter.uniqueTierCosmetics[0].displayOptions.active = existingFilter.highlightExcellentUniques;
    existingFilter.uniqueTierCosmetics[1].displayOptions.active = existingFilter.highlightGoodUniques;
    existingFilter.uniqueTierCosmetics[2].displayOptions.active = existingFilter.highlightGoodUniques;
    existingFilter.uniqueTierCosmetics[3].displayOptions.active = existingFilter.highlightOtherUniques;

    existingFilter.chanceBaseTierCosmetics[0].displayOptions.active = existingFilter.highlightExcellentChanceBases;
    existingFilter.chanceBaseTierCosmetics[1].displayOptions.active = existingFilter.highlightGoodChanceBases;

    // We no longer need unique & chance base highlights; they are replaced by their respective tier cosmetics

    delete existingFilter.highlightExcellentUniques;
    delete existingFilter.highlightExcellentUniquesTier;
    delete existingFilter.highlightGoodUniques;
    delete existingFilter.highlightGoodUniquesTier;
    delete existingFilter.highlightPotentialUniques;
    delete existingFilter.highlightPotentialUniquesTier;
    delete existingFilter.highlightOtherUniques;
    delete existingFilter.highlightOtherUniquesTier;

    delete existingFilter.highlightExcellentChanceBases;
    delete existingFilter.highlightExcellentChanceBasesTier;
    delete existingFilter.highlightGoodChanceBases;
    delete existingFilter.highlightGoodChanceBasesTier;

    // Transform old highlights to new display options

    if (existingFilter.customTierCosmetics) {
      this.migrateHighlightRule(existingFilter, 'highlightRareJewellery');
      this.migrateHighlightRule(existingFilter, 'highlightRareWeaponAndArmourExceptions');
      this.migrateHighlightRule(existingFilter, 'highlightOtherWeaponAndArmourExceptions');
      this.migrateHighlightRule(existingFilter, 'highlightTrialItems', 'highlightTrialItemsRelicsTier');
      this.migrateHighlightRule(existingFilter, 'highlightJewels');
      this.migrateHighlightRule(existingFilter, 'highlightRareBreachRings');
      this.migrateHighlightRule(existingFilter, 'highlightOtherBreachRings');

      // Delete the concept of custom tier cosmetics
      delete existingFilter.customTierCosmetics;
    }

    // Delete more obsolete properties
    delete existingFilter.highlightEndgameFragments;
    delete existingFilter.highlightEndgameFragmentsTier;

    // Migrate advanced conditions
    existingFilter.customRules.forEach((r: CustomRule) => this.migrateAdvancedConditions(r));
    existingFilter.customCosmeticRules.forEach((r: CustomRule) => this.migrateAdvancedConditions(r));

    // Migrate all cosmetic options
    existingFilter.customRules.forEach((r: CustomRule) => this.migrateCosmeticOptions(r.displayOptions.cosmeticOptions));
    existingFilter.customCosmeticRules.forEach((r: CustomRule) => this.migrateCosmeticOptions(r.displayOptions.cosmeticOptions));
    filter.tierCosmetics.forEach((t: TierCosmetic) => this.migrateCosmeticOptions(t.displayOptions.cosmeticOptions));

    // Unidentified item tiers
    filter.showTieredRareGear = existingFilter.hideGearByItemLevel || existingFilter.hideGearByRarity || existingFilter.hideGearByBaseTypeTier;
    filter.showTieredRareGearMinBaseTypeTier = existingFilter.hideGearByBaseTypeTier === false
      ? BaseTypeTier.Basic
      : existingFilter.hideGearOfBaseTypeTier;
    filter.showTieredRareGearMinTier = 3;

    filter.showTieredMagicGear = existingFilter.hideGearByItemLevel || existingFilter.hideGearByRarity || existingFilter.hideGearByBaseTypeTier;
    filter.showTieredMagicGearMinBaseTypeTier = existingFilter.hideGearByBaseTypeTier === false
      ? BaseTypeTier.Basic
      : existingFilter.hideGearOfBaseTypeTier;
    filter.showTieredMagicGearMinTier = 4;

    existingFilter.highlightRareJewelleryMinTier = null;
  }

  private migrateCosmeticOptions(cosmeticOptions?: CosmeticOptions) {
    if (!cosmeticOptions) return;

    if (!cosmeticOptions.highlight) {
      cosmeticOptions.highlight = undefined;
      cosmeticOptions.highlightColor = undefined;
      cosmeticOptions.minimapIconSize = undefined;
      cosmeticOptions.minimapIconShape = undefined;
      cosmeticOptions.beam = undefined;
      cosmeticOptions.temp = undefined;
    }

    if (!cosmeticOptions.alertSound) {
      cosmeticOptions.alertSound = undefined;
      cosmeticOptions.alertSoundSound = undefined;
      cosmeticOptions.alertSoundVolume = undefined;
      cosmeticOptions.disableDropSound = undefined;
      cosmeticOptions.customAlertSound = undefined;
    }

    if (cosmeticOptions.highlightColor === null) cosmeticOptions.highlightColor = undefined;
    if (cosmeticOptions.minimapIconSize === null) cosmeticOptions.minimapIconSize = undefined;
    if (cosmeticOptions.minimapIconShape === null) cosmeticOptions.minimapIconShape = undefined;
    if (cosmeticOptions.beam === null) cosmeticOptions.beam = undefined;
    if (cosmeticOptions.temp === null) cosmeticOptions.temp = undefined;

    if (cosmeticOptions.alertSoundSound === null) cosmeticOptions.alertSoundSound = undefined;
    if (cosmeticOptions.alertSoundVolume === null) cosmeticOptions.alertSoundVolume = undefined;
    if (cosmeticOptions.disableDropSound === null) cosmeticOptions.disableDropSound = undefined;
    if (cosmeticOptions.customAlertSound === null) cosmeticOptions.customAlertSound = undefined;

    if (cosmeticOptions.backgroundColor === null) cosmeticOptions.backgroundColor = undefined;
    if (cosmeticOptions.borderColor === null) cosmeticOptions.borderColor = undefined;
    if (cosmeticOptions.textColor === null) cosmeticOptions.textColor = undefined;
    if (cosmeticOptions.fontSize === null) cosmeticOptions.fontSize = undefined;

    delete cosmeticOptions.alertSoundPositional;
    delete cosmeticOptions.enableDropSound;
    delete cosmeticOptions.disableDropSoundIfAlertSound;
    delete cosmeticOptions.enableDropSoundIfAlertSound;
  }

  private migrateAdvancedConditions(customRule: any) {
    let hasAdvancedConditions = false;

    if (!customRule.advancedConditions) return;

    if (customRule.advancedConditions!.classes !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.classes;
    if (customRule.advancedConditions!.baseTypes !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.baseTypes;
    if (customRule.advancedConditions!.itemLevelComparator !== Comparator.GreaterThanOrEqual) hasAdvancedConditions = true;
    if (customRule.advancedConditions!.itemLevel !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.itemLevel;
    if (customRule.advancedConditions!.dropLevelComparator !== Comparator.GreaterThanOrEqual) hasAdvancedConditions = true;
    if (customRule.advancedConditions!.dropLevel !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.dropLevel;
    if (customRule.advancedConditions!.areaLevelComparator !== Comparator.GreaterThanOrEqual) hasAdvancedConditions = true;
    if (customRule.advancedConditions!.areaLevel !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.areaLevel;
    if (customRule.advancedConditions!.minSockets !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minSockets;
    if (customRule.advancedConditions!.minQuality !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minQuality;
    if (customRule.advancedConditions!.minStackSize !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minStackSize;
    if (customRule.advancedConditions!.minBaseDefencePercentile !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minBaseDefencePercentile;
    if (customRule.advancedConditions!.minArmour !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minArmour;
    if (customRule.advancedConditions!.minEvasion !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minEvasion;
    if (customRule.advancedConditions!.minEnergyShield !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.minEnergyShield;
    if (customRule.advancedConditions!.waystoneTierComparator !== Comparator.GreaterThanOrEqual) hasAdvancedConditions = true;
    if (customRule.advancedConditions!.waystoneTier !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.waystoneTier;
    if (customRule.advancedConditions!.anyEnchantment !== null) hasAdvancedConditions = true;
    else delete customRule.advancedConditions!.anyEnchantment;

    if (!hasAdvancedConditions) delete customRule.advancedConditions;
  }

  private migrateHighlightRule(existingFilter: any, highlightPropertyName: string, highlightPropertyNameTier?: string) {
    const customTier = existingFilter.customTierCosmetics.find((t: TierCosmetic) => t.name === existingFilter[highlightPropertyName + 'Tier']) as any;
    if (customTier) {
      existingFilter[highlightPropertyName] = new ItemHighlight({
        displayOptions: {
          displayType: existingFilter[highlightPropertyName] ? DisplayType.Custom : undefined,
          cosmeticOptions: customTier.cosmeticOptions
        }
      });
      this.migrateCosmeticOptions(existingFilter[highlightPropertyName].displayOptions.cosmeticOptions);
    } else {
      existingFilter[highlightPropertyName] = new ItemHighlight({
        displayOptions: {
          active: existingFilter[highlightPropertyName],
          displayType: DisplayType.EquipmentTier,
          displayTypeTierHighlightType: EquipmentTierType.Item,
          displayTypeTier: existingFilter[highlightPropertyNameTier || (highlightPropertyName + 'Tier')]
        }
      });
    }

    delete existingFilter[highlightPropertyNameTier || (highlightPropertyName + 'Tier')];
  }

  migrateTo81(filter: Filter) {
    // Migrate stored custom gear tiers
    const customGearTiers = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_CUSTOM_GEAR_TIERS) || '[]') as { name: string, tier: Tier }[];
    let hasChanges = false;
    customGearTiers.forEach(t => {
      const migration = baseTypeMigrationData.find(b => b.old === t.name);
      if (migration) {
        t.name = migration.new;
        hasChanges = true;
      }
    });
    if (hasChanges) {
      localStorage.setItem(LOCAL_STORAGE_KEY_CUSTOM_GEAR_TIERS, JSON.stringify(customGearTiers));
      setTimeout(() => location.reload());
    }
  }

  migrateTo77(filter: Filter) {
    const existingFilter = (filter as any);

    // Rune type

    existingFilter.hideRunesOfType = RuneType.Lesser;

    // Replace Extra renames

    existingFilter.customRules.forEach((r: any) => {
      if (r.baseTypes) {
        r.baseTypes = r.baseTypes.map((baseType: string) => {
          const migration = extraRenames.find(b => b.old === baseType);
          return migration ? migration.new : baseType;
        });
      }
    });

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if (r.baseTypes) {
        r.baseTypes = r.baseTypes.map((baseType: string) => {
          const migration = extraRenames.find(b => b.old === baseType);
          return migration ? migration.new : baseType;
        });
      }
    });

    if (filter.freeRulesBottom) {
      extraRenames.forEach(b => {
        filter.freeRulesBottom = filter.freeRulesBottom!.replace(b.old, b.new);
      });
    }

    if (filter.freeRulesTop) {
      extraRenames.forEach(b => {
        filter.freeRulesTop = filter.freeRulesTop!.replace(b.old, b.new);
      });
    }
  }

  migrateTo76(filter: Filter) {
    const existingFilter = (filter as any);

    // Replace base types in custom rules, custom cosmetic rules, and free rules

    existingFilter.customRules.forEach((r: any) => {
      if (r.baseTypes) {
        r.baseTypes = r.baseTypes.map((baseType: string) => {
          const migration = baseTypeMigrationData.find(b => b.old === baseType);
          return migration ? migration.new : baseType;
        });
      }
    });

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if (r.baseTypes) {
        r.baseTypes = r.baseTypes.map((baseType: string) => {
          const migration = baseTypeMigrationData.find(b => b.old === baseType);
          return migration ? migration.new : baseType;
        });
      }
    });

    if (filter.freeRulesBottom) {
      baseTypeMigrationData.forEach(b => {
        filter.freeRulesBottom = filter.freeRulesBottom!.replace(b.old, b.new);
      });
    }

    if (filter.freeRulesTop) {
      baseTypeMigrationData.forEach(b => {
        filter.freeRulesTop = filter.freeRulesTop!.replace(b.old, b.new);
      });
    }

    // If 'other uniques' were set to FHidden, remove that

    if (existingFilter.highlightOtherUniques && existingFilter.highlightOtherUniquesTier === Tier.FHidden) {
      existingFilter.highlightOtherUniques = false;
      existingFilter.highlightOtherUniquesTier = Tier.ARed;
    }

    // Add the new runes to the rune exception list

    if (existingFilter.hideRunes) {
      if (existingFilter.hideRunesExceptions.includes('None')) existingFilter.hideRunesExceptions = [];
      existingFilter.hideRunesExceptions.push(
        "Greater Body Rune",
        "Greater Desert Rune",
        "Greater Glacial Rune",
        "Greater Inspiration Rune",
        "Greater Iron Rune",
        "Greater Mind Rune",
        "Greater Rebirth Rune",
        "Greater Stone Rune",
        "Greater Storm Rune",
        "Greater Vision Rune",
        "Greater Rune of Leadership",
        "Greater Rune of Tithing",
        "Greater Rune of Alacrity",
        "Greater Rune of Nobility",
      );
    }

    // Add new amulets to exceptions

    if (existingFilter.hideAmulets) {
      if (existingFilter.hideAmuletsBaseTypeExceptions.includes('None')) existingFilter.hideAmuletsBaseTypeExceptions = [];
      existingFilter.hideAmuletsBaseTypeExceptions.push(
        "Dusk Amulet",
        "Gloam Amulet",
        "Penumbra Amulet",
        "Tenebrous Amulet",
      );
    }

    // Add new rings to exceptions

    if (existingFilter.hideRings) {
      if (existingFilter.hideRingsBaseTypeExceptions.includes('None')) existingFilter.hideRingsBaseTypeExceptions = [];
      existingFilter.hideRingsBaseTypeExceptions.push(
        "Dusk Ring",
        "Gloam Ring",
        "Penumbra Ring",
        "Tenebrous Ring",
      );
    }
  }

  migrateTo71(filter: Filter) {
    const existingFilter = (filter as any);

    // Process custom rules
    this.processSplitSocketableRules(existingFilter.customRules);

    // Process custom cosmetic rules
    this.processSplitSocketableRules(existingFilter.customCosmeticRules);
  }

  private processSplitSocketableRules(rules: any[]): void {
    const newRules: any[] = [];

    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];

      if (rule.itemType === 'Socketable' && rule.baseTypes && rule.baseTypes.length > 0) {
        // Check if baseTypes contains "All"
        if (rule.baseTypes.includes('All')) {
          // Create a rule for Runes with "All"
          const runeRule = structuredClone(rule);
          runeRule.itemType = 'Runes';

          // Create a rule for Soul Cores with "All"
          const soulCoreRule = structuredClone(rule);
          soulCoreRule.itemType = 'Soul Cores';

          // Add both new rules (skip the original rule)
          newRules.push(runeRule, soulCoreRule);
        } else {
          const runeBaseTypes = rule.baseTypes.filter((baseType: string) => baseType.includes('Rune'));
          const soulCoreBaseTypes = rule.baseTypes.filter((baseType: string) => baseType.includes('Soul Core'));

          // Case: Contains only Runes
          if (runeBaseTypes.length > 0 && soulCoreBaseTypes.length === 0) {
            rule.itemType = 'Runes';
            newRules.push(rule);
          }
          // Case: Contains only Soul Cores
          else if (runeBaseTypes.length === 0 && soulCoreBaseTypes.length > 0) {
            rule.itemType = 'Soul Cores';
            newRules.push(rule);
          }
          // Case: Contains both - need to split the rule
          else if (runeBaseTypes.length > 0 && soulCoreBaseTypes.length > 0) {
            // Create rule for Runes
            const runeRule = structuredClone(rule);
            runeRule.itemType = 'Runes';
            runeRule.baseTypes = runeBaseTypes;

            // Create rule for Soul Cores
            const soulCoreRule = structuredClone(rule);
            soulCoreRule.itemType = 'Soul Cores';
            soulCoreRule.baseTypes = soulCoreBaseTypes;

            // Add both rules in sequence
            newRules.push(runeRule, soulCoreRule);
          } else {
            // No socketable items in this rule
            newRules.push(rule);
          }
        }
      } else {
        // Not a socketable rule, keep as is
        newRules.push(rule);
      }
    }

    // Replace the contents of the original array
    rules.length = 0;
    rules.push(...newRules);
  }

  migrateTo70(filter: Filter) {
    const existingFilter = (filter as any);

    if (existingFilter.skillGemFilterType === undefined) {
      existingFilter.skillGemFilterType = SkillGemFilterType.Dynamic;
    }
  }

  migrateTo69(filter: Filter) {
    const existingFilter = (filter as any);

    if (existingFilter.hideGearOfBaseTypeTier === 'Regular') existingFilter.hideGearOfBaseTypeTier = BaseTypeTier.Basic;

    existingFilter.weaponFilters.forEach((w: any) => {
      if (w.baseTypeTier === 'Regular') w.baseTypeTier = BaseTypeTier.Basic;
    });

    existingFilter.armourFilters.forEach((a: any) => {
      if (a.baseTypeTier === 'Regular') a.baseTypeTier = BaseTypeTier.Basic;
    });

    filter.showQualityCasterWeapons = existingFilter.showQualityArcaneWeapons;
    filter.showQualityCasterWeaponsMinQuality = existingFilter.showQualityArcaneWeaponsMinQuality;
  }

  migrateTo67(filter: Filter) {
    const existingFilter = (filter as any);

    if (existingFilter.dynamicWaystonesStrict) {
      filter.waystoneFilterType = WaystoneFilterType.StaticStrict;
    } else if (existingFilter.dynamicWaystones) {
      filter.waystoneFilterType = WaystoneFilterType.Dynamic;
    } else {
      filter.waystoneFilterType = WaystoneFilterType.StaticDefault;
    }
  }

  migrateFilterBefore66(filter: Filter) {
    const existingFilter = (filter as any);

    // Move shields over to armour

    const shieldFilters = structuredClone(filter.weaponFilters.filter(w => ((w as any).weaponType as string) == "Shields"));
    if (shieldFilters.length > 0) {
      filter.weaponFilters = filter.weaponFilters.filter(w => ((w as any).weaponType as string) != "Shields");
      filter.armourFilters.push(...shieldFilters.map((s: any) => {
        return {
          show: s.show,
          armourType: ArmourType.Shields,
          rarity: s.rarity,
          baseTypeTier: s.baseTypeTier,
          defenceType: [DefenceType.All],
        } as any;
      }));
    }

    // Initialize charm quality

    if (existingFilter.hideCharms && existingFilter.hideCharmsBaseTypeExceptions.length > 0) {
      if (existingFilter.hideCharmsQuality === undefined) {
        existingFilter.hideCharmsQuality = 1;
      }
    }

    // Add custom cosmetic rules

    if (existingFilter.customCosmeticRules === undefined) {
      existingFilter.customCosmeticRules = [];
    }

    // Fix item type for custom rules

    existingFilter.customRules.forEach((r: any) => {
      if ((r as any).class) {
        r.itemType = (r as any).class;
        r.itemClass = this.itemData.find(i => i.itemType === r.itemType)?.itemClass || 'All';
        delete (r as any).class;
      }
    });

    // Currency filter

    const hideCommonCurrencyType = existingFilter.hideCommonCurrencyType;
    if (hideCommonCurrencyType) {
      filter.hideCurrency = true;

      if (hideCommonCurrencyType === "CommonShardsOnly") {
        filter.hideCurrencyTypes = ['Transmutation Shard', 'Artificer\'s Shard'];
      } else if (hideCommonCurrencyType === "ShardsOnly") {
        filter.hideCurrencyTypes = ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard', 'Chance Shard'];
      } else if (hideCommonCurrencyType === "AllCommon") {
        filter.hideCurrencyTypes = ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard', 'Chance Shard', 'Orb of Augmentation', 'Orb of Transmutation'];
      }

      delete existingFilter.hideCommonCurrency;
      delete existingFilter.hideCommonCurrencyType;
    }

    // Sounds for custom cosmetic rules

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if ((r as any).cosmeticOptions!.alertSound === undefined) {
        r.cosmeticOptions!.alertSound = false;
        r.cosmeticOptions!.alertSoundSound = '2';
        r.cosmeticOptions!.alertSoundVolume = 200;
        r.cosmeticOptions!.disableDropSound = false;
        r.cosmeticOptions!.customAlertSound = null;

        // Currently unused
        r.cosmeticOptions!.alertSoundPositional = false;
        r.cosmeticOptions!.enableDropSound = false;
        r.cosmeticOptions!.disableDropSoundIfAlertSound = false;
        r.cosmeticOptions!.enableDropSoundIfAlertSound = false;
      }
    });

    // Strict waystone filter

    if (existingFilter.dynamicWaystonesStrict === undefined) {
      existingFilter.dynamicWaystonesStrict = false;
    }

    // Fill in order

    if (existingFilter.customRules.some((r: any) => r.order === undefined)) {
      existingFilter.customRules.forEach((r: any, index: number) => {
        r.order = index;
      });
    }

    if (existingFilter.customCosmeticRules.some((r: any) => r.order === undefined)) {
      existingFilter.customCosmeticRules.forEach((r: any, index: number) => {
        r.order = index;
      });
    }

    // Always init advanced conditions

    existingFilter.customRules.forEach((r: any) => {
      if (!r.advancedConditions) r.advancedConditions = {
        active: false,
        baseTypes: null,
        itemLevelComparator: Comparator.GreaterThanOrEqual,
        itemLevel: null,
        dropLevelComparator: Comparator.GreaterThanOrEqual,
        dropLevel: null,
        areaLevelComparator: Comparator.GreaterThanOrEqual,
        areaLevel: null,
        minQuality: null,
        minStackSize: null,
        minBaseDefencePercentile: null,
      } as any
    });

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if (!r.advancedConditions) r.advancedConditions = {
        active: false,
        baseTypes: null,
        itemLevelComparator: Comparator.GreaterThanOrEqual,
        itemLevel: null,
        dropLevelComparator: Comparator.GreaterThanOrEqual,
        dropLevel: null,
        areaLevelComparator: Comparator.GreaterThanOrEqual,
        areaLevel: null,
        minQuality: null,
        minStackSize: null,
        minBaseDefencePercentile: null,
      } as any
    });

    // New unique and chance Base Types

    if (existingFilter.highlightUniquesType === undefined) {
      existingFilter.highlightUniquesType = 'All';
    }

    if (existingFilter.highlightChanceBasesType === undefined) {
      existingFilter.highlightChanceBasesType = 'All';
    }

    // Init default tier cosmetics

    if (filter.tierCosmetics === undefined) {
      filter.tierCosmetics = this.createInitialDefaultTierCosmetics();
    }

    // New socket and gear rules

    if (filter.showSocketedGear === undefined) {
      if (existingFilter.showSocketedItems) {
        filter.showSocketedGear = true;
        filter.showSocketedGearType = existingFilter.showSocketedItemsType;
      } else {
        filter.showSocketedGear = false;
        filter.showSocketedGearType = SocketedItemType.TwoOrMoreSockets;
      }
    }

    if (filter.showQualityMartialWeapons === undefined) {
      if (existingFilter.showQualityItems) {
        filter.showQualityMartialWeapons = true;
        filter.showQualityCasterWeapons = true;
        filter.showQualityArmour = true;
      } else {
        filter.showQualityMartialWeapons = false;
        filter.showQualityCasterWeapons = false;
        filter.showQualityArmour = false;
      }

      if (existingFilter.showQualityItemsType === 'MinimumTenQuality') {
        filter.showQualityMartialWeaponsMinQuality = 10;
        filter.showQualityCasterWeaponsMinQuality = 10;
        filter.showQualityArmourMinQuality = 10;
      } else {
        filter.showQualityMartialWeaponsMinQuality = 1;
        filter.showQualityCasterWeaponsMinQuality = 1;
        filter.showQualityArmourMinQuality = 1;
      }
    }

    if (existingFilter.hideGearByRarity === undefined) {
      // Set defaults
      existingFilter.hideGearByRarity = true;
      existingFilter.hideGearOfRarity = Rarity.Normal;
      existingFilter.hideGearByBaseTypeTier = false;
      existingFilter.hideGearOfBaseTypeTier = BaseTypeTier.Basic;
      existingFilter.hideGearByItemLevel = false;
      existingFilter.hideGearBelowItemLevel = 81;

      if (existingFilter.hideNormalAndMagicItems) {
        existingFilter.hideGearByRarity = true;
        if ((existingFilter.hideNormalAndMagicItemsOfRarity as any) == 'Normal') {
          existingFilter.hideGearOfRarity = Rarity.Normal;
        } else if ((existingFilter.hideNormalAndMagicItemsOfRarity as any) == 'NormalAndMagic') {
          existingFilter.hideGearOfRarity = Rarity.Magic;
        } else if ((existingFilter.hideNormalAndMagicItemsOfRarity as any) == 'NormalMagicRareBelowAdvanced') {
          existingFilter.hideGearOfRarity = Rarity.Magic;
          existingFilter.hideGearByBaseTypeTier = true;
          existingFilter.hideGearOfBaseTypeTier = BaseTypeTier.Basic
        } else if ((existingFilter.hideNormalAndMagicItemsOfRarity as any) == 'NormalMagicRareBelowExpert') {
          existingFilter.hideGearOfRarity = Rarity.Magic;
          existingFilter.hideGearByBaseTypeTier = true;
          existingFilter.hideGearOfBaseTypeTier = BaseTypeTier.Advanced
        } else { // NormalMagicRare
          existingFilter.hideGearOfRarity = Rarity.Rare;
          existingFilter.hideGearByBaseTypeTier = true;
          existingFilter.hideGearOfBaseTypeTier = BaseTypeTier.Advanced
        }
      }
    }

    // Migrate Weapon & Armour base tier type

    filter.weaponFilters.forEach((weaponFilter) => {
      const existingBaseTypeTier = weaponFilter.baseTypeTier as string;
      if (existingBaseTypeTier === 'ExpertOnly' || existingBaseTypeTier === 'AdvancedAndExpert' || existingBaseTypeTier === 'All') {
        weaponFilter.baseTypeTier = existingBaseTypeTier === 'ExpertOnly' ? BaseTypeTier.Expert :
          existingBaseTypeTier === 'AdvancedAndExpert' ? BaseTypeTier.Advanced : BaseTypeTier.Basic;
      }
    });

    filter.armourFilters.forEach((armourFilter) => {
      const existingBaseTypeTier = armourFilter.baseTypeTier as string;
      if (existingBaseTypeTier === 'ExpertOnly' || existingBaseTypeTier === 'AdvancedAndExpert' || existingBaseTypeTier === 'All') {
        armourFilter.baseTypeTier = existingBaseTypeTier === 'ExpertOnly' ? BaseTypeTier.Expert :
          existingBaseTypeTier === 'AdvancedAndExpert' ? BaseTypeTier.Advanced : BaseTypeTier.Basic;
      }
    });

    // New Highlights

    if (existingFilter.highlightTrialItems === undefined) {
      existingFilter.highlightTrialItems = true;
    }
    if (existingFilter.highlightBreachRings === undefined) {
      existingFilter.highlightBreachRings = true;
      existingFilter.highlightBreachRingsRarity = Rarity.Normal;
    }
    if (existingFilter.highlightJewels === undefined) {
      existingFilter.highlightJewels = true;
      existingFilter.highlightJewelsRarity = Rarity.Normal;
    }

    // Switch to strings for all sounds

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if (r.cosmeticOptions?.alertSoundSound) {
        r.cosmeticOptions!.alertSoundSound = r.cosmeticOptions!.alertSoundSound.toString();
      }
    });

    filter.tierCosmetics.forEach((t: any) => {
      if (t.options?.alertSoundSound) {
        t.options!.alertSoundSound = t.options!.alertSoundSound.toString();
      }
    });

    // Set the comparator for all weapon and armour exceptions

    filter.weaponFilters.forEach((w: any) => {
      if (w.rarityComparator === undefined) {
        w.rarityComparator = Comparator.GreaterThanOrEqual;
      }
    });

    filter.armourFilters.forEach((a: any) => {
      if (a.rarityComparator === undefined) {
        a.rarityComparator = Comparator.GreaterThanOrEqual;
      }
    });

    // Migrate highlightRareWeaponAndArmourExceptions

    if (existingFilter.highlightRareWeaponAndArmourExceptions === undefined) {
      existingFilter.highlightRareWeaponAndArmourExceptions = true;
    }

    // Migrate joining beam and icon color into highlight

    existingFilter.customCosmeticRules.filter((c: any) => c.cosmeticOptions).forEach((r: any) => {
      this.migrateHighlight(r.cosmeticOptions!);
    });

    filter.tierCosmetics.forEach((t: any) => {
      this.migrateHighlight(t.options!);
    });

    // Add S+ Tier

    let spTier = filter.tierCosmetics.find(t => t.tier as any === 'P') as any;
    if (!spTier) {
      // Increment the 'order' of each of the existing tiers
      filter.tierCosmetics.forEach(t => t.order++);

      spTier = this.createInitialDefaultSPTier();
      filter.tierCosmetics.unshift(spTier);

      // Copy the S-Tier cosmetics to the S+ Tier
      const sTier = filter.tierCosmetics.find(t => t.tier === Tier.SPurple) as any;
      if (sTier) {
        spTier!.options = structuredClone(sTier!.options);

        if (sTier.options?.highlightColor === Color.Purple) {
          sTier.options!.highlightColor = Color.Red;
        }
      }
    }

    // Move quick cosmetic rules to tier cosmetics

    if (existingFilter.cosmeticTopCurrencyLabels) {
      const topCurrencyTiers = filter.tierCosmetics.filter(t => t.tier as any === 'P' || t.tier === Tier.SPurple || t.tier === Tier.ARed);
      for (let topCurrencyTier of topCurrencyTiers) {
        if (existingFilter.cosmeticTopCurrencyLabelsPurpleSize !== undefined && existingFilter.cosmeticTopCurrencyLabelsPurpleSize !== null) {
          if ((topCurrencyTier as any).options?.fontSize === null) {
            (topCurrencyTier as any).options!.fontSize = existingFilter.cosmeticTopCurrencyLabelsPurpleSize;
          }
        }
      }

      const secondCurrencyTiers = filter.tierCosmetics.filter(t => t.tier === Tier.BOrange || t.tier === Tier.CYellow);
      for (let secondCurrencyTier of secondCurrencyTiers) {
        if (existingFilter.cosmeticTopCurrencyLabelsBrownSize !== undefined && existingFilter.cosmeticTopCurrencyLabelsBrownSize !== null) {
          if ((secondCurrencyTier as any).options?.fontSize === null) {
            (secondCurrencyTier as any).options!.fontSize = existingFilter.cosmeticTopCurrencyLabelsBrownSize;
          }
        }
      }
    }

    // Same for sounds

    if (existingFilter.cosmeticTopCurrencyAlertSounds) {
      const topCurrencyTiers = filter.tierCosmetics.filter(t => t.tier as any === 'P' || t.tier === Tier.SPurple || t.tier === Tier.ARed);
      for (let topCurrencyTier of topCurrencyTiers) {
        if (existingFilter.cosmeticTopCurrencyAlertSoundPurpleSound !== undefined && existingFilter.cosmeticTopCurrencyAlertSoundPurpleSound !== null) {
          if (!(topCurrencyTier as any).options?.alertSound) {
            (topCurrencyTier as any).options!.alertSound = true;
            (topCurrencyTier as any).options!.alertSoundSound = existingFilter.cosmeticTopCurrencyAlertSoundPurpleSound.toString();
            (topCurrencyTier as any).options!.alertSoundVolume = existingFilter.cosmeticTopCurrencyAlertSoundPurpleVolume;
          }
        }
      }

      const secondCurrencyTiers = filter.tierCosmetics.filter(t => t.tier === Tier.BOrange || t.tier === Tier.CYellow);
      for (let secondCurrencyTier of secondCurrencyTiers) {
        if (existingFilter.cosmeticTopCurrencyAlertSoundBrownSound !== undefined && existingFilter.cosmeticTopCurrencyAlertSoundBrownSound !== null) {
          if (!(secondCurrencyTier as any).options?.alertSound) {
            (secondCurrencyTier as any).options!.alertSound = true;
            (secondCurrencyTier as any).options!.alertSoundSound = existingFilter.cosmeticTopCurrencyAlertSoundBrownSound.toString();
            (secondCurrencyTier as any).options!.alertSoundVolume = existingFilter.cosmeticTopCurrencyAlertSoundBrownVolume;
          }
        }
      }
    }

    // Delete old properties

    delete existingFilter.cosmeticTopCurrencyLabels;
    delete existingFilter.cosmeticTopCurrencyLabelsPurpleSize;
    delete existingFilter.cosmeticTopCurrencyLabelsBrownSize;
    delete existingFilter.cosmeticTopCurrencyAlertSounds;
    delete existingFilter.cosmeticTopCurrencyAlertSoundPurpleSound;
    delete existingFilter.cosmeticTopCurrencyAlertSoundPurpleVolume;
    delete existingFilter.cosmeticTopCurrencyAlertSoundBrownSound;
    delete existingFilter.cosmeticTopCurrencyAlertSoundBrownVolume;

    // Migrate cosmeticRemoveAllHighlights and cosmeticRemoveAllMinimapIcons

    if (existingFilter.cosmeticRemoveAllHighlights) {
      filter.tierCosmetics.forEach(t => (t as any).options!.beam = false);
    }

    if (existingFilter.cosmeticRemoveAllMinimapIcons && existingFilter.cosmeticRemoveAllHighlights) {
      filter.tierCosmetics.forEach(t => (t as any).options!.highlight = false);
    }

    delete existingFilter.cosmeticRemoveAllHighlights;
    delete existingFilter.cosmeticRemoveAllMinimapIcons;

    // Armour defence type migration: should now be an array. Also, the string values of the enum have changed:

    filter.armourFilters.forEach(a => {
      // If it's not an array, convert it to an array
      if (!Array.isArray(a.defenceType)) {
        // Using the old/new values mentioned before, translate the old string value to the new one
        if ((a as any).defenceType === 'All') {
          a.defenceType = [DefenceType.All];
        } else if ((a as any).defenceType === 'Armour') {
          a.defenceType = [DefenceType.Armour];
        } else if ((a as any).defenceType === 'Evasion') {
          a.defenceType = [DefenceType.Evasion];
        } else if ((a as any).defenceType === 'EnergyShield') {
          a.defenceType = [DefenceType.EnergyShield];
        } else if ((a as any).defenceType === 'ArmourEvasion') {
          a.defenceType = [DefenceType.ArmourEvasion];
        } else if ((a as any).defenceType === 'ArmourEnergyShield') {
          a.defenceType = [DefenceType.ArmourEnergyShield];
        } else if ((a as any).defenceType === 'EvasionEnergyShield') {
          a.defenceType = [DefenceType.EvasionEnergyShield];
        }
      }
    });

    // New Highlights

    if (existingFilter.highlightEndgameFragments === undefined) {
      existingFilter.highlightEndgameFragments = true;
    }

    // Remove 'active' from all advanced custom (cosmetic) rules' advanced conditions

    existingFilter.customCosmeticRules.forEach((r: any) => {
      if (r.advancedConditions) {
        delete r.advancedConditions.active;
      }
    });

    if (existingFilter.customTierCosmetics === undefined) {
      existingFilter.customTierCosmetics = [];
    }

    filter.tierCosmetics.forEach(t => {
      if ((t as any).active === undefined) (t as any).active = true;
      if ((t as any).continue === undefined) (t as any).continue = false;
    });

    // DisplayType enum no longer exists; migrate to new DisplayType values, being Tier

    existingFilter.customRules.forEach((r: any) => {
      r.displayType = r.displayType === 'Hide' ? Tier.FHidden :
        r.displayType === 'Show' ? Tier.EVisible :
          r.displayType === 'White' ? Tier.DWhite :
            r.displayType === 'Yellow' ? Tier.CYellow :
              r.displayType === 'Orange' ? Tier.BOrange :
                r.displayType === 'Brown' ? Tier.ARed :
                  r.displayType === 'Red' ? Tier.SPurple :
                    r.displayType === 'Purple' ? 'P' :
                      r.displayType;
    });

    // Migrate unique highlights

    if (existingFilter.highlightUniques) {
      if (existingFilter.highlightUniquesType === 'All') {
        existingFilter.highlightExcellentUniques = true;
        existingFilter.highlightExcellentUniquesTier = Tier.ARed;
        existingFilter.highlightGoodUniques = true;
        existingFilter.highlightGoodUniquesTier = Tier.ARed;
        existingFilter.highlightOtherUniques = true;
        existingFilter.highlightOtherUniquesTier = Tier.ARed;
      } else if (existingFilter.highlightUniquesType === 'GoodOnly') {
        existingFilter.highlightExcellentUniques = true;
        existingFilter.highlightExcellentUniquesTier = Tier.ARed;
        existingFilter.highlightGoodUniques = true;
        existingFilter.highlightGoodUniquesTier = Tier.ARed;
        existingFilter.highlightOtherUniques = false;
      } else if (existingFilter.highlightUniquesType === 'TopTierOnly') {
        existingFilter.highlightExcellentUniques = true;
        existingFilter.highlightExcellentUniquesTier = Tier.ARed;
        existingFilter.highlightGoodUniques = false;
        existingFilter.highlightOtherUniques = false;
      }

      delete existingFilter.highlightUniques;
      delete existingFilter.highlightUniquesType;
    }

    // Migrate chance base highlights

    if (existingFilter.highlightChanceBases) {
      if (existingFilter.highlightChanceBasesType === 'Highlight excellent, show good') {
        existingFilter.highlightExcellentChanceBases = true;
        existingFilter.highlightExcellentChanceBasesTier = Tier.ARed;
        existingFilter.highlightGoodChanceBases = true;
        existingFilter.highlightGoodChanceBasesTier = Tier.EVisible;
      } else if (existingFilter.highlightChanceBasesType === 'Highlight excellent only') {
        existingFilter.highlightExcellentChanceBases = true;
        existingFilter.highlightExcellentChanceBasesTier = Tier.ARed;
        existingFilter.highlightGoodChanceBases = false;
        existingFilter.highlightGoodChanceBasesTier = Tier.EVisible;
      } else if (existingFilter.highlightChanceBasesType === 'Show excellent only') {
        existingFilter.highlightExcellentChanceBases = true;
        existingFilter.highlightExcellentChanceBasesTier = Tier.EVisible;
        existingFilter.highlightGoodChanceBases = false;
        existingFilter.highlightGoodChanceBasesTier = Tier.EVisible;
      }

      delete existingFilter.highlightChanceBases;
      delete existingFilter.highlightChanceBasesType;
    }

    if (!existingFilter.highlightRareJewelleryTier) existingFilter.highlightRareJewelleryTier = Tier.CYellow;
    if (!existingFilter.highlightRareWeaponAndArmourExceptionsTier) existingFilter.highlightRareWeaponAndArmourExceptionsTier = Tier.CYellow;
    if (!existingFilter.highlightOtherWeaponAndArmourExceptionsTier) existingFilter.highlightOtherWeaponAndArmourExceptionsTier = Tier.DWhite;
    if (existingFilter.highlightOtherWeaponAndArmourExceptions === undefined) existingFilter.highlightOtherWeaponAndArmourExceptions = false;
    if (!existingFilter.highlightJewelsTypes) existingFilter.highlightJewelsTypes = ['All'];
    if (!existingFilter.highlightJewelsTier) existingFilter.highlightJewelsTier = Tier.CYellow;
    if (!existingFilter.highlightRareBreachRingsTier) existingFilter.highlightRareBreachRingsTier = Tier.CYellow;
    if (!existingFilter.highlightOtherBreachRingsTier) existingFilter.highlightOtherBreachRingsTier = Tier.DWhite;
    if (!existingFilter.highlightTrialItemsRelicsTier) existingFilter.highlightTrialItemsRelicsTier = Tier.DWhite;
    if (!existingFilter.highlightEndgameFragmentsTier) existingFilter.highlightEndgameFragmentsTier = 'P';

    if (existingFilter.highlightRareBreachRings === undefined) {
      if (existingFilter.highlightBreachRings) {
        if (existingFilter.highlightBreachRingsRarity === 'Normal') {
          existingFilter.highlightRareBreachRings = true;
          existingFilter.highlightOtherBreachRings = true;
        } else {
          existingFilter.highlightRareBreachRings = true;
          existingFilter.highlightOtherBreachRings = false;
        }
      } else {
        existingFilter.highlightRareBreachRings = false;
        existingFilter.highlightOtherBreachRings = false;
      }

      delete existingFilter.highlightBreachRings;
      delete existingFilter.highlightBreachRingsRarity;
    }

    // Set 'show' on all custom rules unless they have tier 'FHidden'

    existingFilter.customRules.filter((r: any) => r.show === undefined).forEach((r: any) => {
      if (r.displayType !== Tier.FHidden) {
        r.show = true;
      }
    });
  }

  private migrateHighlight(o: CosmeticOptions) {
    const existingOptions = o as any;
    if (existingOptions.minimapIcon || existingOptions.playEffect && !o.highlight) {
      o.highlight = true;
      o.highlightColor = existingOptions.minimapIconColor || existingOptions.playEffectColor;
      if (existingOptions.playEffect) o.beam = true;
      if (existingOptions.playEffectTemp) o.temp = true;

      delete existingOptions.minimapIcon;
      delete existingOptions.minimapIconColor;
      delete existingOptions.playEffect;
      delete existingOptions.playEffectColor;
      delete existingOptions.playEffectTemp;
    }
  }

  createInitialCosmeticOptions() {
    return {
      minimapIcon: false,
      minimapIconSize: MinimapIconSize.Small,
      minimapIconColor: Color.White,
      minimapIconShape: MinimapIconShape.Circle,

      playEffect: false,
      playEffectColor: Color.White,
      playEffectTemp: false,

      backgroundColor: null,
      borderColor: null,
      textColor: null,
      fontSize: null,

      alertSound: false,
      alertSoundSound: 2,
      alertSoundVolume: 200,
      disableDropSound: false,

      // Currently unused
      alertSoundPositional: false,
      enableDropSound: false,
      disableDropSoundIfAlertSound: false,
      enableDropSoundIfAlertSound: false,
      customAlertSound: null,
    } as any;
  }

  createInitialSPCosmeticOptions() {
    return {
      highlight: false,
      highlightColor: Color.White,

      minimapIconSize: MinimapIconSize.Small,
      minimapIconShape: MinimapIconShape.Circle,
      beam: true,
      temp: false,

      backgroundColor: null,
      borderColor: null,
      textColor: null,
      fontSize: null,

      alertSound: false,
      alertSoundSound: '2',
      alertSoundVolume: 200,
      disableDropSound: false,
      customAlertSound: null,

      // Currently unused
      alertSoundPositional: false,
      enableDropSound: false,
      disableDropSoundIfAlertSound: false,
      enableDropSoundIfAlertSound: false,
    }
  }

  createInitialDefaultTierCosmetics() {
    const defaultTierCosmetics: any[] = [];

    const sTier = {} as any;
    sTier.order = 0;
    sTier.tier = 'S';
    sTier.name = 'Purple';
    sTier.label = '> 100 ex';
    sTier.options = this.createInitialCosmeticOptions();
    sTier.options.playEffect = true;
    sTier.options.playEffectColor = Color.Purple;
    sTier.options.minimapIcon = true;
    sTier.options.minimapIconColor = Color.Purple;
    sTier.options.minimapIconSize = MinimapIconSize.Large;
    defaultTierCosmetics.push(sTier);

    const aTier = {} as any;
    aTier.order = 1;
    aTier.tier = Tier.ARed;
    aTier.name = 'Brown';
    aTier.label = '> 20 ex';
    aTier.options = this.createInitialCosmeticOptions();
    aTier.options.playEffect = true;
    aTier.options.playEffectColor = Color.Brown;
    aTier.options.minimapIcon = true;
    aTier.options.minimapIconColor = Color.Brown;
    aTier.options.minimapIconSize = MinimapIconSize.Medium;
    defaultTierCosmetics.push(aTier);

    const bTier = {} as any;
    bTier.order = 2;
    bTier.tier = Tier.BOrange;
    bTier.name = 'Orange';
    bTier.label = '> 3 ex';
    bTier.options = this.createInitialCosmeticOptions();
    bTier.options.playEffect = true;
    bTier.options.playEffectColor = Color.Orange;
    bTier.options.minimapIcon = true;
    bTier.options.minimapIconColor = Color.Orange;
    defaultTierCosmetics.push(bTier);

    const cTier = {} as any;
    cTier.order = 3;
    cTier.tier = Tier.CYellow;
    cTier.name = 'Yellow';
    cTier.label = '~ 1 ex';
    cTier.options = this.createInitialCosmeticOptions();
    cTier.options.playEffect = true;
    cTier.options.playEffectColor = Color.Yellow;
    cTier.options.minimapIcon = true;
    cTier.options.minimapIconColor = Color.Yellow;
    defaultTierCosmetics.push(cTier);

    const dTier = {} as any;
    dTier.order = 4;
    dTier.tier = Tier.DWhite;
    dTier.name = 'White';
    dTier.label = '< 0.5 ex';
    dTier.options = this.createInitialCosmeticOptions();
    dTier.options.playEffect = true;
    dTier.options.playEffectColor = Color.White;
    dTier.options.minimapIcon = true;
    dTier.options.minimapIconColor = Color.White;
    defaultTierCosmetics.push(dTier);

    const eTier = {} as any;
    eTier.order = 5;
    eTier.tier = Tier.EVisible;
    eTier.name = 'Shown';
    eTier.label = '< 0.1 ex';
    eTier.options = this.createInitialCosmeticOptions();
    defaultTierCosmetics.push(eTier);

    const fTier = {} as any;
    fTier.order = 6;
    fTier.tier = Tier.FHidden;
    fTier.name = 'Hidden';
    fTier.label = '< 0.01 ex';
    fTier.show = false;
    fTier.options = this.createInitialCosmeticOptions();
    defaultTierCosmetics.push(fTier);

    return defaultTierCosmetics;
  }

  createInitialDefaultSPTier() {
    const spTier = {} as any;
    spTier.order = 0;
    spTier.tier = 'P';
    spTier.name = 'Purple';
    spTier.label = '> 500 ex';
    spTier.options = this.createInitialSPCosmeticOptions()
    spTier.options.highlight = true;
    spTier.options.highlightColor = Color.Purple;
    spTier.options.minimapIconSize = MinimapIconSize.Large;
    spTier.options.alertSound = true;
    spTier.options.alertSoundSound = '6';
    spTier.options.alertSoundVolume = 300;
    return spTier;
  }

  private migrateRemoveItemsFromCustomGear(filter: Filter, baseTypes: string[]) {
    filter.customGearTiers = filter.customGearTiers.filter((t: CustomTieredGear) => !baseTypes.includes(t.baseType));
  }

  private migrateRemoveItemsFromCustomJewellery(filter: Filter, baseTypes: string[]) {
    if (!filter.customJewelleryTiers) {
      filter.customJewelleryTiers = [];
      return;
    }
    filter.customJewelleryTiers = filter.customJewelleryTiers.filter((t: CustomTieredJewellery) => !baseTypes.includes(t.baseType));
  }

  private migrateRemoveItemsFromCustomUnique(filter: Filter, baseTypes: string[]) {
    filter.customUniqueTiers = filter.customUniqueTiers.filter((t: CustomTieredUnique) => !baseTypes.includes(t.baseType));
  }

  private migrateRemoveItemsFromCustomChanceBase(filter: Filter, baseTypes: string[]) {
    filter.customChanceBaseTiers = filter.customChanceBaseTiers.filter((t: CustomTieredChanceBase) => !baseTypes.includes(t.baseType));
  }

  private migrateRemoveItemsFromCustomEquipment(filter: Filter, equipmentTypes: string[]) {
    filter.customEquipmentTiers = filter.customEquipmentTiers.filter((t: CustomTieredEquipment) => !equipmentTypes.includes(t.equipmentType));
  }

  private migrateRemoveCustomMods(filter: Filter, mods: string[]) {
    filter.customModTiers = filter.customModTiers.filter((c: TieredMod) => !mods.includes(c.name));
  }

  private migrateRemovedIdentifiedItemCategories(filter: Filter, categories: string[]) {
    filter.customModTiers = filter.customModTiers.filter((c: TieredMod) => !c.cat || !categories.includes(c.cat));
  }

  private usesLegacyFlatCustomRules(filter: Filter, cosmetic: boolean): boolean {
    const key = cosmetic ? 'customCosmeticRules' : 'customRules';
    return Object.prototype.hasOwnProperty.call(filter as any, key);
  }

  private legacyCustomRulesArray(filter: Filter, cosmetic: boolean): CustomRule[] {
    return cosmetic
      ? (((filter as any).customCosmeticRules ?? []) as CustomRule[])
      : (((filter as any).customRules ?? []) as CustomRule[]);
  }

  private groupedCustomRuleGroups(filter: Filter, cosmetic: boolean): CustomRuleGroup[] {
    return cosmetic ? (filter.customCosmeticRuleGroups ?? []) : (filter.customRuleGroups ?? []);
  }

  private listCustomRulesMatching(filter: Filter, cosmetic: boolean, pred: (c: CustomRule) => boolean): CustomRule[] {
    if (this.usesLegacyFlatCustomRules(filter, cosmetic)) {
      return this.legacyCustomRulesArray(filter, cosmetic).filter(pred);
    }
    const out: CustomRule[] = [];
    for (const g of this.groupedCustomRuleGroups(filter, cosmetic)) {
      for (const c of g.rules) {
        if (pred(c)) out.push(c);
      }
    }
    return out;
  }

  private eachMatchingCustomRule(filter: Filter, cosmetic: boolean, pred: (c: CustomRule) => boolean, fn: (rule: CustomRule) => void): void {
    this.listCustomRulesMatching(filter, cosmetic, pred).forEach(fn);
  }

  private removeCustomRuleFromStorage(filter: Filter, cosmetic: boolean, rule: CustomRule): void {
    if (this.usesLegacyFlatCustomRules(filter, cosmetic)) {
      const arr = this.legacyCustomRulesArray(filter, cosmetic);
      const idx = arr.indexOf(rule);
      if (idx >= 0) arr.splice(idx, 1);
      return;
    }
    for (const g of this.groupedCustomRuleGroups(filter, cosmetic)) {
      const idx = g.rules.indexOf(rule);
      if (idx >= 0) {
        g.rules.splice(idx, 1);
        return;
      }
    }
  }

  private filterOutRulesByItemType(filter: Filter, cosmetic: boolean, itemType: string): void {
    if (this.usesLegacyFlatCustomRules(filter, cosmetic)) {
      const any = filter as any;
      const next = this.legacyCustomRulesArray(filter, cosmetic).filter((c: CustomRule) => c.itemType !== itemType);
      if (cosmetic) any.customCosmeticRules = next;
      else any.customRules = next;
      return;
    }
    for (const g of this.groupedCustomRuleGroups(filter, cosmetic)) {
      g.rules = g.rules.filter((c: CustomRule) => c.itemType !== itemType);
    }
  }

  private migrateRenamedCurrency(filter: Filter, renames: { type: string; baseTypes: { old: string; new: string }[] }[]) {
    renames.forEach(currency => {
      for (const cosmetic of [false, true]) {
        this.eachMatchingCustomRule(filter, cosmetic, c => c.itemType === currency.type, rule => {
          rule.baseTypes = rule.baseTypes.map((baseType: string) => currency.baseTypes.find(b => b.old === baseType)?.new || baseType);
        });
      }

      filter.customCurrencyTiers = filter.customCurrencyTiers.map((tier: CustomTieredItem) => {
        tier.name = currency.baseTypes.find(b => b.old === tier.name)?.new || tier.name;
        return tier;
      });
    });
  }

  private migrateRenamedGearBaseTypes(filter: Filter, renames: { itemType: string; baseTypes: { old: string; new: string }[] }[]) {
    renames.forEach(rename => {
      for (const cosmetic of [false, true]) {
        this.eachMatchingCustomRule(filter, cosmetic, c => c.itemType === rename.itemType, rule => {
          rule.baseTypes = rule.baseTypes.map((baseType: string) => rename.baseTypes.find(b => b.old === baseType)?.new || baseType);
        });
      }

      filter.customGearTiers = filter.customGearTiers.map((tier: CustomTieredGear) => {
        tier.baseType = rename.baseTypes.find(b => b.old === tier.baseType)?.new || tier.baseType;
        return tier;
      });
    });
  }

  private migrateRemovedCurrency(filter: Filter, removals: { type: string; baseTypes: string[] }[]) {
    removals.forEach(currency => {
      filter.customCurrencyTiers = filter.customCurrencyTiers.filter((tier: CustomTieredItem) => !currency.baseTypes.includes(tier.name));
    });
    this.migrateRemovedItemsFromCustomRules(filter, removals);
  }

  private migrateRenamedCurrencyClasses(filter: Filter, renames: { oldClass: string; newClass: string; }[]) {
    renames.forEach(currency => {
      for (const cosmetic of [false, true]) {
        this.eachMatchingCustomRule(filter, cosmetic, c => c.itemClass === currency.oldClass, rule => {
          rule.itemClass = currency.newClass;
        });
      }
    });
  }

  private migrateRenamedCurrencyTypes(filter: Filter, renames: { oldType: string; newType: string; }[]) {
    renames.forEach(currency => {
      for (const cosmetic of [false, true]) {
        this.eachMatchingCustomRule(filter, cosmetic, c => c.itemType === currency.oldType, rule => {
          rule.itemType = currency.newType;
        });
      }
    });
  }

  private migrateRemovedItemTypes(filter: Filter, removals: string[]) {
    removals.forEach(removal => {
      for (const cosmetic of [false, true]) {
        this.filterOutRulesByItemType(filter, cosmetic, removal);
      }
    });
  }

  private migrateRemovedGear(filter: Filter, removals: { type: string; baseTypes: string[] }[]) {
    removals.forEach(removal => {
      filter.customGearTiers = filter.customGearTiers.filter(tier => !removal.baseTypes.includes(tier.baseType));
    });

    this.migrateRemovedItemsFromCustomRules(filter, removals);
  }

  private migrateRemovedItemsFromCustomRules(filter: Filter, removals: { type: string; baseTypes: string[] }[]) {
    removals.forEach(removal => {
      for (const cosmetic of [false, true]) {
        const rulesForType = this.listCustomRulesMatching(filter, cosmetic, c => c.itemType === removal.type);
        rulesForType.forEach((rule: CustomRule) => {
          rule.baseTypes = rule.baseTypes.filter((baseType: string) => !removal.baseTypes.includes(baseType));
          if (rule.baseTypes.length === 0) {
            this.removeCustomRuleFromStorage(filter, cosmetic, rule);
          }
        });
      }
    });
  }

  private migrateRemovedEquipmentTypes(filter: Filter, removals: string[]) {
    filter.customEquipmentTiers = filter.customEquipmentTiers.filter((t: CustomTieredEquipment) => !removals.includes(t.equipmentType));
  }

  /**
   * Only use this if *all* (or all expensive) uniques of this base type are removed.
   */
  private dangerouslyMigrateRemovedUniquesBySpecialBaseType(filter: Filter, removedBaseTypes: string[]) {
    filter.customUniqueTiers = filter.customUniqueTiers.filter((u: CustomTieredUnique) => !removedBaseTypes.includes(u.baseType));
    this.dangerouslyMigrateRemovedChanceBaseTypes(filter, removedBaseTypes);
  }

  private dangerouslyMigrateRemovedChanceBaseTypes(filter: Filter, removedBaseTypes: string[]) {
    filter.customChanceBaseTiers = filter.customChanceBaseTiers.filter((c: CustomTieredChanceBase) => !removedBaseTypes.includes(c.baseType));
  }

  private migrateAddMyJewelleryBaseTypes(filter: Filter, jewelleryType: JewelleryType, baseTypes: string[]) {
    const typeFilters = filter.jewelleryFilters.filter(j => j.jewelleryType === jewelleryType);
    const presetFilter = typeFilters.find(j => j.fromProgressPreset);
    if (presetFilter) {
      presetFilter.jewelleryBaseTypes.push(...baseTypes);
    } else {
      filter.jewelleryFilters.push(new JewelleryFilter({
        fromProgressPreset: true,
        jewelleryType,
        jewelleryBaseTypes: baseTypes,
      }));
    }
  }

  private migrateRemoveJewellery(filter: Filter, jewelleryType: JewelleryType, baseTypes: string[]) {
    filter.jewelleryFilters.forEach(j => {
      if (j.jewelleryType === jewelleryType) {
        j.jewelleryBaseTypes = j.jewelleryBaseTypes.filter(bt => !baseTypes.includes(bt));
      }
    });
    filter.jewelleryFilters = filter.jewelleryFilters.filter(j => j.jewelleryType !== jewelleryType || j.jewelleryBaseTypes.length > 0);
    this.migrateRemoveItemsFromCustomJewellery(filter, baseTypes);
  }
}

class InitialDisplayOptions {
  constructor(init?: Partial<InitialDisplayOptions>) {
    if (init) Object.assign(this, init);

    if (init?.cosmeticOptions) {
      this.cosmeticOptions = new CosmeticOptions({ ...init?.cosmeticOptions });
    }
  }

  active? = true;
  hidden? = false;

  displayType?: DisplayType;

  displayTypeTier?: Tier;
  displayTypeTierHighlightType?: EquipmentTierType;

  cosmeticOptions?: CosmeticOptions;
}

export class Initial86CustomRule {
  order: number = 0;
  itemClass: string = 'All';
  filterItemClass?: string = undefined;
  itemType: string = 'All';
  baseTypes: string[] = ['All'];
  rarityComparator: Comparator = Comparator.GreaterThanOrEqual;
  rarity: Rarity = Rarity.Normal;
  advancedConditions?: AdvancedConditions;
  continue = false;

  displayOptions: InitialDisplayOptions = new InitialDisplayOptions();
}
